// Translation resources
const translationResources = {
    navbar: {
        en: {
            getStarted: "Get Started",
            howitWorks: "How it Works",
            holidaysDashboard: "Holiday Dashboard",
            closingLounge: "Closing Lounge",
            cruisingPower: "Cruising Power",
            account: "Account",
            holidaySuitcase: "Holiday Suitcase",
            clubRoyal: "Club Royal",
            clubRoyalUrl: "https://www.myclubroyal.co.uk/",
            suitcase: "Suitcase",
            royalBridge: "Royal Bridge",
        },
        es: {
            getStarted: "Inicio",
            howitWorks: "Cómo funciona",
            holidaysDashboard: "Pantalla principal",
            closingLounge: "Cierra la venta",
            cruisingPower: "Poder de Crucero",
            account: "Cuenta",
            holidaySuitcase: "Maleta Vacaciones",
            clubRoyal: "Club Royal",
            clubRoyalUrl: "https://miclubroyal.es/",
            suitcase: "Maleta",
            royalBridge: "Royal Bridge",
        },
        nordics: {
            getStarted: "Get Started",
            howitWorks: "How it Works",
            holidaysDashboard: "Holiday Dashboard",
            closingLounge: "Closing Lounge",
            cruisingPower: "Cruising Power",
            account: "Account",
            holidaySuitcase: "Holiday Suitcase",
            clubRoyal: "Club Royal",
            clubRoyalUrl: "https://www.myclubroyal.co.uk/",
            suitcase: "Suitcase",
            royalBridge: "Royal Bridge",
        },
    },
    footer: {
        en: {
            contactUs: "Contact Us",
            termsAndCondition: "Terms & Conditions",
            privacyPolicy: "Privacy Policy",
            privacyPolicyUrl: "https://www.myclubroyal.co.uk/#/privacy",
            cookieInfo: "Cookie Info",
            cookieInfoUrl: "https://www.myclubroyal.co.uk/#/cookie",
            textRoyalCaribbeanInternational: "Royal Caribbean International",
            textSupport: "Support",
            textEmail: "Email",
            textPhone: "Phone",
            textQuickLinks: "Quick Links",
            termsOfService: "Terms of Service",
            dataLastUpdated: "Data last updated:",
            textDisclaimer:
                "Disclaimer: Health and safety protocols, guest conduct rules, and regional travel restrictions vary by ship and destination, and are subject to change. Due to evolving health protocols, imagery and messaging may not accurately reflect onboard and destination experiences, offerings, features, or itineraries. These may not be available during your voyage, may vary by ship and destination, and may be subject to change. Please check our website or consult your travel agent before booking.",
        },
        nordics: {
            contactUs: "Contact Us",
            termsAndCondition: "Terms & Conditions",
            privacyPolicy: "Privacy Policy",
            privacyPolicyUrl: "https://www.myclubroyal.co.uk/#/privacy",
            cookieInfo: "Cookie Info",
            cookieInfoUrl: "https://www.myclubroyal.co.uk/#/cookie",
            textRoyalCaribbeanInternational: "Royal Caribbean International",
            textSupport: "Support",
            textEmail: "Email",
            textPhone: "Phone",
            textQuickLinks: "Quick Links",
            termsOfService: "Terms of Service",
            dataLastUpdated: "Data last updated:",
            textDisclaimer:
                "Disclaimer: Health and safety protocols, guest conduct rules, and regional travel restrictions vary by ship and destination, and are subject to change. Due to evolving health protocols, imagery and messaging may not accurately reflect onboard and destination experiences, offerings, features, or itineraries. These may not be available during your voyage, may vary by ship and destination, and may be subject to change. Please check our website or consult your travel agent before booking.",
        },
        es: {
            contactUs: "Contacta con nosotros",
            termsAndCondition: "Términos y Condiciones",
            privacyPolicy: "Política de Privacidad",
            privacyPolicyUrl: "https://www.royalcaribbean.com/esp/es/resources/privacy-policy",
            cookieInfo: "Información sobre cookies",
            cookieInfoUrl: "https://miclubroyal.es/#/cookie",
            textRoyalCaribbeanInternational: "Royal Caribbean International",
            textSupport: "Soporte",
            textEmail: "Correo electrónico",
            textPhone: "Teléfono",
            textQuickLinks: "Enlaces rápidos",
            termsOfService: "Términos de servicio",
            dataLastUpdated: "Datos actualizados por última vez:",
            textDisclaimer:
                "Descargo de responsabilidad: los protocolos de salud y seguridad, las normas de conducta de los clientes, y las restricciones de viaje regionales pueden variar según el barco y el destino y están sujetas a posibles cambios. Debido a protocolos de salud en proceso, las imágenes y los textos podrían no reflejar con exactitud los itinerarios, las experiencias, ofertas, o características  a bordo. Puede que no estén disponibles en el momento del viaje, puede que varíen según el barco y el destino, y pueden estar sujetas a cambios. Es importante comprobarlo en nuestra página web o consultar con el agente de viajes antes de reservar.",
        },
    },
    royalBridgeNavBar: {
        en: {
            home: "Home",
            commercialPerformance: "Sales Performance",
            pipeline: "Pipeline",
            accountCommunication: "Account Communication",
            agentEngagement: "Agent Engagement",
            plansAndTargets: "Plans and Goals",
            activation: "Activation",
            activationKam: "Activation (KAM)",
            logout: "Logout",
        },
        nordics: {
            home: "Home",
            commercialPerformance: "Sales Performance",
            pipeline: "Pipeline",
            accountCommunication: "Account Communication",
            agentEngagement: "Agent Engagement",
            plansAndTargets: "Plans and Goals",
            activation: "Activation",
            activationKam: "Activation (KAM)",
            logout: "Logout",
        },
        es: {
            home: "Inicio",
            commercialPerformance: "Rendimiento comercial",
            pipeline: "Pipeline",
            accountCommunication: "Comunicación de cuenta",
            agentEngagement: "Compromiso del agente",
            plansAndTargets: "Planes y objetivos",
            activation: "Activación",
            activationKam: "Activación (KAM)",
            logout: "Cerrar sesión",
        },
    },
    logoutConfirmation: {
        en: {
            title: "Log Out",
            text: "Are you sure you want to log out?",
            cancel: "Cancel",
            confirm: "Yes, Log Out",
        },
        nordics: {
            title: "Log Out",
            text: "Are you sure you want to log out?",
            cancel: "Cancel",
            confirm: "Yes, Log Out",
        },
        es: {
            title: "Cerrar Sesión",
            text: "¿Estás seguro de que quieres cerrar sesión?",
            cancel: "Cancelar",
            confirm: "Sí, Cerrar Sesión",
        },
    },
    suitcase: {
        en: {
            holidaySuitcase: "Holiday Suitcase",
            item: "Item",
            items: "Items",
            footerCaption: "To preview and send their personalised holidays:",
            buttonOpenSuitcase: "Go to Holiday Suitcase",
        },
        nordics: {
            holidaySuitcase: "Holiday Suitcase",
            item: "Item",
            items: "Items",
            footerCaption: "To preview and send their personalised holidays:",
            buttonOpenSuitcase: "Go to Holiday Suitcase",
        },
        es: {
            holidaySuitcase: "Maleta Vacaciones",
            item: "Elemento",
            items: "Elementos",
            footerCaption: "Para vista previa y para enviar sus vacaciones personalizadas:",
            buttonOpenSuitcase: "Ir a la Maleta de Vacaciones",
        },
    },
    tuiBeforeStart: {
        en: {
            titleBeforeStart: "BEFORE YOU GET STARTED",
            textCorrectDetails: "Please check that all your agency details are correct.",
            titleStoreName: "STORE NAME",
            titleStorePhoneNumber: "STORE PHONE NUMBER",
            titleStoreEmail: "STORE EMAIL",
            textEmailTo:
                "If the store details displayed are  incorrect , please continue using the application with your personal details and send anagency change email to",
            textMyClubRoyal:
                "If they aren’t correct, please log into My Club Royal and submit an agency change",
            buttonUsePersonalDetails: "USE MY PERSONAL DETAILS",
            buttonClubRoyal: "TAKE ME TO CLUB ROYAL",
            buttonDetailCorrect: "THESE DETAILS ARE CORRECT",
        },
        nordics: {
            titleBeforeStart: "BEFORE YOU GET STARTED",
            textCorrectDetails: "Please check that all your agency details are correct.",
            titleStoreName: "STORE NAME",
            titleStorePhoneNumber: "STORE PHONE NUMBER",
            titleStoreEmail: "STORE EMAIL",
            textEmailTo:
                "If the store details displayed are  incorrect , please continue using the application with your personal details and send anagency change email to",
            textMyClubRoyal:
                "If they aren’t correct, please log into My Club Royal and submit an agency change",
            buttonUsePersonalDetails: "USE MY PERSONAL DETAILS",
            buttonClubRoyal: "TAKE ME TO CLUB ROYAL",
            buttonDetailCorrect: "THESE DETAILS ARE CORRECT",
        },
        es: {
            titleBeforeStart: "ANTES DE COMENZAR",
            textCorrectDetails:
                "Por favor verifique que todos los datos de su agencia sean correctos.",
            titleStoreName: "NOMBRE DE LA TIENDA",
            titleStorePhoneNumber: "NÚMERO DE TELÉFONO DE LA TIENDA",
            titleStoreEmail: "CORREO ELECTRÓNICO DE LA TIENDA",
            textEmailTo:
                "Si los detalles de la tienda que se muestran son incorrectos, continúe usando la aplicación con sus datos personales y envíe un correo electrónico de cambio de agencia a",
            textMyClubRoyal:
                "Si no son correctos, inicie sesión en My Club Royal y envíe un cambio de agencia.",
            buttonUsePersonalDetails: "UTILIZAR MIS DATOS PERSONALES",
            buttonClubRoyal: "LLÉVAME AL CLUB ROYAL",
            buttonDetailCorrect: "ESTOS DETALLES SON CORRECTOS",
        },
    },
    countrySelector: {
        en: {
            textSelectCountry: "Please select your country",
            buttonSelectCountry: "Select Country",
            titleUnitedKingdom: "United Kingdom",
            titleIreland: "Ireland",
            titleNordics: "Nordics",
            titleMalta: "Malta",
            titleUAE: "UAE",
            titleSpain: "Spain",
            buttonPrevious: "Go Back",
        },
        nordics: {
            textSelectCountry: "Please select your country",
            buttonSelectCountry: "Select Country",
            titleUnitedKingdom: "United Kingdom",
            titleIreland: "Ireland",
            titleNordics: "Nordics",
            titleMalta: "Malta",
            titleUAE: "UAE",
            titleSpain: "Spain",
            buttonPrevious: "Go Back",
        },
        es: {
            textSelectCountry: "Por favor selecciona tu país",
            buttonSelectCountry: "Selecciona Este País",
            titleUnitedKingdom: "Reino Unido",
            titleIreland: "Irlanda",
            titleNordics: "Países nórdicos",
            titleMalta: "Malta",
            titleUAE: "UAE",
            titleSpain: "España",
            buttonPrevious: "Anterior",
        },
    },
    login: {
        en: {
            headingWelcome: "Welcome",
            headingWelcomeTo: "Welcome to",
            textWelcomeTo:
                "Welcome to My Royal Genie, our exciting new tool which allows you to build the perfect holiday for your customers based on their wishlist, helping you sell like never before.",
            textGetStarted: "To get started, please sign up to My Royal Genie.",
            textGetStartedBridge: "My Royal Bridge",
            textGetStartedPro: "Royal Momentum",
            textNeedHelpBridge: "Need help signing in?",
            // textExplBridge:
            //     "Password resets are managed by your Royal Caribbean IT team. For support please log an incident in Service now - Sales tools issue",
            // textExplPro:
            //     "Password resets are managed by your Royal Caribbean IT team. For support please log an incident in Service now - Sales tools issue",
            textExplBridge:
                "Contact your Royal Caribbean account manager",
            textExplPro:
                "Contact your Royal Caribbean account manager",
            textHaventRegister: "Haven’t got a My Royal Genie account yet?",
            textForgotPassword: "Forgot Password?",
            buttonSignUp: "Create an account",
            buttonLogIn: "Sign In",
            textStaySignedIn: "Stay signed in",
            textShow: "show",
            placeholderEmailAddress: "Email Address",
            placeholderPassword: "Password",
        },
        nordics: {
            headingWelcomeTo: "Welcome to",
            textWelcomeTo:
                "Welcome to My Royal Genie, our exciting new tool which allows you to build the perfect holiday for your customers based on their wishlist, helping you sell like never before.",
            textGetStarted: "To get started, please sign up to My Royal Genie.",
            textHaventRegister: "Haven’t got a My Royal Genie account yet?",
            textForgotPassword: "Forgot Password?",
            buttonSignUp: "Create an account",
            buttonLogIn: "Sign In",
            textStaySignedIn: "Stay signed in",
            textShow: "show",
            placeholderEmailAddress: "Email Address",
            placeholderPassword: "Password",
        },
        es: {
            headingWelcome: "Bienvenido",
            headingWelcomeTo: "Bienvenido a",
            textWelcomeTo:
                "Os damos la bienvenida a My Royal Genie, nuestra nueva y atractiva herramienta que os permitirá diseñar las vacaciones perfectas para vuestros clientes en base a su lista de deseos. Esta herramienta os proporcionará un éxito de ventas sin precedentes.",
            textGetStarted: "Para comenzar hay que inscribirse en My Royal Genie.",
            textGetStartedBridge: "My Royal Bridge",
            textGetStartedPro: "Royal Momentum",
            textNeedHelpBridge: "¿Necesita ayuda para iniciar sesión?",
            textExplBridge:
                "El restablecimiento de contraseñas es gestionado por su equipo de cuenta de Royal Caribbean. Para cualquier problema de inicio de sesión o acceso, comuníquese con su contacto de cuenta o envíe un correo electrónico a ",
            textExplPro:
                "El restablecimiento de contraseñas es gestionado por su equipo de IT de Royal Caribbean. Para cualquier problema de inicio de sesión o acceso, comuníquese con su contacto de cuenta o envíe un correo electrónico a ",
            textHaventRegister: "¿Aún no tienes una cuenta de My Royal Genie?",
            textForgotPassword: "¿Has olvidado tu contraseña?",
            buttonSignUp: "REGÍSTRATE",
            buttonLogIn: "INICIAR SESIÓN",
            textStaySignedIn: "Mantener la sesión iniciada",
            textShow: "mostrar",
            placeholderEmailAddress: "Correo electrónico",
            placeholderPassword: "Contraseña",
        },
    },
    register: {
        en: {
            textBackToClubRoyal: "Back to Club Royal",
            headingWelcomeTo: "Welcome to",
            headingSignUp: "Sign Up",
            textWelcome:
                "Welcome to My Royal Genie, our exciting new tool to help you sell like never before. First up, let’s make your My Royal Genie account.",
            buttonBackToLogin: "Back to Login",
            buttonPrevious: "Go Back",
            buttonNext: "Next",
            linkBackToLogin: "Back to Login",
            textAdditionalAgency: "",
            textGetName: "First up, let’s get your name:",
            placeholderFirstName: "First Name*",
            placeholderLastName: "Last Name*",
            textWhatAgency:
                "Next, what agency are you part of? We will brand your experience to your agency:",
            placeholderAgencyName: "Agency Name*",
            placeholderABTA: "ABTA*",
            textContactTradeTeam: "If you do not have an ABTA please contact the Trade team on",
            placeholderAgencyID: "Agency ID*",
            placeholderAgencyIDOptional: "Agency ID",
            placeholderAgencyPhoneNumber: "Agency Phone Number*",
            textAgencyPhoneNumber: "Please enter your agency phone number without a country code.",
            placeholderTypeName: "Type Name*",
            textContactDetails:
                "Lastly, we need your contact details. These contact details will be provided for your customers to get hold of you.",
            placeholderContactPhoneNumber: "Contact Phone Number*",
            validationContactPhoneNumber: "Please specify valid phone number",
            placeholderWorkEmail: "Work Email*",
            validationWorkEmail: "Please specify valid email",
            placeholderPassword: "Password*",
            textPasswordRules: "Please make sure your password has:",
            textPasswordRulesListOne: "Minimum of 8 characters",
            textPasswordRulesListTwo: "One upper case character",
            textPasswordRulesListThree: "One special character",
            placeholderReenterPassword: "Re-enter Password*",
            validationPasswordDoesNotMatch: "Password does not match",
            textAcceptTerms: "Accept Terms & Conditions",
            notVerifiedTextDivNordicsText:
                "Please ensure that you are registering with a company email address and your correct the country code. If you do not have a have problems, please contact",
            notVerifiedTextDivMaltaText:
                "Please ensure that you are registering with a company email address. If you do not have a company email address or continue to have problems, please contact",
            notVerifiedTextDivOtherText:
                "Sorry, you need a My Club Royal account before you can sign up to My Royal Genie. Please create a My Club Royal account first.",
            verifiedTextDivNordicsText:
                "Congratulations, your account has been verified for My Royal Genie. Login to start creating bespoke holiday suitcases for your customers!",
            verifiedTextDivOtherText:
                "Congratulations, your My Club Royal account has been verified for My Royal Genie. Login to start creating bespoke holiday suitcases for your customers!",
            headingAccountVerified: "Account Verified",
            headingAccountNotVerified: "Account Not Verified",
            buttonLogin: "Login",
            buttonMyClubRoyal: "My Club Royal",
            textRegisteringIn: "Registering in",
            buttonChange: "Change",
            labelAgencySearchAbta: "Agency name or ABTA number*",
            labelAgencySearchId: "Agency name or Agency ID*",
            labelAgencySearchName: "Agency name*",
            placeholderAgencySearch: "Start typing your agency name…",
            textSearching: "Searching…",
            textNoMatchTradeTeam:
                "If you can’t find your agency, please contact the Trade team on",
            textAbtaHint: "Looks like an ABTA number — keep typing to search",
            textMoreMatch: "{count} more match — keep typing to narrow down",
            textMoreMatches: "{count} more matches — keep typing to narrow down",
            validationSelectAgency: "Please select your agency from the list",
            validationRequiredField: "This field is required",
            validationAcceptTerms: "Please accept the Terms & Conditions",
            labelCardAbta: "ABTA",
            labelCardAgencyId: "Agency ID",
        },
        nordics: {
            textBackToClubRoyal: "Back to Club Royal",
            headingWelcomeTo: "Welcome to",
            headingSignUp: "Sign Up",
            textWelcome:
                "Welcome to My Royal Genie, our exciting new tool to help you sell like never before. First up, let’s make your My Royal Genie account.",
            buttonBackToLogin: "Back to Login",
            buttonPrevious: "Go Back",
            buttonNext: "Next",
            linkBackToLogin: "Back to Login",
            textAdditionalAgency: "",
            textGetName: "First up, let’s get your name:",
            placeholderFirstName: "First Name*",
            placeholderLastName: "Last Name*",
            textWhatAgency:
                "Next, what agency are you part of? We will brand your experience to your agency:",
            placeholderAgencyName: "Agency Name*",
            placeholderABTA: "ABTA*",
            textContactTradeTeam: "If you do not have an ABTA please contact the Trade team on",
            placeholderAgencyID: "Agency ID*",
            placeholderAgencyIDOptional: "Agency ID",
            placeholderAgencyPhoneNumber: "Agency Phone Number*",
            textAgencyPhoneNumber: "Please enter your agency phone number without a country code.",
            placeholderTypeName: "Type Name*",
            textContactDetails:
                "Lastly, we need your contact details. These contact details will be provided for your customers to get hold of you.",
            placeholderContactPhoneNumber: "Contact Phone Number*",
            validationContactPhoneNumber: "Please specify valid phone number",
            placeholderWorkEmail: "Work Email*",
            validationWorkEmail: "Please specify valid email",
            placeholderPassword: "Password*",
            textPasswordRules: "Please make sure your password has:",
            textPasswordRulesListOne: "Minimum of 8 characters",
            textPasswordRulesListTwo: "One upper case character",
            textPasswordRulesListThree: "One special character",
            placeholderReenterPassword: "Re-enter Password*",
            validationPasswordDoesNotMatch: "Password does not match",
            textAcceptTerms: "Accept Terms & Conditions",
            notVerifiedTextDivNordicsText:
                "Please ensure that you are registering with a company email address and your correct the country code. If you do not have a have problems, please contact",
            notVerifiedTextDivMaltaText:
                "Please ensure that you are registering with a company email address. If you do not have a company email address or continue to have problems, please contact",
            notVerifiedTextDivOtherText:
                "Sorry, you need a My Club Royal account before you can sign up to My Royal Genie. Please create a My Club Royal account first.",
            verifiedTextDivNordicsText:
                "Congratulations, your account has been verified for My Royal Genie. Login to start creating bespoke holiday suitcases for your customers!",
            verifiedTextDivOtherText:
                "Congratulations, your My Club Royal account has been verified for My Royal Genie. Login to start creating bespoke holiday suitcases for your customers!",
            headingAccountVerified: "Account Verified",
            headingAccountNotVerified: "Account Not Verified",
            buttonLogin: "Login",
            buttonMyClubRoyal: "My Club Royal",
            textRegisteringIn: "Registering in",
            buttonChange: "Change",
            labelAgencySearchAbta: "Agency name or ABTA number*",
            labelAgencySearchId: "Agency name or Agency ID*",
            labelAgencySearchName: "Agency name*",
            placeholderAgencySearch: "Start typing your agency name…",
            textSearching: "Searching…",
            textNoMatchTradeTeam:
                "If you can’t find your agency, please contact the Trade team on",
            textAbtaHint: "Looks like an ABTA number — keep typing to search",
            textMoreMatch: "{count} more match — keep typing to narrow down",
            textMoreMatches: "{count} more matches — keep typing to narrow down",
            validationSelectAgency: "Please select your agency from the list",
            validationRequiredField: "This field is required",
            validationAcceptTerms: "Please accept the Terms & Conditions",
            labelCardAbta: "ABTA",
            labelCardAgencyId: "Agency ID",
        },
        es: {
            textBackToClubRoyal: "Atrás a Club Royal",
            headingWelcomeTo: "Bienvenido a",
            headingSignUp: "REGÍSTRATE",
            textWelcome:
                "Bienvenido a Royal Genie: una herramienta que te permite diseñar las vacaciones perfectas para tus clientes. El primer paso es crear tu cuenta de Royal Genie.",
            buttonBackToLogin: "Atrás a Iniciar Sesión",
            buttonPrevious: "Anterior",
            buttonNext: "Siguiente",
            linkBackToLogin: "Atrás a Iniciar Sesión",
            textAdditionalAgency: (
                <>
                    Si tu agencia no aparece en el listado por favor contacta con{" "}
                    <a href="mailto:comercial.es@rccl.com" className="font-darwinProBold">
                        comercial.es@rccl.com
                    </a>
                </>
            ),
            textGetName: "Para empezar, introduce tu nombre:",
            placeholderFirstName: "Nombre*",
            placeholderLastName: "Apellidos*",
            textWhatAgency:
                "¿A qué agencia perteneces? Personalizaremos la experiencia para que refleje la identidad de tu agencia.",
            placeholderAgencyName: "Nombre de la agencia*",
            placeholderABTA: "ABTA*",
            textContactTradeTeam:
                "Si no encuentras tu agencia en la lista, no dudes en ponerte en contacto con nuestro equipo:",
            placeholderAgencyID: "ID de la agencia*",
            placeholderAgencyIDOptional: "ID de la agencia",
            placeholderAgencyPhoneNumber: "Teléfono de contacto de la agencia*",
            textAgencyPhoneNumber:
                "Introduce el número de teléfono de tu agencia sin el prefijo del país",
            placeholderTypeName: "Introducir nombre",
            textContactDetails:
                "Por último, necesitamos tus datos de contacto. Estos serán esenciales para que tus clientes puedan comunicarse contigo fácilmente.",
            placeholderContactPhoneNumber: "Número de teléfono*",
            validationContactPhoneNumber: "Introduce un número de teléfono válido",
            placeholderWorkEmail: "Correo electrónico de trabajo*",
            validationWorkEmail: "Introduce un correo electrónico válido",
            placeholderPassword: "Contraseña*",
            textPasswordRules: "Por favor asegúrese de que su contraseña tenga:",
            textPasswordRulesListOne: "Mínimo de 8 caracteres",
            textPasswordRulesListTwo: "Un carácter en mayúscula",
            textPasswordRulesListThree: "Un carácter especial",
            placeholderReenterPassword: "Escriba de nuevo su contraseña",
            validationPasswordDoesNotMatch: "La contraseña no coincide Password",
            textAcceptTerms: "Aceptar los Términos y Condiciones",
            notVerifiedTextDivNordicsText:
                "Comprueba que te registras con una dirección de correo electrónico corporativa y el código correcto de tu país. Si tienes algún problema puedes contactar con",
            notVerifiedTextDivMaltaText:
                "Comprueba que te registras con una dirección de correo electrónico corporativa.Si no tienes una dirección de correo electrónico corporativa o tienes algún problema, contacta con",
            notVerifiedTextDivOtherText:
                "Lo sentimos, necesitas una cuenta en miclubroyal.es (Programa de Afiliación de Royal Caribbean) antes de poder registrarte en My Royal Genie. Por favor, crea una cuenta en miclubroyal.es primero o envía un correo electrónico a comercial.es@rccl.com.",
            verifiedTextDivNordicsText:
                "¡Enhorabuena! Tu cuenta ha sido verificada. Ahora formas parte de My Royal Genie. Solo necesitas iniciar sesión para personalizar las vacaciones de tus clientes.",
            verifiedTextDivOtherText:
                "Enhorabuena. Hemos verificado tu cuenta My Club Royal para My Royal Genie. Inicia sesión para empezar a crear maletas de vacaciones personalizadas para tus clientes",
            headingAccountVerified: "Cuenta verificada",
            headingAccountNotVerified: "Su cuenta no ha sido verificada",
            buttonLogin: "Inicia sesión",
            buttonMyClubRoyal: "My Club Royal",
            textRegisteringIn: "Registrándote en",
            buttonChange: "Cambiar",
            labelAgencySearchAbta: "Nombre de la agencia o número ABTA*",
            labelAgencySearchId: "Nombre de la agencia o ID de la agencia*",
            labelAgencySearchName: "Nombre de la agencia*",
            placeholderAgencySearch: "Empieza a escribir el nombre de tu agencia…",
            textSearching: "Buscando…",
            textNoMatchTradeTeam:
                "Si no encuentras tu agencia, ponte en contacto con nuestro equipo:",
            textAbtaHint: "Parece un número ABTA: sigue escribiendo para buscar",
            textMoreMatch: "{count} coincidencia más: sigue escribiendo para afinar la búsqueda",
            textMoreMatches: "{count} coincidencias más: sigue escribiendo para afinar la búsqueda",
            validationSelectAgency: "Por favor, selecciona tu agencia de la lista",
            validationRequiredField: "Este campo es obligatorio",
            validationAcceptTerms: "Por favor, acepta los Términos y Condiciones",
            labelCardAbta: "ABTA",
            labelCardAgencyId: "ID de la agencia",
        },
    },
    resetPassword: {
        en: {
            backToClubRoyal: "Back to Club Royal",
            headingWelcomeTo: "Welcome to",
            headingResetPassword: "Reset Password",
            textEnterEmail:
                "Please enter your email address below. If you have an account with us we will send you can email with further instructions.",
            textCheckJunkSpam: (
                <>
                    If you don’t hear from us in the next 15 minutes, please double check you have
                    entered your email correctly and{" "}
                    <span className="font-darwinProBold">check your junk/spam folder.</span>
                </>
            ),
            placeholderEmail: "Email*",
            buttonBackToLogin: "Back to Login",
            buttonUpdate: "Update",
            headingPasswordChanged: "Password Changed",
            textPasswordChanged:
                "Great news, your password has changed. Head to login to Build a holiday for your customers today.",
                        headingCheckEmail: "Check Your Email",
            textPasswordChangedPro:
                "Great news, your password has changed. Head to login to pick up where you left off in My Royal Momentum.",
            textPasswordChangedBridge:
                "Great news, your password has changed. Head to login to pick up where you left off in My Royal Bridge.",
            textPasswordChangedSignIn:
                "You can now sign in to the My Royal Momentum app with your new password.",
            buttonBackToLoginLarge: "Back to Login",
            placeholderPassword: "Password*",
            textPasswordRules: "Please make sure your password has:",
            textPasswordRulesListOne: "Minimum of 8 characters",
            textPasswordRulesListTwo: "One upper case character",
            textPasswordRulesListThree: "One special character",
            placeholderReenterPassword: "Re-enter Password*",
            validationConfirmPass: "Confirm password is not similiar with password",
            buttonResetPassword: "Reset Password",
        },
        nordics: {
            backToClubRoyal: "Back to Club Royal",
            headingWelcomeTo: "Welcome to",
            headingResetPassword: "Reset Password",
            textEnterEmail:
                "Please enter your email address below. If you have an account with us we will send you can email with further instructions.",
            textCheckJunkSpam: (
                <>
                    If you don’t hear from us in the next 15 minutes, please double check you have
                    entered your email correctly and{" "}
                    <span className="font-darwinProBold">check your junk/spam folder.</span>
                </>
            ),
            placeholderEmail: "Email*",
            buttonBackToLogin: "Back to Login",
            buttonUpdate: "Update",
            headingPasswordChanged: "Password Changed",
            textPasswordChanged:
                "Great news, your password has changed. Head to login to Build a holiday for your customers today.",
                        headingCheckEmail: "Check Your Email",
            textPasswordChangedPro:
                "Great news, your password has changed. Head to login to pick up where you left off in My Royal Momentum.",
            textPasswordChangedBridge:
                "Great news, your password has changed. Head to login to pick up where you left off in My Royal Bridge.",
            textPasswordChangedSignIn:
                "You can now sign in to the My Royal Momentum app with your new password.",
            buttonBackToLoginLarge: "Back to Login",
            placeholderPassword: "Password*",
            textPasswordRules: "Please make sure your password has:",
            textPasswordRulesListOne: "Minimum of 8 characters",
            textPasswordRulesListTwo: "One upper case character",
            textPasswordRulesListThree: "One special character",
            placeholderReenterPassword: "Re-enter Password*",
            validationConfirmPass: "Confirm password is not similiar with password",
            buttonResetPassword: "Reset Password",
        },
        es: {
            backToClubRoyal: "Atrás a Club Royal",
            headingWelcomeTo: "Bienvenido a",
            headingResetPassword: "RESTABLECER CONTRASEÑA",
            textEnterEmail:
                "Introduce tu dirección de correo electrónico en el recuadro. Si ya tienes cuenta con nosotros recibirás un correo electrónico con instrucciones.",
            textCheckJunkSpam: (
                <>
                    Si no has obtenido respuesta en 15 minutos, comprueba que has accedido a tu
                    correo correctamente y mira{" "}
                    <span className="font-darwinProBold">en tu correo no deseado y spam.</span>
                </>
            ),
            placeholderEmail: "Email*",
            buttonBackToLogin: "ATRÁS A INICIAR SESIÓN",
            buttonUpdate: "actualizar",
            headingPasswordChanged: "Contraseña Cambiada",
            textPasswordChanged:
                "Enhorabuena. Tu contraseña ha sido actualizada. Accede a Iniciar Sesión para diseñar las vacaciones de tus clientes ahora mismo",
                        headingCheckEmail: "Revisa Tu Correo",
            textPasswordChangedPro:
                "Enhorabuena. Tu contraseña ha sido actualizada. Accede a Iniciar Sesión para continuar en My Royal Momentum.",
            textPasswordChangedBridge:
                "Enhorabuena. Tu contraseña ha sido actualizada. Accede a Iniciar Sesión para continuar en My Royal Bridge.",
            textPasswordChangedSignIn:
                "Ya puedes iniciar sesión en la app My Royal Momentum con tu nueva contraseña.",
            buttonBackToLoginLarge: "ATRÁS A INICIAR SESIÓN",
            placeholderPassword: "Contraseña*",
            textPasswordRules: "Por favor asegúrese de que su contraseña tenga:",
            textPasswordRulesListOne: "Mínimo de 8 caracteres",
            textPasswordRulesListTwo: "Un carácter en mayúscula",
            textPasswordRulesListThree: "Un carácter especial",
            placeholderReenterPassword: "Escriba de nuevo su contraseña*",
            validationConfirmPass: "La contraseña no coincide",
            buttonResetPassword: "RESTABLECER CONTRASEÑA",
        },
    },
    homepage: {
        en: {
            headerOne: "Build a Holiday",
            headerTwo: "For your customers",
            headerThree:
                "Create the perfect selection of holiday itineraries for every customer, every time. This is how to sell Royal Caribbean.",
            headerButton: "Get Started",
            introTitle: "AN ICONIC <br> FAMILY HOLIDAY",
            introText:
                "Introducing Legend of the Seas, the threequel that’s levelling up everything you love about Icon of the Seas. Dial up the whoas on the boldest holiday to hit the Med, adventuring on a ship as monumental as the destinations. Or choose from spectacular southern and western Caribbean sailings, both with stops at the award-winning Perfect Day at CocoCay. This is an adventure of the ages, for all ages — sailing summer 2026 from Barcelona, Spain and winter 2026 from Fort Lauderdale, Florida",
            introTitleSliderTwo: "A LEGENDARY HOLIDAY",
            introTextSliderTwo:
                "The third installment of the saga far exceeds everything you love about the Icon of the Seas. Get ready to be amazed by the most incredible holiday in the Mediterranean and live the adventure on a ship as monumental as the destinations where it takes you. Embark on a mind-blowing journey for travellers of all ages setting sail from Barcelona. From the summer of 2026.",
            introTitleSliderGenie: "OUR NEW AI TOOL TO HELP YOU SELL",
            introTextSliderGenie:
                "Meet Genie AI — an AI-powered sales assistant designed to make selling Royal Caribbean cruises easier. Ask Genie about customer objections, common questions, or anything you need to know about our ships and experiences. Whatever the question, Genie AI is here to help.",
            headingFocusHolidays: "FOCUS HOLIDAYS",
            textFocusHolidays: (
                <>
                    Not sure where to start? With Royal Caribbean there's something to ignite
                    excitement in every guest – why not start with this extraordinary selection of{" "}
                    2025 and 2026 holidays.
                </>
            ),
            headingLatestCampaign: "Latest Campaign",
            scroll: "SCROLL",
            welcomeToThe: "Welcome to the",
            reimagined: "Reimagined",
            welcomeTextPopup:
                "Welcome to the reimagined My Royal Genie, featuring a bold new look and even more ways to bring dream holidays to life. From richer visuals to immersive video and deeper product content, it is built to help you excite customers, tell bigger stories and close with confidence. Everything you already love, now with even more magic. <br /><br /> What are you waiting for? Get started building bolder brochures, visit the closing lounge and get chatting to our brand-new Genie AI.",
            welcomeBtnPopup: "Jump into the new My Royal Genie",
        },
        nordics: {
            headerOne: "Build a Holiday",
            headerTwo: "For your customers",
            headerThree:
                "Create the perfect selection of holiday itineraries for every customer, every time. This is how to sell Royal Caribbean.",
            headerButton: "Get Started",
            introTitle: "AN ICONIC FAMILY HOLIDAY <br> LEGEND OF THE SEAS",
            introText:
                "Introducing Legend of the Seas, the threequel that’s levelling up everything you love about Icon of the Seas. Dial up the whoas on the boldest holiday to hit the Med, adventuring on a ship as monumental as the destinations. Or choose from spectacular southern and western Caribbean sailings, both with stops at the award-winning Perfect Day at CocoCay. This is an adventure of the ages, for all ages — sailing summer 2026 from Barcelona, Spain and winter 2026 from Fort Lauderdale, Florida",
            headingFocusHolidays: "FOCUS HOLIDAYS",
            textFocusHolidays: (
                <>
                    Not sure where to start? With Royal Caribbean there's something to ignite
                    excitement in every guest – why not start with this extraordinary selection of{" "}
                    2025 and 2026 holidays.
                </>
            ),
            headingLatestCampaign: "Latest Campaign",
            scroll: "SCROLL",
        },
        es: {
            headerOne: "PERSONALIZA LAS VACACIONES",
            headerTwo: "DE TUS CLIENTES POR EUROPA",
            headerThree:
                "Crea la selección perfecta de itinerarios vacacionales para cada cliente. Así es como se vende Royal Caribbean.",
            headerButton: "Iniciar",
            introTitle: "UNAS VACACIONES <br> LEGENDARIAS",
            introText:
                "La tercera entrega de la saga supera con creces todo lo que te encanta del Icon of the Seas. Prepárate para alucinar con las vacaciones más increíbles del Mediterráneo y vive la aventura en un barco tan monumental como los destinos donde te lleva. Embárcate en un viaje alucinante para viajeros de todas las edades zarpando desde Barcelona en el verano de 2026.",
            introTitleSliderTwo: "UNAS VACACIONES LEGENDARIAS",
            introTextSliderTwo:
                "La tercera entrega de la saga supera con creces todo lo que te encanta del Icon of the Seas. Prepárate para alucinar con las vacaciones más increíbles del Mediterráneo y vive la aventura en un barco tan monumental como los destinos donde te lleva. Embárcate en un viaje alucinante para viajeros de todas las edades zarpando desde Barcelona. A partir del Verano de 2026.",
            introTitleSliderGenie: "Genie AI ya está aquí",
            introTextSliderGenie:
                "Conoce a Genie AI, un asistente de ventas con tecnología de inteligencia artificial diseñado para facilitar la venta de cruceros de Royal Caribbean. Pregúntale a Genie sobre las objeciones de los clientes, preguntas frecuentes o cualquier cosa que necesites saber sobre nuestros barcos y experiencias. Sea cual sea la pregunta, Genie AI está aquí para ayudarte.",
            headingFocusHolidays: "PERSONALIZA SUS VACACIONES",
            textFocusHolidays: (
                <>
                    ¿No sabes por donde empezar? ¡Royal Caribbean tiene actividades que sorprenderán
                    a todos los miembros de la familia sin importar la edad! ¡Personaliza las
                    vacaciones de tus clientes para el año 2025 o 2026!
                </>
            ),
            headingLatestCampaign: "Última campaña",
            scroll: "Desplazar",
            welcomeToThe: "Bienvenido a ",
            reimagined: "el renovado",
            welcomeTextPopup:
                "Bienvenidos a la versión renovada de My Royal Genie. Hemos incorporado nuevas herramientas para ayudarte a personalizar el crucero perfecto para tu cliente. Esta actualización incluye colores más brillantes, imágenes nuevas y catálogos digitales de alto nivel con más información sobre nuestros barcos, incluido el Legend of the Seas. <br /><br /> ¿TE APUNTAS? ¡La versión renovada de My Royal Genie ya está disponible!",
            welcomeBtnPopup: "¡ÉCHALE UN VISTAZO!",
        },
    },
    howitWorks: {
        en: {
            headerTitle: "HOW IT WORKS",
            headerCaption: "How it Works",
            textWelcomeToMyRoyalGenie: (
                <>
                    Welcome to <span className="font-darwinProBold">My Royal Genie</span>, our brand
                    new 5-step tool to help you sell Royal Caribbean cruises better than ever
                    before. My Royal Genie helps you to do exactly that for your customers, enabling
                    you to put together their dream selection of personalised holidays based on
                    where and when they’re interested in holidaying.
                </>
            ),
            titleHowItWorks: "How to start",
            textHowItWorks:
                "It’s simple, click “Get Started” on the homepage and we will ask you 5 questions in our step-by-step process, helping us to narrow down the holiday results you’ll see at the end based on:",
            textHowItWorksListOne: "What dates they’re interested in taking their holiday on",
            textHowItWorksListTwo: "The type of group they’re travelling with",
            textHowItWorksListThree:
                "The destinations they want to visit and where they’ll depart from",
            textHowItWorksListFour: "How many nights they’d like to stay onboard",
            titlePersonalisedToThem: "Personalised to them",
            textPersonalisedToThem:
                "During the process we ask for their first name and group type. This is so we can take things one step further by personalising their experience, dynamically changing what to do onboard and at the destinations they’ll visit, as well as including handy hints for those new to cruise, making it easier than ever to sell.",
            titleBuildTheirHolidaySuitcase: "Build their Holiday Suitcase",
            textBuildTheirHolidaySuitcase:
                "Once you’ve answered all 5 questions, you’ll see a filtered list of itineraries, now it’s up to you to select the best ones for your customer and add them to their Holiday Suitcase - when you’re happy with your selection, click the Holiday Suitcase to proceed to the last step.",
            titleReadyToSend: "Ready to Send?",
            textReadyToSend:
                "Once you’re done, you can preview their selection of holidays and then share and send them their unique URL – all your contact details will be included so it’s easy for them to book with you afterwards! If you need to make any changes to your contact details, you can do so from the Account button in the top right corner.",
            ctaTitle: "BUILD A NEW EXPERIENCE",
            ctaSubtitle: "Create a suitcase for your new customer",
            ctaButton: "Get Started",
        },
        nordics: {
            headerTitle: "MY ROYAL GENIE",
            headerCaption: "How it Works",
            textWelcomeToMyRoyalGenie: (
                <>
                    Welcome to <span className="font-darwinProBold">My Royal Genie</span>, our brand
                    new 5-step tool to help you sell Royal Caribbean cruises better than ever
                    before. My Royal Genie helps you to do exactly that for your customers, enabling
                    you to put together their dream selection of personalised holidays based on
                    where and when they’re interested in holidaying.
                </>
            ),
            titleHowItWorks: "How it Works",
            textHowItWorks:
                "It’s simple, click “Get Started” on the homepage and we will ask you 5 questions in our step-by-step process, helping us to narrow down the holiday results you’ll see at the end based on:",
            textHowItWorksListOne: "What dates they’re interested in taking their holiday on",
            textHowItWorksListTwo: "The type of group they’re travelling with",
            textHowItWorksListThree:
                "The destinations they want to visit and where they’ll depart from",
            textHowItWorksListFour: "How many nights they’d like to stay onboard",
            titlePersonalisedToThem: "Personalised to them",
            textPersonalisedToThem:
                "During the process we ask for their first name and group type. This is so we can take things one step further by personalising their experience, dynamically changing what to do onboard and at the destinations they’ll visit, as well as including handy hints for those new to cruise, making it easier than ever to sell.",
            titleBuildTheirHolidaySuitcase: "Build their Holiday Suitcase",
            textBuildTheirHolidaySuitcase:
                "Once you’ve answered all 5 questions, you’ll see a filtered list of itineraries, now it’s up to you to select the best ones for your customer and add them to their Holiday Suitcase - when you’re happy with your selection, click the Holiday Suitcase to proceed to the last step.",
            titleReadyToSend: "Ready to Send?",
            textReadyToSend:
                "Once you’re done, you can preview their selection of holidays and then share and send them their unique URL – all your contact details will be included so it’s easy for them to book with you afterwards! If you need to make any changes to your contact details, you can do so from the Account button in the top right corner.",
            ctaTitle: "BUILD A NEW HOLIDAY EXPERIENCE",
            ctaSubtitle: "to wow your next customer",
            ctaButton: "Get Started",
        },
        es: {
            headerTitle: "MY ROYAL GENIE",
            headerCaption: "Cómo funciona",
            textWelcomeToMyRoyalGenie: (
                <>
                    Bienvenidos a <span className="font-darwinProBold">My Royal Genie</span>,
                    nuestra nueva herramienta que en sólo cinco pasos te ayudará a vender cruceros
                    de Royal Caribbean con más facilidad que nunca. My Royal Genie te ayuda a
                    aconsejar a tus clientes. Según sus preferencias, podrás ofrecer una selección
                    de vacaciones personalizadas basándote en dónde y cuándo quieren viajar.
                </>
            ),
            titleHowItWorks: "Cómo funciona",
            textHowItWorks:
                "Es tan fácil como hacer clic en la página de INICIO y te haremos 5 preguntas en un proceso que nos ayudará a conseguir resultados basados en:",
            textHowItWorksListOne: "Las fechas en que los clientes quieren viajar",
            textHowItWorksListTwo: "El tipo de grupo con el que viajarán",
            textHowItWorksListThree: "Qué destinos quieren visitar y de dónde zarparán",
            textHowItWorksListFour: "La cantidad de noches que quieren pasar a bordo",
            titlePersonalisedToThem: "Personalizado",
            textPersonalisedToThem:
                "Durante el proceso preguntamos el nombre y el tipo de grupo para poder personalizar sus vacaciones. Seleccionamos las actividades que podrían disfrutar a bordo y en los Y en los puertos de escala. También podemos así incluir algunas sugerencias útiles para los cruceristas primerizos y así facilitarles su primera experiencia a bordo de nuestros barcos. Vender será más fácil que nunca.",
            titleBuildTheirHolidaySuitcase: "Crea su maleta para las vacaciones",
            textBuildTheirHolidaySuitcase:
                "Una vez contestadas las cinco preguntas verás un listado de itinerarios. Ahora podrás seleccionar los más adecuados para tus clientes y añadirlos a su Maleta de Vacaciones. Con la selección hecha, haz clic en MALETA DE VACACIONES para seguir con el proceso.",
            titleReadyToSend: "¿Listo para enviar?",
            textReadyToSend:
                "Ahora puedes previsualizar su selección y compartirla enviándoles su propio enlace. Allí aparecerán todos tus datos de contacto de modo que será fácil para ellos ponerse en contacto contigo para reservar. Si necesitas cambiar algún detalle de tus datos de contacto podrás hacerlo desde el botón que encontrarás arriba a la derecha.",
            ctaTitle: "PERSONALIZA LAS VACACIONES DE TUS CLIENTES",
            // ctaSubtitle: "para sorprender a tu próximo cliente",
            ctaButton: "Inicio",
        },
    },
    holidaysDashboard: {
        en: {
            headerTitle: "Build a Holiday",
            headerCaption: "Dashboard",
            caption: "Your past holidays you have created for your customers.",
            captionNordics:
                "Don't forget to go back into your Club Rewards accounts to claim your confirmed bookings.",
            tableTextName: "Name",
            tableTextDateCreated: "Date Created",
            tableTextLink: "Link",
            tableTextHolidayPurchased: "Holiday Purchased",
            buttonCopyLink: "Copy Link",
            buttonYes: "Yes",
            buttonNo: "No",
            buttonYesNo: "Yes/No?",
            buttonChoose: "choose",
            buttonChooseNo: "choose no",
            textNoHoliday: "No holidays have been viewed by a customer yet",
        },
        nordics: {
            headerTitle: "Build a Holiday",
            headerCaption: "Dashboard",
            caption: "Your past holidays you have created for your customers.",
            captionNordics:
                "Don't forget to go back into your Club Rewards accounts to claim your confirmed bookings.",
            tableTextName: "Name",
            tableTextDateCreated: "Date Created",
            tableTextLink: "Link",
            tableTextHolidayPurchased: "Holiday Purchased",
            buttonCopyLink: "Copy Link",
            buttonYes: "Yes",
            buttonNo: "No",
            buttonYesNo: "Yes/No?",
            buttonChoose: "choose",
            buttonChooseNo: "choose no",
            textNoHoliday: "No holidays have been viewed by a customer yet",
        },
        es: {
            headerTitle: "PERSONALIZA LAS VACACIONES",
            headerCaption: "Pantalla de inicio",
            caption:
                "Podrás ver todas las vacaciones que has creado y compartido con tus clientes.",
            captionNordics:
                "No olvides entrar en tu cuenta Club Rewards para reclamar tus reservas confirmadas,",
            tableTextName: "Nombre",
            tableTextDateCreated: "Fecha Creado",
            tableTextLink: "Enlace",
            tableTextHolidayPurchased: "Vacaciones compradas",
            buttonCopyLink: "Copia el link",
            buttonYes: "Sí",
            buttonNo: "No",
            buttonYesNo: "Sí/No?",
            buttonChoose: "elegir",
            buttonChooseNo: "elige no",
            textNoHoliday: "Ningún cliente ha visualizado vacaciones todavía",
            genieAIDescPopup: `Genie AI is a chatbot that has been trained to help you sell cruises to
                            the best of your abilities. From overcoming objections from customers,
                            to providing the latest cruises Royal Caribbean has to offer - Genie
                            AI’s there to help you every step of the way.`,
            genieAIBackButtonPopup: "Go back",
            genieAINextButtonPopup: "Chat to Genie AI",
        },
    },
    closingLounge: {
        en: {
            headerTitle: "Closing Lounge",
            headerCaption:
                "Your space to close the deal, fuel the excitement, and get the booking over the line.",
            tab1: "Active Suitcases",
            tab2: "Booked Cruises",
            tab3: "Archived Suitcases",
            reachOut: "REACH OUT TO GENIE AI",
            reachOutDesc:
                "Review your selections and make sure everything’s ready before sharing with your customer.",
            chatAiBtn: "Chat to Genie AI",
            activeSuitcase: "Your Active Suitcase",
            sortBy: "Sort by",
            name: "Name",
            created: "Created",
            status: "Status",
            cruise: "Cruise",
            closeSuitcase: "Archive Suitcase",
            yes: "Yes",
            no: "No",
            noLead: "no lead status",
            hotLead: "hot lead",
            warmLead: "warm lead",
            viewExperience: "View Customer Experience",
            lastOpened: "Last Opened",
            neededInspiration: "Open suitcase",
            readyForGenieAi: "READY FOR GENIE AI?",
            activeSuitcaseBoxOneDesc:
                "Get instant sales tips, objections support and closing suggestions tailored to your customer.",
            activeSuitcaseBoxOneBtn: "Learn about Genie AI",
            activeSuitcaseBoxTwoTitle: "NEED HELP CLOSING THE BOOKING?",
            activeSuitcaseBoxTwoDesc:
                "Genie AI helps you write the kind of message that gets customers excited — fast, friendly, and ready to book.",
            activeSuitcaseBoxTwoBtn: "Try Genie AI",
            bookedCruises: "Your Booked Cruises",
            bookingId: "Booking ID:",
            dateOfDep: "Date of departure",
            upperDeck: "UPPER DECK BANNER?",
            upperDeckLogoText: "UPPER DECK",
            upperDeckTitle: "Fill your pocket with rewards",
            upperDeckSubtitle: "Get more from your bookings.",
            upperDeckButton: "Go to Upper Deck",
            toAdvise: "Royal Caribbean to advise",
            pastSuitcases: "Your Past Suitcases",
            settingSail: "Setting sail?",
            noData: "No Data",
            usersSuitcase: "'s Suitcase",
            awaitingFeedback: "AWAITING CUSTOMER FEEDBACK",
            awaitingFeedbackText: "is yet to send feedback.",
            awaitingFeedbackDesc:
                "Even though the customer didn’t like any of the cruises in their suitcase, you could still reach out to see if you can help in any other way.",
            letCloseIt: "LEt’s CLOSE IT",
            letCloseItDesc:
                "viewed your recommendations and liked the following itineraries. Use Genie AI <br /> below to follow up, overcome any concerns, and help close the booking.",
            confirmBooking: "Confirm Booking",
            closeThisCruise: "Help me close this cruise",
            suitcaseItinerary: "Suitcase Itineraries",
            noSuitcases: "No Itineraries",
            itsMatch: "It's a match!",
            nowLetCloseIt: "NOW LET’s CLOSE IT.",
            returnTo: "Return to ",
            closingCongrat:
                "Congratulations on matching your customer to a great cruise option! Now its time to turn this dream match into a reality. With the help of",
            closingCongratSecond:
                "you can ask all the questions you need to get this sale over the line. Start asking, or use our prompts below:",
            questionOne: "How can I overcome objections?",
            questionTwo: "How can I close this cruise?",
            enterBookId: "Enter booking ID",
            enterBookText:
                "The final step! Please enter your booking ID below, and select the ship they will be cruising on. Please make sure you have entered the correct booking ID, as once submitted, this cannot be undone.",
            bookId: "BOOKING ID",
            selectShip: "Select Ship",
            congratulations: "Congratulations",
            congratulationsDesc:
                "You’ve successfully submitted your booking ID and it matches a booking on our end.",
            noBookingFound: "no booking found.",
            noBookingFoundDesc:
                "The details you’ve provided do not match any booking we have. Please check your details again.",
            bookingAlreadySubmited: "Booking Already submitted",
            bookingAlreadySubmitedDesc:
                "The details you’ve provided show that this booking has already been submitted and confirmed. Please enter a valid booking that has not been submitted, or check your details again.",
            backToSuitcase: "Go back to suitcase",
            hi: "Hi",
            pitchFirstParagraphEmailFun:
                "I have pulled together some Royal Caribbean cruises tailored just for you. These options bring sunshine, energy, and unforgettable moments, and each one offers its own style of adventure. Here is a quick look at what is waiting for you.",
            pitchSecondParagraphEmailFun: "Your personalised proposal with full details for all ",
            pitchSecondParagraphEmailFunEnd: " cruises is ready here:",
            pitchSecondParagraphEmailFunSingle:
                "Your personalised proposal with full details is ready here:",
            pitchThirdParagraphEmailFun:
                "If one of these sailings stands out, I can help you compare the details or get everything arranged. Just let me know what you are thinking and we will start building an unforgettable getaway.",
            pitchFirstParagraphEmailFriendly:
                "I have selected a few Royal Caribbean cruises that I think you will really enjoy. Each sailing blends great destinations with memorable onboard experiences, and I am excited to share them with you. Here is a quick overview.",
            pitchThirdParagraphEmailFriendly:
                "If any of these feel right for you, or if you would like help choosing, I am here whenever you need me. Just let me know what you would like to explore next.",
            pitchFirstParagraphEmailProfessinal:
                "I have prepared several Royal Caribbean itineraries based on your preferences. Each option offers a strong combination of destinations and onboard features. Here is a concise summary for your review.",
            pitchThirdParagraphEmailProfessinal:
                "If you would like support comparing these itineraries, adjusting dates, or securing a booking, I am available to assist. Please let me know how you would like to proceed.",

            pitchFirstParagraphMessageFun:
                "I have found some amazing Royal Caribbean sailings tailored for you. These cruises are packed with sunshine, energy, and unforgettable moments. Here are the top picks.",
            pitchThirdParagraphMessageFun:
                "Tell me which one you prefer, or I can help you narrow it down. Let us get you ready for an incredible holiday.",

            pitchFirstParagraphMessageFriendly:
                "I have pulled together a few Royal Caribbean cruises that I think you will love. Each sailing offers memorable destinations and relaxing onboard experiences. Here is a quick summary.",
            pitchThirdParagraphMessageFriendly:
                "If any of these interest you, I am here to help you compare the options and choose the right one. Just let me know when you are ready.",

            pitchFirstParagraphMessageProfessional:
                "Here are the Royal Caribbean cruise options selected for you. Each itinerary provides a balanced mix of destinations and onboard features. Please review the details below.",
            pitchThirdParagraphMessageProfessional:
                "If you require further information or wish to move forward with a booking, feel free to reply. I am available to assist at your convenience.",

            pitchFirstParagraphSocialFun:
                "I have picked out some amazing Royal Caribbean cruises that match what you are looking for. These sailings bring sunshine, adventure, and big holiday energy. Take a look.",
            pitchThirdParagraphSocialFun:
                "If one of these catches your eye, I can help you get everything arranged. Let us build a holiday worth talking about.",

            pitchFirstParagraphSocialFriendly:
                "I have rounded up a few Royal Caribbean cruises that you might really enjoy. Each one combines great destinations with amazing onboard experiences. Here is what is waiting for you.",
            pitchThirdParagraphSocialFriendly:
                "If any of these appeal to you, I would be happy to help with next steps. Just let me know what you would like to explore.",

            pitchFirstParagraphSocialProfessional:
                "Here are several Royal Caribbean itineraries that match your travel preferences. Each option provides a strong blend of destination highlights and onboard value. Here is a brief overview.",
            pitchThirdParagraphSocialProfessional:
                "If you would like further detail or support evaluating these options, or help moving ahead with a booking, I am available to assist. Please contact me at your convenience.",

            speakSoon: "Speak soon,",
            aiChatDesc:
                "Genie AI can help you overcome any difficulties faced when trying to sell cruises. Ask Genie AI anything you wish, or take a little inspiration from the buttons below.",
            aiChatTitle: "CHAT TO GENIE AI",
            genieAITitlePopup: "WHAT is GENIE AI?",

            genieAIDescPopup: `Genie AI is a chatbot that has been trained to help you sell cruises to
                            the best of your abilities. From overcoming objections from customers,
                            to providing the latest cruises Royal Caribbean has to offer - Genie
                            AI’s there to help you every step of the way.`,
            genieAIBackButtonPopup: "Go back",
            genieAINextButtonPopup: "Chat to Genie AI",
            askGenieAi: "Ask Genie AI",
            acceptGenieAiTitle: "Acceptable Use Notice",
            acceptGenieAiText: "Before using Genie AI, please read our ",
            acceptGenieAiConfirm: "I’ve read and accept the Acceptable Use Notice.",
            archiveSuitcaseTitle: "Archive this suitcase",
            archiveSuitcaseText:
                "Only close this suitcase if your customer has decided they are not purchasing a cruise. This suitcase will be moved into ‘Past Suitcases’.",
            archiveSuitcaseButton: "I’m sure, close the suitcase",
            continueText: "Continue",
            closedSuitcaseHereText: "Closed suitcases live here.",
            viewArchived: "View archived suitcase",
            acceptableGenieTitle: "ACCEPTABLE USE NOTICE",
            acceptableGenieText:
                "Genie AI is provided to support partner sales enablement only. It is a support tool and not an authoritative source.<br /><br />Genie AI outputs may be inaccurate, incomplete or out of date.<br /><br />You are responsible for verifying all Genie AI outputs before any onward use. If an output appears inaccurate, you should escalate to your Royal Caribbean Trade Representative.<br /><br />You will not use Genie AI for personal or unrelated activities.<br /><br />You will not share personal or otherwise confidential data including passwords, financial details, or customer information.<br /><br />You will not use Genie AI to create or share anything unlawful, offensive, or harmful. This includes discriminatory, misleading, or inappropriate content.<br /><br />You will not use Genie AI for pricing confirmations, regulatory, legal, or compliance advice.<br /><br />You must not reproduce, forward, publish, rely on, or otherwise share any Genie AI output that contains factual representations in any customer‑facing communication (including emails, marketing materials, sales messages, or verbal advice) unless you have independently verified that the information is accurate, complete, and appropriate by checking it against official Royal Caribbean sources. You remain fully responsible for any statements or representations you make to consumers.<br /><br />Your use of Genie AI is subject to the Terms and Conditions and Privacy Notice.",
        },
        nordics: {
            headerTitle: "Closing Lounge",
            headerCaption:
                "Your space to close the deal, fuel the excitement, and get the booking over the line.",
            tab1: "Active Suitcases",
            tab2: "Booked Cruises",
            tab3: "Past Suitcases",
            reachOut: "REACH OUT TO GENIE AI",
            reachOutDesc:
                "Review your selections and make sure everything's ready before sharing with your customer.",
            bookingAlreadySubmited: "Booking Already submitted",
            yes: "Yes",
            no: "No",
            genieAITitlePopup: "WHAT is GENIE AI?",
            genieAIDescPopup: `Genie AI is a chatbot that has been trained to help you sell cruises to
                            the best of your abilities. From overcoming objections from customers,
                            to providing the latest cruises Royal Caribbean has to offer - Genie
                            AI’s there to help you every step of the way.`,
            genieAIBackButtonPopup: "Go back",
            genieAINextButtonPopup: "Chat to Genie AI",
        },
        es: {
            headerTitle: "Cierra la venta",
            headerCaption:
                "Tu espacio para cerrar el trato, aumentar la emoción y concretar la reserva",
            tab1: "Maletas de vacaciones disponibles ",
            tab2: "Cruceros reservados",
            tab3: "Maletas archivadas",
            reachOut: "Consulta más información con GENIE AI",
            reachOutDesc:
                "Revisa tu selección y asegúrate de que todo esté listo antes de compartirlo con tu cliente.",
            chatAiBtn: "Conacta con Genie AI",
            activeSuitcase: "Tus maletas de vacaciones actuales",
            sortBy: "Ordenar por",
            name: "Nombre",
            created: "Creado",
            status: "Estado",
            cruise: "Crucero",
            closeSuitcase: "Archivar maleta",
            yes: "Sí",
            no: "No",
            noLead: "Sin estado",
            hotLead: "Cliente muy interesado",
            warmLead: "Cliente potencial",
            viewExperience: "Ver la experiencia del cliente",
            lastOpened: "Abierto por última vez",
            neededInspiration: "Abrir maleta",
            readyForGenieAi: "¿Objeciones de precio?",
            activeSuitcaseBoxOneDesc:
                "Obtén consejos de ventas al instante, apoyo para manejar Objeciones de precio y sugerencias para cerrar la venta adaptadas a tu cliente.",
            activeSuitcaseBoxOneBtn: "Conoce Genie AI",
            activeSuitcaseBoxTwoTitle: "¿Necesitas ayuda para cerrar la reserva?",
            activeSuitcaseBoxTwoDesc:
                "Genie AI te ayuda a redactar el tipo de mensaje que entusiasma a los clientes: rápido, amigable y listo para reservar.",
            activeSuitcaseBoxTwoBtn: "Prueba Genie AI",
            bookedCruises: "Tus cruceros reservados",
            bookingId: "Número de reserva:",
            dateOfDep: "Fecha de salida",
            upperDeck: "¿BANNER DE CUBIERTA SUPERIOR?",

            upperDeckLogoText: "Cubierta Superior",
            upperDeckTitle: "Llena tu bolsillo de recompensas",
            upperDeckSubtitle: "Obtén más de tus reservas.",
            upperDeckButton: "Ir a la cubierta superior",
            toAdvise: "Royal Caribbean aconsejará",
            pastSuitcases: "Tus Cruceros anteriores",
            settingSail: "¿Preparado para zarpar?",
            noData: "Sin datos",
            usersSuitcase: "Maleta de vacaciones de",
            awaitingFeedback: "A la espera de recibir la opinión de tu cliente",
            awaitingFeedbackText: "aún no ha enviado su opinión.",
            awaitingFeedbackDesc:
                "Aunque al cliente no le haya gustado ninguno de los cruceros en su maleta, aún podrías ponerte en contacto para ver si puedes ayudarle de alguna otra manera",
            letCloseIt: "¡Cierra la venta!",
            letCloseItDesc:
                "ha visto las recomendaciones y le han gustado los siguientes itinerarios. Utiliza Genie AI <br /> a continuación para hacer seguimiento y cerrar la reserva.",
            confirmBooking: "Confirmar reserva",
            closeThisCruise: "Ayúdame a cerrar este crucero",
            suitcaseItinerary: "Maletas de vacaciones",
            noSuitcases: "No Maletas",
            itsMatch: "¡Es un acierto!",
            nowLetCloseIt: "Ahora vamos a cerrarlo.",
            returnTo: "Volver a la maleta vacaciones de",
            closingCongrat:
                "¡Felicidades por haber encontrado la opción de crucero perfecta para tu cliente! Ahora es momento de convertir este sueño en una realidad. Con la ayuda de",
            closingCongratSecond:
                "puedes hacer todas las preguntas que necesites para cerrar la venta. Comienza a preguntar o utiliza nuestras sugerencias a continuación:",
            questionOne: "¿Cómo puedo superar las objeciones del cliente?",
            questionTwo: "¿Cómo puedo cerrar esta reserva?",
            enterBookId: "Introduce el ID de reserva",
            enterBookText:
                "¡El último paso! Por favor, introduce a continuación tu ID de reserva y selecciona el barco en el que navegará tu cliente. Asegúrate de haber introducido el ID correcto, ya que una vez enviado, no se puede deshacer.",
            bookId: "ID DE RESERVA",
            selectShip: "Selecciona el barco",
            congratulations: "¡Felicidades!",
            congratulationsDesc:
                "Has enviado con éxito tu ID de reserva y coincide con una reserva en nuestro sistema.",
            noBookingFound: "No se encontró ninguna reserva.",
            noBookingFoundDesc:
                "Los datos que ha proporcionado no coinciden con ninguna reserva que tengamos. Por favor, compruebe sus datos de nuevo.",
            bookingAlreadySubmited: "La reserva ya ha sido enviada.",
            bookingAlreadySubmitedDesc:
                "Los datos que ha proporcionado indican que esta reserva ya ha sido enviada y confirmada. Por favor, introduzca una reserva válida que no haya sido enviada o compruebe sus datos de nuevo.",
            backToSuitcase: "Volver a la maleta de vacaciones ",
            hi: "Hola",
            pitchFirstParagraphEmailFun:
                "He preparado una selección de cruceros de Royal Caribbean hechos a tu medida. Estas opciones traen sol, energía y momentos inolvidables, y cada una ofrece su propio estilo de aventura. Aquí tienes un vistazo rápido de lo que te espera.",
            pitchSecondParagraphEmailFun:
                "Tu propuesta personalizada con todos los detalles de los: ",
            pitchSecondParagraphEmailFunEnd: " cruceros está lista aquí:",
            pitchSecondParagraphEmailFunSingle:
                "Tu propuesta personalizada con todos los detalles está lista aquí:",
            pitchThirdParagraphEmailFun:
                "Si alguno de estos cruceros te llama la atención, puedo ayudarte a comparar los detalles o a gestionar todo. Solo dime qué tienes en mente y empezaremos a planificar una escapada inolvidable.",
            pitchFirstParagraphEmailFriendly:
                "He seleccionado varios cruceros de Royal Caribbean que sé que te van a gustar. Cada itinerario une destinos increíbles con experiencias a bordo memorables, y estoy encantado de compartirlos contigo. Aquí tienes un resumen rápido. ",
            pitchThirdParagraphEmailFriendly:
                "Si alguno te cuadra o quieres ayuda para decidir, estoy aquí para ayudarte cuando me necesites. Dímelo y exploramos qué te gustaría ver.",
            pitchFirstParagraphEmailProfessinal:
                "He preparado varios itinerarios de Royal Caribbean adaptados a sus preferencias. Cada itinerario ofrece una buena mezcla de destinos y experiencias a bordo. Aquí tiene un resumen breve para su revisión.",
            pitchThirdParagraphEmailProfessinal:
                "Si quiere ayuda para comparar, ajustar fechas o cerrar la reserva, estoy disponible para asistirle. Por favor, díganos cómo quiere proceder.",

            pitchFirstParagraphMessageFun:
                "He seleccionado algunos cruceros de Royal Caribbean pensados para ti. Cada itinerario está cargado de sol, energía y momentos inolvidables. Aquí tienes las opciones destacadas. ",
            pitchThirdParagraphMessageFun:
                "Dime cuál te gusta más o te ayudo a reducirlas. ¡Vamos a preparar unas vacaciones increíbles!",

            pitchFirstParagraphMessageFriendly:
                "He seleccionado varias opciones de cruceros de Royal Caribbean que seguro te van a gustar. Cada itinerario ofrece destinos memorables y experiencias a bordo para relajarte. Aquí tienes un resumen rápido.",
            pitchThirdParagraphMessageFriendly:
                "Si alguno te interesa, te puedo ayudar a comparar y elegir la mejor opción. Dime cuándo quieres avanzar.",

            pitchFirstParagraphMessageProfessional:
                "Le presento las opciones de cruceros de Royal Caribbean que he seleccionado para usted. Cada itinerario ofrece una mezcla equilibrada de destinos y características a bordo. Por favor, revise los detalles a continuación.",
            pitchThirdParagraphMessageProfessional:
                "Si necesita más información o desea avanzar con la reserva, díganos y con gusto le ayudaré.",

            pitchFirstParagraphSocialFun:
                "I have picked out some amazing Royal Caribbean cruises that match what you are looking for. These sailings bring sunshine, adventure, and big holiday energy. Take a look.",
            pitchThirdParagraphSocialFun:
                "If one of these catches your eye, I can help you get everything arranged. Let us build a holiday worth talking about.",

            pitchFirstParagraphSocialFriendly:
                "He reunido algunos cruceros de Royal Caribbean que podrían encantarte. Cada uno ofrece destinos geniales y experiencias a bordo asombrosas. Esto es lo que te espera. ",
            pitchThirdParagraphSocialFriendly:
                "Si alguno te llama la atención, te puedo ayudar a dar los siguientes pasos. Dímelo y vemos qué quieres explorar.",

            pitchFirstParagraphSocialProfessional:
                "He preparado varias rutas de Royal Caribbean que encajan con lo que buscas para tu viaje. Cada itinerario combina destinos destacados y experiencias a bordo. Este es un breve resumen.",
            pitchThirdParagraphSocialProfessional:
                "Si quieres más información o ayuda para evaluar estas opciones, o para reservar, estoy a tu disposición. Contáctame cuando te venga bien.",

            speakSoon: "Hablamos pronto,",
            aiChatDesc:
                "Genie AI puede ayudarte a superar cualquier dificultad que enfrentes al intentar vender cruceros. Pregúntale a Genie AI todo lo que desees o inspírate un poco con los botones de abajo.",
            aiChatTitle: "CHATEA CON GENIE AI",
            genieAITitlePopup: "¿QUÉ es GENIE AI?",
            genieAIDescPopup: `Genie AI es un chatbot entrenado para ayudarte a vender cruceros
de la mejor manera posible. Desde superar objeciones de los clientes
hasta ofrecer los cruceros más recientes de Royal Caribbean,
Genie AI está contigo en cada paso del proceso.`,
            genieAIBackButtonPopup: "Volver",
            genieAINextButtonPopup: "Chatear con Genie AI",
            askGenieAi: "Pregúntale a Genie AI",
            acceptGenieAiTitle: "Aviso De Uso Aceptable",
            acceptGenieAiText: "Antes de usar Genie AI, por favor lea nuestro ",
            acceptGenieAiConfirm: "He leído y acepto los Términos de Uso Aceptable.",
            archiveSuitcaseTitle: "Archivar esta maleta",
            archiveSuitcaseText:
                "Solo cierre esta maleta si su cliente ha decidido que no va a comprar un crucero. Esta maleta se moverá a ‘Maletas anteriores’.",
            archiveSuitcaseButton: "Estoy seguro, cerrar la maleta",
            continueText: "Continuar",
            closedSuitcaseHereText: "Las maletas cerradas se encuentran aquí.",
            viewArchived: "Ver maleta archivada",
            acceptableGenieTitle: "AVISO DE USO ACEPTABLE",
            acceptableGenieText:
                "Genie AI se proporciona únicamente para apoyar la capacitación de ventas para partners. Es una herramienta de apoyo y no una fuente autorizada.<br /><br />Las respuestas de Genie AI pueden ser inexactas, incompletas o estar desactualizadas.<br /><br />Usted es responsable de verificar todas las respuestas de Genie AI antes de utilizarlas. Si una respuesta parece inexacta, debe escalarla a su Representante Comercial de Royal Caribbean.<br /><br />No utilizará Genie AI para actividades personales ni no relacionadas.<br /><br />No compartirá datos personales ni información confidencial, incluidos contraseñas, datos financieros o información de clientes.<br /><br />No utilizará Genie AI para crear o compartir contenido ilegal, ofensivo o perjudicial. Esto incluye contenido discriminatorio, engañoso o inapropiado.<br /><br />No utilizará Genie AI para confirmaciones de precios ni para asesoramiento regulatorio, legal o de cumplimiento.<br /><br />No debe reproducir, reenviar, publicar, confiar en ni compartir ninguna respuesta de Genie AI que contenga afirmaciones de hechos en comunicaciones dirigidas al cliente (incluidos correos electrónicos, materiales de marketing, mensajes de ventas o asesoramiento verbal) a menos que haya verificado de forma independiente que la información es precisa, completa y adecuada, comprobándola con las fuentes oficiales de Royal Caribbean. Usted sigue siendo completamente responsable de cualquier declaración o representación que haga a los consumidores.<br /><br />El uso de Genie AI está sujeto a los Términos y Condiciones y al Aviso de Privacidad.",
        },
    },
    pitchIt: {
        en: {
            superchargeTitle: "SUPERCHARGE YOUR PITCH",
            superchargeDesc:
                "You've built their dream getaway — now let's pitch it with confidence. Whether it's a fun message, a friendly note, or a professional email, Genie will help you craft something that gets them booking",
            howSending: "How will you be sending this pitch?",
            methodEmail: "Email",
            methodMessage: "Message",
            methodMessageSubtitle: "(imessage, whatsapp etc)",
            methodSocialPost: "Social post",
            whatTone: "What tone do you want to convey in the pitch?",
            toneFun: "fun",
            toneFriendly: "friendly",
            toneProfessional: "professional",
            generateBtn: "Generate pitch with Genie AI",
            generating: "GENERATING...",
            didYouKnow: "Did you know",
            editTitle: "EDIT YOUR PITCH",
            editDesc: "Click the button below once you're finished editing.",
            pitchReadyTitle: "Your Pitch Is Good to Go",
            pitchReadyDesc:
                "Your message is ready to share. Copy it, tweak it, or let Genie polish it further — your customer's dream cruise is just a click away.",
            copiedToClipboard: "Copied to clipboard!",
            copyBtn: "Copy to clipboard",
            editBtn: "Edit Pitch",
            backToSuitcase: "Go back to suitcase",
            finishEditingBtn: "Finish editing",
        },
        es: {
            superchargeTitle: "Potencia tu discurso de venta",
            superchargeDesc:
                "Has creado el mejor plan de vacaciones para tu cliente — ahora vamos a presentarla con confianza. Ya sea un mensaje divertido, una nota amigable o un correo profesional, Genie te ayudará a redactar algo que les haga reservar.",
            howSending: "¿Cómo vas a enviar este discurso de venta?",
            methodEmail: "Correo electrónico",
            methodMessage: "Mensaje",
            methodMessageSubtitle: "(iMessage, WhatsApp, etc.)",
            methodSocialPost: "Publicación en redes sociales",
            whatTone: "¿Qué tono quieres transmitir en tu discurso de venta?",
            toneFun: "Divertido",
            toneFriendly: "Familiar",
            toneProfessional: "Profesional",
            generateBtn: "Genera el discurso de venta con Genie AI",
            generating: "Generando...",
            didYouKnow: "¿Sabías que",
            editTitle: "Edita el discurso de venta",
            editDesc: "Haz clic en el botón de abajo cuando hayas terminado de editar.",
            pitchReadyTitle: "Tu discurso de venta está listo para usarse",
            pitchReadyDesc:
                "Tu mensaje está listo para compartir. ¡Si necesitar editar el mensaje antes de enviarlo hazlo!",
            copiedToClipboard: "¡Copiado al portapapeles!",
            copyBtn: "Copiar el mensaje",
            editBtn: "Edita el discurso de venta",
            backToSuitcase: "Volver a la maleta de vacaciones",
            finishEditingBtn: "Acaba de editarlo",
        },
        nordics: {
            superchargeTitle: "SUPERCHARGE YOUR PITCH",
            superchargeDesc:
                "You've built their dream getaway — now let's pitch it with confidence. Whether it's a fun message, a friendly note, or a professional email, Genie will help you craft something that gets them booking",
            howSending: "How will you be sending this pitch?",
            methodEmail: "Email",
            methodMessage: "Message",
            methodMessageSubtitle: "(imessage, whatsapp etc)",
            methodSocialPost: "Social post",
            whatTone: "What tone do you want to convey in the pitch?",
            toneFun: "fun",
            toneFriendly: "friendly",
            toneProfessional: "professional",
            generateBtn: "Generate pitch with Genie AI",
            generating: "GENERATING...",
            didYouKnow: "Did you know",
            editTitle: "EDIT YOUR PITCH",
            editDesc: "Click the button below once you're finished editing.",
            pitchReadyTitle: "Your Pitch Is Good to Go",
            pitchReadyDesc:
                "Your message is ready to share. Copy it, tweak it, or let Genie polish it further — your customer's dream cruise is just a click away.",
            copiedToClipboard: "Copied to clipboard!",
            copyBtn: "Copy to clipboard",
            editBtn: "Edit Pitch",
            backToSuitcase: "Go back to suitcase",
            finishEditingBtn: "Finish editing",
        },
    },
    holidaySuitcase: {
        en: {
            titleHolidaySuitcase: "HOLIDAY SUITCASE",
            captionHolidaySuitcase:
                "Check out the new ‘Pitch it’ button below, helping you sell the cruise to every customer, no matter their needs.",
            textItineraries: "Itineraries",
            textItinerary: "Itinerary",
            textItinerariesSmall: "itineraries",
            textItinerarySmall: "itinerary",
            textSelectedForItineraries: "selected for",
            textSelectedForItinerary: "selected for",
            textEditItinerariesSmall: "Edit itineraries",
            textEditItinerarySmall: "Edit itinerary",
            textSelectedItinerariesSmall: "Selected itineraries",
            textSelectedItinerarySmall: "Selected itinerary",
            textEdit: "Edit",
            textCancel: "Cancel",
            buttonUpdate: "UPDATE",
            textPreview: (
                <>
                    Preview exactly what your customer will see when{" "}
                    <br className="hidden desktop:block" />
                    they open your personalised Holiday Suitcase.
                </>
            ),
            buttonPreview: "Preview Experience",
            textShare: (
                <>
                    You’ve built the dream — now share it! Copy your customer’s personalised Royal
                    Caribbean link and send it your way.
                </>
            ),
            buttonCopyLink: "Copy Link",
            buttonCopied: "Copied",
            getStartedTitle: (
                <>
                    ADD A NEW <br className="hidden ipad:block" />
                    ITINERARY
                </>
            ),
            getStartedCaption: "to wow your next customer",
            addMoreCruises: "Add more cruises to this suitcase",
            previewExperience: "Preview the experience",
            previewDesc:
                "Review your selections and make sure everything's ready before sharing with your customer.",
            yourQrCode: "YOUR QR CODE",
            saveQrCode: "Save QR Code",
            pitchIt: "Pitch It",
            pitchItDesc:
                "Every customer is different, so let’s make this pitch speak their language.",
            readyToShare: "Ready to share?",
            readyToShareDesc:
                "You've built the dream — now share it! Copy your customer's personalised Royal Caribbean link and send it your way.",
            linkCopied: "Link copied",
            readyToShareTitle: "READY TO SHARE?",
            yourPitchSupercharged: "YOUR PITCH, SUPERCHARGED",
            yourPitchSuperchargedDesc:
                "Genie AI helps you write the kind of message that gets customers excited — fast, friendly, and ready to book.",
            buildMyPitch: "Build my pitch",
            startAfresh: "START AFRESH",
            createSuitcaseNext: "Create a suitcase for your next customer",
        },
        nordics: {
            titleHolidaySuitcase: "HOLIDAY SUITCASE",
            captionHolidaySuitcase:
                "Check out the new ‘Pitch it’ button below, helping you sell the cruise to every customer, no matter their needs.",
            textItineraries: "Itineraries",
            textItinerary: "Itinerary",
            textItinerariesSmall: "itineraries",
            textItinerarySmall: "itinerary",
            textSelectedForItineraries: "selected for",
            textSelectedForItinerary: "selected for",
            textEditItinerariesSmall: "Edit itineraries",
            textEditItinerarySmall: "Edit itinerary",
            textSelectedItinerariesSmall: "Selected itineraries",
            textSelectedItinerarySmall: "Selected itinerary",
            textEdit: "Edit",
            textCancel: "Cancel",
            buttonUpdate: "UPDATE",
            textPreview: (
                <>
                    Preview exactly what your customer will see when{" "}
                    <br className="hidden desktop:block" />
                    they open your personalised Holiday Suitcase.
                </>
            ),
            buttonPreview: "Preview Experience",
            textShare: (
                <>
                    You’ve built the dream — now share it! Copy your customer’s personalised Royal
                    Caribbean link and send it your way.
                </>
            ),
            buttonCopyLink: "Copy Link",
            buttonCopied: "Copied",
            getStartedTitle: (
                <>
                    ADD A NEW <br className="hidden ipad:block" />
                    ITINERARY
                </>
            ),
            getStartedCaption: "to wow your next customer",
            addMoreCruises: "Add more cruises to this suitcase",
            previewExperience: "Preview the experience",
            previewDesc:
                "Review your selections and make sure everything's ready before sharing with your customer.",
            yourQrCode: "YOUR QR CODE",
            saveQrCode: "Save QR Code",
            pitchIt: "Pitch It",
            pitchItDesc:
                "Every customer is different, so let's make this pitch speak their language. Choose who you're selling to and Genie will help you tailor the message that wows",
            readyToShare: "Ready to share?",
            readyToShareDesc:
                "You've built the dream — now share it! Copy your customer's personalised Royal Caribbean link and send it your way.",
            linkCopied: "Link copied",
            readyToShareTitle: "READY TO SHARE?",
            yourPitchSupercharged: "YOUR PITCH, SUPERCHARGED",
            yourPitchSuperchargedDesc:
                "Genie AI helps you write the kind of message that gets customers excited — fast, friendly, and ready to book.",
            buildMyPitch: "Build my pitch",
            startAfresh: "START AFRESH",
            createSuitcaseNext: "Create a suitcase for your next customer",
        },
        es: {
            titleHolidaySuitcase: "LA MALETA DE VACACIONES DE",
            captionHolidaySuitcase:
                "Echa un vistazo al nuevo botón 'Véndelo' a continuación, que te ayuda a vender el crucero a cada cliente, sin importar sus necesidades.",
            textItineraries: "Itinerarios",
            textItinerary: "Itinerarios",
            textItinerariesSmall: "itinerarios",
            textItinerarySmall: "itinerario",
            textSelectedForItineraries: "seleccionado por",
            textSelectedForItinerary: "seleccionado para",
            textEditItinerariesSmall: "Editar itinerarios",
            textEditItinerarySmall: "Editar itinerario",
            textSelectedItinerariesSmall: "Itinerarios seleccionado",
            textSelectedItinerarySmall: "Itinerario seleccionado",
            textEdit: "Editar",
            textCancel: "Cancelar",
            buttonUpdate: "ACTUALIZAR",
            textPreview:
                "Vista previa de lo que verá tu cliente cuando abra tu maleta de vacaciones personalizada.",
            buttonPreview: "Vista previa de la Experiencia",
            textShare:
                "¿Listo para compartir su maleta de vacaciones? Copia la dirección de la web que verás a continuación para enviarla a tu cliente.",
            buttonCopyLink: "Copia el link",
            buttonCopied: "Copiado",
            getStartedTitle: "AÑADE UN NUEVO ITINERARIO",
            getStartedCaption: "para sorprender a tu próximo cliente",
            addMoreCruises: "Añade más cruceros en esta maleta de vacaciones",
            previewExperience: "Vista previa de la experiencia",
            previewDesc:
                "Revisa los itinerarios y asegúrate de que todo esté preparado antes de compartirlo con tu cliente.",
            yourQrCode: "TU CÓDIGO QR",
            saveQrCode: "Guardar código QR",
            pitchIt: "Véndelo",
            pitchItDesc:
                "Cada cliente es diferente, así que hagamos que esta propuesta hable su idioma. Elige a quién le estás vendiendo y Genie te ayudará a adaptar el mensaje para que impresione.",
            readyToShare: "¿Listo para compartir?",
            readyToShareDesc:
                "Has creado el viaje soñado; ahora compártelo. Copia el enlace personalizado de Royal Caribbean de tu cliente y envíalo al cliente.",
            linkCopied: "Enlace copiado",
            readyToShareTitle: "¿LISTO PARA COMPARTIR?",
            yourPitchSupercharged: "TU DISCURSO DE VENTA PERFECCIONADO",
            yourPitchSuperchargedDesc:
                "Genie AI te ayuda a redactar el tipo de mensaje que entusiasma a los clientes: rápido, amigable y listo para reservar.",
            buildMyPitch: "Crear mi discurso de venta",
            startAfresh: "EMPIEZA DE NUEVO",
            createSuitcaseNext: "Crea una maleta para tu próximo cliente",
        },
    },
    genieAi: {
        en: {
            placeholder: "Ask away!",
        },
        es: {
            placeholder: "¡Pregunta lo que quieras!",
        },
        nordics: {
            placeholder: "Ask away!",
        },
    },
    forms: {
        en: {
            yourName: "Your Name",
            firstName: "First Name",
            lastName: "Last Name",
            emailAddress: "Email address",
            buildBespokeTitle: "Your Name",
            buildBespokeDesc:
                "To build a bespoke holiday for you, let's start by personalising it.",
            buildBespokeDescFull:
                "To build a bespoke holiday for you, let's start by personalising it.<br />Please fill out your personal information below.",
        },
        es: {
            yourName: "Tu nombre",
            firstName: "Nombre",
            lastName: "Apellido",
            emailAddress: "Correo electrónico",
            buildBespokeTitle: "Tu nombre",
            buildBespokeDesc:
                "Para crear unas vacaciones a medida para ti, empecemos por personalizarlas.",
            buildBespokeDescFull:
                "Para crear unas vacaciones a medida para ti, empecemos por personalizarlas.<br />Por favor, completa tu información personal a continuación.",
        },
        nordics: {
            yourName: "Your Name",
            firstName: "First Name",
            lastName: "Last Name",
            emailAddress: "Email address",
            buildBespokeTitle: "Your Name",
            buildBespokeDesc:
                "To build a bespoke holiday for you, let's start by personalising it.",
            buildBespokeDescFull:
                "To build a bespoke holiday for you, let's start by personalising it.<br />Please fill out your personal information below.",
        },
    },
    account: {
        en: {
            Account: "Account",
            Password: "Password",
            Logout: "Logout",
            Update: "Update",
            placeholderFirstName: "First Name*",
            placeholderLastName: "Last Name*",
            placeholderAgencyName: "Agency Name",
            placeholderAgencyID: "Agency ID*",
            placeholderABTA: "ABTA*",
            placeholderAgencyPhoneNumber: "Agency Phone Number",
            placeholderTypeName: "Type Name*",
            textUploadNewLogo: "Upload New Logo",
            textMaxFileSize: "Max. File Size: 500kb.",
            textLogoDescription:
                "This logo will be used on the image on the contact details of your experiences.",
            placeholderContactPhoneNumber: "Contact Phone Number*",
            validationContactPhoneNumber: "Please specify valid phone number",
            placeholderWorkEmail: "Work Email*",
            validationWorkEmail: "Please specify valid email",
            placeholderOldPassword: "Old Password*",
            placeholderPassword: "Password*",
            textPasswordRules: "Please make sure your password has:",
            textPasswordRulesListOne: "Minimum of 8 characters",
            textPasswordRulesListTwo: "One upper case character",
            textPasswordRulesListThree: "One special character",
            placeholderReenterPassword: "Re-enter Password*",
            validationPasswordDoesNotMatch: "Password does not match",
            textLogoutConfirmation: "Are you sure you want to logout of",
            textCMS: "Content Management System",
            textMRG: "My Royal Genie",
            logo: "Logo",
        },
        nordics: {
            Account: "Account",
            Password: "Password",
            Logout: "Logout",
            Update: "Update",
            placeholderFirstName: "First Name*",
            placeholderLastName: "Last Name*",
            placeholderAgencyName: "Agency Name",
            placeholderAgencyID: "Agency ID*",
            placeholderABTA: "ABTA*",
            placeholderAgencyPhoneNumber: "Agency Phone Number*",
            placeholderTypeName: "Type Name*",
            textUploadNewLogo: "Upload New Logo",
            textMaxFileSize: "Max. File Size: 500kb.",
            textLogoDescription:
                "This logo will be used on the image on the contact details of your experiences.",
            placeholderContactPhoneNumber: "Contact Phone Number*",
            validationContactPhoneNumber: "Please specify valid phone number",
            placeholderWorkEmail: "Work Email*",
            validationWorkEmail: "Please specify valid email",
            placeholderOldPassword: "Old Password*",
            placeholderPassword: "Password*",
            textPasswordRules: "Please make sure your password has:",
            textPasswordRulesListOne: "Minimum of 8 characters",
            textPasswordRulesListTwo: "One upper case character",
            textPasswordRulesListThree: "One special character",
            placeholderReenterPassword: "Re-enter Password*",
            validationPasswordDoesNotMatch: "Password does not match",
            textLogoutConfirmation: "Are you sure you want to logout of",
            textCMS: "Content Management System",
            textMRG: "My Royal Genie",
            logo: "Logo",
        },
        es: {
            Account: "Cuenta",
            Password: "Contraseña",
            Logout: "Salir",
            Update: "Actualizar",
            placeholderFirstName: "Nombre de pila*",
            placeholderLastName: "Apellido*",
            placeholderAgencyName: "Nombre de la agencia",
            placeholderAgencyID: "ID de agencia*",
            placeholderABTA: "ABTA*",
            placeholderAgencyPhoneNumber: "Número de teléfono de la agencia*",
            placeholderTypeName: "Escriba Nombre*",
            textUploadNewLogo: "Subir nuevo logotipo",
            textMaxFileSize: "Tamaño máximo de archivo: 500 kb.",
            textLogoDescription:
                "Este logotipo se utilizará en la imagen de los datos de contacto de tus experiencias.",
            placeholderContactPhoneNumber: "Número de teléfono de contacto*",
            validationContactPhoneNumber: "Por favor especifique un número de teléfono válido",
            placeholderWorkEmail: "Correo electrónico de trabajo*",
            validationWorkEmail: "Por favor, especifique un correo electrónico válido",
            placeholderOldPassword: "Contraseña anterior",
            placeholderPassword: "Contraseña nueva",
            textPasswordRules: "Por favor asegúrese de que su contraseña tenga:",
            textPasswordRulesListOne: "Mínimo de 8 caracteres",
            textPasswordRulesListTwo: "Un carácter en mayúscula",
            textPasswordRulesListThree: "Un carácter especial",
            placeholderReenterPassword: "Escriba de nuevo su contraseña",
            validationPasswordDoesNotMatch: "La contraseña no coincide",
            textLogoutConfirmation: "¿Seguro que quieres salir de",
            textCMS: "Content Management System",
            textMRG: "My Royal Genie",
            logo: "Logotipo",
        },
    },
    contactUs: {
        en: {
            headingContact: "Contact Us",
            textGotAQuestion: "Got a question?",
            textGetInTouchNordics:
                "Simply get in touch using the form below and we will get right back to you. Please note, our opening hours are 9am to 4pm, Monday to Friday. We aim to respond to all queries within 48 hours (2 working days) and we regret the delay over the non-working hours.",
            textGetInTouch:
                "Simply get in touch using the form below and we will get right back to you. Please note, our opening hours are 9am to 5:30pm, Monday to Friday. We aim to respond to all queries within 48 hours (2 working days) and we regret the delay over the non-working hours.",
            textThankYou:
                "Thank you for your enquiry, we will get back to you as soon as possible.",
            placeholderFirstName: "First Name*",
            placeholderSurname: "Surname*",
            placeholderEmail: "Email*",
            placeholderSubject: "Subject*",
            placeholderEnquiry: "Enquiry*",
            buttonSend: "SEND",
        },
        nordics: {
            headingContact: "Contact Us",
            textGotAQuestion: "Got a question?",
            textGetInTouchNordics:
                "Simply get in touch using the form below and we will get right back to you. Please note, our opening hours are 9am to 4pm, Monday to Friday. We aim to respond to all queries within 48 hours (2 working days) and we regret the delay over the non-working hours.",
            textGetInTouch:
                "Simply get in touch using the form below and we will get right back to you. Please note, our opening hours are 9am to 5:30pm, Monday to Friday. We aim to respond to all queries within 48 hours (2 working days) and we regret the delay over the non-working hours.",
            textThankYou:
                "Thank you for your enquiry, we will get back to you as soon as possible.",
            placeholderFirstName: "First Name*",
            placeholderSurname: "Surname*",
            placeholderEmail: "Email*",
            placeholderSubject: "Subject*",
            placeholderEnquiry: "Enquiry*",
            buttonSend: "SEND",
        },
        es: {
            headingContact: "Contacta con nosotros",
            textGotAQuestion: "¿Tienes alguna pregunta?",
            textGetInTouchNordics:
                "Ponte en contacto con nosotros a través del formulario que verás a continuación. Te responderemos a la mayor brevedad posible. Nuestro horario es de 9am a 4pm de lunes a viernes. Intentamos responder en un plazo de 48 horas (dos días laborables). Sentimos el retraso si estamos fuera de horario.",
            textGetInTouch:
                "Ponte en contacto con nosotros a través del formulario que verás a continuación. Te responderemos a la mayor brevedad posible. Nuestro horario es de 9am a 5:30 pm de lunes a viernes. Intentamos responder en un plazo de 48 horas (dos días laborables). Sentimos el retraso si estamos fuera de horario.",
            textThankYou: "Gracias por su consulta, nos comunicaremos con usted lo antes posible.",
            placeholderFirstName: "Nombre*",
            placeholderSurname: "Apellidos*",
            placeholderEmail: "Correo electrónico*",
            placeholderSubject: "Asunto*",
            placeholderEnquiry: "Consulta*",
            buttonSend: "ENVIAR",
        },
    },
    buildMyHoliday: {
        en: {
            headingGetStarted: "Get Started",
            headingBuildAHoliday: "Build a Holiday",
            textBuildAHoliday: "For your customers",
            buttonPrevious: "Back",
            textAddHolidayToSuitcase: "Add to Suitcase",
            textAddedHolidayToSuitcase: "Added to Suitcase",
            textAddedHolidayToSuitcase: "Added to Suitcase",
            textSeeResults: "See Results",
            textNext: "Next",
            headingYourCustomerName: "Your Customer's Name",
            textFormCaption:
                "To build a bespoke holiday for your customer, let's start by personalising it to them. What's their name?",
            textWhatsTheirName: "What's their name?",
            placeholderCustomerName: "ENTER NAME HERE",
            validationName:
                "Your customer's name cannot include profanity, please enter something else.",
            headingWhen: "When?",
            textWhen: "What year are they interested in taking their holiday?",
            textWhatMonth: "What months of the year are they considering?",
            textSelectApply: "Please select all that apply",
            headerWho: "Who?",
            textWho: "What type of group is your customer a part of?",
            textChoice: "Will your guest require accessibility support during their cruise?",
            textChoiceApply: "For example wheelchair accessible room, hearing kit etc",
            headingWhere: "Where?",
            textWhere: "What locations are they interested in?",
            textWhatDeparturePort: "What departure port do they want to travel from?",
            headingHowLong: "Duration?",
            textHowLong: "How many nights would they like to be on holiday for?",
            placeholderShip: "Filter via Ship",
            placeholderAll: "All",
            placeholderItineraryName: "Itinerary Name",
            placeholderStartDate: "Start Date",
            placeholderEndDate: "End Date",
            buttonResetDate: "Reset Date",
            headingResults: "Results",
            textResults: "Match the perfect itineraries",
            textSelectHolildays:
                "Please select the holidays that you'd like to send to your customer - these will be added to their Holiday Suitcase.",
            headingNoResults: "No Results",
            textNoResults:
                "No holidays match your search criteria at the moment, please go back and adjust your itinerary search.",
            headingNoResults2: "That ship has already sailed...",
            textNoResults2:
                "The parameters you’ve selected have returned zero results. Use the results bar above to go back and make changes to your selections.",

            noResultBox1Title: "If the departure port you’ve selected is non-negotiable",
            noResultBox1Text: "Try a different ship or date of departure.",
            noResultBox2Title: "If the ships you’ve selected is non-negotiable",
            noResultBox2Text: "Try a different date of departure.",
            noResultBox3Title: "If the DATE OF DEPARTURE IS NON-NEGOTIABLE",
            noResultBox3Text: "Try a different ship or departure port.",
            textConfirmationOne: "Would you like to add these itineraries to",
            textConfirmationTwo: "'s suitcase, or create a brand new suitcase?",
            buttonCreateNewSuitcase: "Create New Suitcase",
            buttonAddToCurrentSuitcase: "Add to Current Suitcase",
            january: "January",
            february: "February",
            march: "March",
            april: "April",
            may: "May",
            june: "June",
            july: "July",
            august: "August",
            september: "September",
            october: "October",
            november: "November",
            december: "December",
            couple: "Couple",
            family: "Family",
            solo: "Solo",
            group: "Friends/Groups",
            foodAndDrink: "A variety of food and drink choices",
            entertainment: "Entertainment",
            kidsActivities: "Kids activities",
            chillOut: "Time to chill out",
            familyActivities: "A variety of things to do for all the family",
            culture: "Different places/cultures",
            sun: "Relax in the sun",
            nordicLanguageQuestion: "Which Language?",
            nordicLanguageText:
                "The welcome introduction will be in the language of your choice, the holiday information will remain in English.",
            swedish: "Swedish",
            finnish: "Finnish",
            english: "English",
            danish: "Danish",
            norwegian: "Norwegian",
            createYourHoliday: "Create Your Holiday",
            headingShipSidebar: "Ship",
            textShipSidebar: "Choose their preferred Ship",
            headingShip: "Select the Ships",
            textShip: "Which ship are they taking?",
            headingWhenSidebar: "When",
            textWhenSidebar: "When would they like to travel?",
            headingWhoSidebar: "Who",
            textWhoSidebar: "Couple, family, or solo?",
            scrollForMore: (
                <>
                    Scroll <br />
                    for more
                </>
            ),
            headingCustomerSidebar: "Customer’s Name",
            textCustomerSidebar: "Personalise their experience",
            headingWhereSidebar: "Where",
            textWhereSidebar: "Where is the desired location?",
            headingHowLongSidebar: "Duration",
            textHowLongSidebar: "How long is their perfect holiday?",
            whatDatesAreConsidering: "What dates are they considering?",
            classTitle: "Class",
            holidayResultText: "HOLIDAY RESULT",
            textResult: "Result",
            textShips: "Ships",
            // textWho: "Who",
            // textWhere: "Where",
            // textWhen: "When",
            textEdit: "edit",
            accessRequired: "Accessibility Support Required",
            NoAccessRequired: "No Accessibility Support",
        },
        nordics: {
            headingGetStarted: "Get Started",
            headingBuildAHoliday: "Build a Holiday",
            textBuildAHoliday: "For your customers",
            buttonPrevious: "Go Back",
            textAddHolidayToSuitcase: "Add to Suitcase",
            textAddedHolidayToSuitcase: "Added to Suitcase",
            textSeeResults: "See Results",
            textNext: "Next",
            headingYourCustomerName: "Your Customer's Name",
            textFormCaption:
                "To build a bespoke holiday for your customer, let's start by personalising it to them. What's their name?",
            textWhatsTheirName: "What's their name?",
            placeholderCustomerName: "Customer's Name",
            validationName:
                "Your customer's name cannot include profanity, please enter something else.",
            headingWhen: "When?",
            textWhen: "What year are they interested in taking their holiday?",
            textWhatMonth: "What months of the year are they considering?",
            textSelectApply: "Please select all that apply",
            headerWho: "Who?",
            textWho: "What type of group is your customer a part of?",
            textChoice: "Will your guest require accessibility support during their cruise?",
            textChoiceApply: "For example wheelchair accessible room, hearing kit etc",
            headingWhere: "Where?",
            textWhere: "What locations are they interested in?",
            textWhatDeparturePort: "What departure port do they want to travel from?",
            headingHowLong: "Duration?",
            textHowLong: "How many nights would they like to be on holiday for?",
            placeholderShip: "Ship",
            placeholderAll: "All",
            placeholderItineraryName: "Itinerary Name",
            placeholderStartDate: "Start Date",
            placeholderEndDate: "End Date",
            buttonResetDate: "Reset Date",
            headingResults: "Results",
            textResults: "Match the perfect itineraries",
            textSelectHolildays:
                "Please select the holidays that you'd like to send to your customer - these will be added to their Holiday Suitcase.",
            headingNoResults: "No Results",
            textNoResults:
                "No holidays match your search criteria at the moment, please go back and adjust your itinerary search.",
            headingNoResults2: "That ship has already sailed...",
            textNoResults2:
                "The parameters you’ve selected have returned zero results. Use the results bar above to go back and make changes to your selections.",

            noResultBox1Title: "If the departure port you’ve selected is non-negotiable",
            noResultBox1Text: "Try a different ship or date of departure.",
            noResultBox2Title: "If the ships you’ve selected is non-negotiable",
            noResultBox2Text: "Try a different date of departure.",
            noResultBox3Title: "If the DATE OF DEPARTURE IS NON-NEGOTIABLE",
            noResultBox3Text: "Try a different ship or departure port.",
            textConfirmationOne: "Would you like to add these itineraries to",
            textConfirmationTwo: "'s suitcase, or create a brand new suitcase?",
            buttonCreateNewSuitcase: "Create New Suitcase",
            buttonAddToCurrentSuitcase: "Add to Current Suitcase",
            january: "January",
            february: "February",
            march: "March",
            april: "April",
            may: "May",
            june: "June",
            july: "July",
            august: "August",
            september: "September",
            october: "October",
            november: "November",
            december: "December",
            couple: "Couple",
            family: "Family",
            solo: "Solo",
            group: "Friends/Groups",
            foodAndDrink: "A variety of food and drink choices",
            entertainment: "Entertainment",
            kidsActivities: "Kids activities",
            chillOut: "Time to chill out",
            familyActivities: "A variety of things to do for all the family",
            culture: "Different places/cultures",
            sun: "Relax in the sun",
            nordicLanguageQuestion: "Which Language?",
            nordicLanguageText:
                "The welcome introduction will be in the language of your choice, the holiday information will remain in English.",
            swedish: "Swedish",
            finnish: "Finnish",
            english: "English",
            danish: "Danish",
            norwegian: "Norwegian",
            createYourHoliday: "Create Your Holiday",
            headingShipSidebar: "Ship",
            textShipSidebar: "Choose their preferred Ship",
            headingShip: "Ship?",
            textShip: "Which ship are they taking?",
            headingWhenSidebar: "When",
            textWhenSidebar: "When would they like to travel?",
            headingWhoSidebar: "Who",
            textWhoSidebar: "Couple, family, or solo?",
            scrollForMore: (
                <>
                    Scroll <br />
                    for more
                </>
            ),
            headingCustomerSidebar: "Customer’s Name",
            textCustomerSidebar: "Personalise their experience",
            headingWhereSidebar: "Where",
            textWhereSidebar: "Where is the desired location?",
            headingHowLongSidebar: "Duration",
            textHowLongSidebar: "How long is their perfect holiday?",
            whatDatesAreConsidering: "What dates are they considering?",
            classTitle: "Class",
            holidayResultText: "HOLIDAY RESULT",
            textResult: "Result",
            textShips: "Ships",
            textWho: "Who",
            textWhere: "Where",
            textWhen: "When",
            textEdit: "edit",
        },
        es: {
            headingGetStarted: "Inicio",
            headingBuildAHoliday: "PERSONALIZA LAS VACACIONES",
            textBuildAHoliday: "para tus clientes",
            buttonPrevious: "Anterior",
            textAddHolidayToSuitcase: "Añade vacaciones a la maleta",
            textAddedHolidayToSuitcase: "Vacaciones añadidas a la maleta",
            textSeeResults: "Ver resultados",
            textNext: "Siguiente",
            headingYourCustomerName: "El nombre de tu cliente",
            textFormCaption:
                "Para que tu cliente pueda embarcar en las vacaciones más increíbles de su vida, empecemos por personalizar sus vacaciones. ¿Cómo se llama tu cliente?",
            textWhatsTheirName: "Cómo se llama tu cliente?",
            placeholderCustomerName: "Nombre del cliente",
            validationName:
                "El nombre del cliente no puede ser indecoroso ni contener lenguaje soez. Introduce otro nombre.",
            headingWhen: "¿Cuándo?",
            textWhen: "¿En qué año desean embarcar en sus vacaciones?",
            textWhatMonth: "¿Qué meses prefieren?",
            textSelectApply: "Selecciona todas las respuestas aplicables",
            headerWho: "¿Con Quién?",
            textWho: "¿Con quién viaja tu cliente?",
            textChoice: "¿Requerirá de alguna asistencia especial a bordo de su crucero?",
            textChoiceApply: "Selecciona una opción.",

            headingWhere: "¿DÓNDE?",
            textWhere: "¿Qué destinos le interesan?",
            textWhatDeparturePort: "¿De qué puerto querría zarpar?",

            headingHowLong: "¿CUÁNTO TIEMPO?",
            textHowLong: "¿Cuántas noches quieren embarcar?",
            placeholderShip: "Barco",
            placeholderAll: "Todo",
            placeholderItineraryName: "Nombre del itinerario",
            placeholderStartDate: "Día de inicio",
            placeholderEndDate: "Día de finalización",
            buttonResetDate: "Resetear fechas",
            headingResults: "Resultados",
            textResults: "Consulta los itinerarios disponibles",
            textSelectHolildays:
                "Selecciona las vacaciones que te gustaría enviar a tu cliente. Éstas se añadirán a su Maleta de Vacaciones.",
            headingNoResults: "SIN RESULTADOS",
            textNoResults:
                "Por el momento no hay vacaciones que coincidan con tus criterios de selección. Vuelve atrás y ajusta tu búsqueda de itinerarios.",

            headingNoResults2: "Ese barco ya ha zarpado...",
            textNoResults2:
                "Los parámetros que has seleccionado no han devuelto resultados. Utiliza la barra de resultados de arriba para volver atrás y realizar cambios en tus selecciones.",
            noResultBox1Title: "Si el puerto de salida que has seleccionado no es negociable",
            noResultBox1Text: "Prueba con un barco o fecha de salida diferente.",
            noResultBox2Title: "Si el barco que has seleccionado no es negociable",
            noResultBox2Text: "Prueba con una fecha de salida diferente.",
            noResultBox3Title: "SI LA FECHA DE SALIDA NO ES NEGOCIABLE",
            noResultBox3Text: "Prueba con un barco o puerto de salida diferente.",
            textConfirmationOne: "Te gustaría añadir estos itinerarios a la maleta de",
            textConfirmationTwo: " o crear una maleta nueva?", // TODO: Dynamic - Untranslated (la maleta de ..... o crear una maleta nueva?)
            buttonCreateNewSuitcase: "CREAR MALETA NUEVA",
            buttonAddToCurrentSuitcase: "Añadir a la maleta actual",
            january: "Enero",
            february: "Febrero",
            march: "Marzo",
            april: "Abril",
            may: "Mayo",
            june: "Junio",
            july: "Julio",
            august: "Agosto",
            september: "Septiembre",
            october: "Octubre",
            november: "Noviembre",
            december: "Diciembre",
            couple: "Pareja",
            family: "Familia",
            solo: "Solo",
            group: "Amigos/Grupos",
            foodAndDrink: "Una variedad de opciones de comida y bebida",
            entertainment: "Entretenimiento",
            kidsActivities: "Actividades para niños",
            chillOut: "Tiempo para relajarse",
            familyActivities: "Una variedad de actividades para toda la familia",
            culture: "Diferentes lugares/culturas",
            sun: "Relajarse al sol",
            nordicLanguageQuestion: "¿Qué idioma prefieres? ",
            nordicLanguageText:
                "La introducción de bienvenida será en el idioma de su elección, la información de vacaciones permanecerá en inglés.",
            swedish: "Sueco",
            finnish: "Finlandés",
            english: "Inglés",
            danish: "Danés",
            norwegian: "Noruego",
            createYourHoliday: "PERSONALIZA LAS VACACIONES",
            headingShip: "Elige un barco",
            textShip: "",
            headingShipSidebar: "Barco",
            textShipSidebar: "Selecciona el barco que prefiera",
            headingWhenSidebar: "Cuándo",
            textWhenSidebar: "¿Cuándo les gustaría viajar?",
            headingWhoSidebar: "¿Quién?",
            textWhoSidebar: "¿Pareja, familia o solo?",
            scrollForMore: (
                <>
                    Sigue <br />
                    leyendo <br />
                    para más <br />
                    información
                </>
            ),
            headingCustomerSidebar: "Nombre del cliente",
            textCustomerSidebar: "Personaliza su experiencia",
            headingWhereSidebar: "¿Dónde?",
            textWhereSidebar: "¿Dónde desean viajar?",
            headingHowLongSidebar: "Duración",
            textHowLongSidebar: "Especifica la duración de sus vacaciones",
            whatDatesAreConsidering: "¿En qué fechas tienen disponibilidad?",
            classTitle: "Clase",
            holidayResultText: "RESULTADOS PARA",
            textResult: "Resultado",
            textShips: "Barcos",
            // textWho: "Quién",
            // textWhere: "Dónde",
            // textWhen: "Cuándo",
            textEdit: "editar",
            accessRequired: "Se requiere apoyo de accesibilidad",
            noAccessRequired: "No se requiere asistencia de accesibilidad",
        },
    },
    itineraryCard: {
        en: {
            textExplore: "Explore",
            textLeaving: "Leaving",
            textFrom: "From",
            textOnboard: "Onboard",
            textNight: "Night",
            textNights: "Nights",
            pitchIt: "Pitch It",
            remove: "Remove",
            textLikeThisCruise: "I like this cruise!",
            textCruiseLiked: "Cruise liked!",
            textUnlikeThisCruise: "Unlike this cruise",
        },
        nordics: {
            textExplore: "Explore",
            textLeaving: "Leaving",
            textFrom: "From",
            textOnboard: "Onboard",
            textNight: "Night",
            textNights: "Nights",
            pitchIt: "Pitch It",
            remove: "Remove",
            textLikeThisCruise: "I like this cruise!",
            textCruiseLiked: "Cruise liked!",
            textUnlikeThisCruise: "Unlike this cruise",
        },
        es: {
            textExplore: "Explorar",
            textLeaving: "Salida",
            textFrom: "Desde",
            textOnboard: "A bordo de",
            textNight: "Noche",
            textNights: "Noches",
            pitchIt: "Presentarlo",
            remove: "Eliminar",
            textLikeThisCruise: "¡Me gusta este crucero!",
            textCruiseLiked: "¡Te gustó este crucero!",
            textUnlikeThisCruise: "Ya no me gusta este crucero",
        },
    },
    overview: {
        en: {
            // textNextHoliday: "your next holiday always awaits",
            textNextHoliday: "your next holiday awaits",
            buttonExplore: "EXPLORE",
        },
        nordics: {
            // textNextHoliday: "your next holiday always awaits",
            textNextHoliday: "your next holiday awaits",
            buttonExplore: "EXPLORE",
        },
        es: {
            textNextHoliday: "Tus próximas vacaciones",
            buttonExplore: "Explorar",
        },
    },
    navbarCruises: {
        en: {
            listMenuYourCruises: "Your Cruises",
            listMenuWhyRoyal: "Why Royal",
            listMenuWhatsIncluded: "What's Included",
            listMenuTheSuiteLife: "The Suite Life",
            // listMenuContactYourAgent: "Contact Your Agent",
            listMenuContactYourAgent: "Contact",
            textContact: "Contact",
            accessibility: "Accessibility",
            extras: "Extras",
        },
        nordics: {
            listMenuYourCruises: "Your Cruises",
            listMenuWhyRoyal: "Why Royal",
            listMenuWhatsIncluded: "What's Included",
            listMenuTheSuiteLife: "The Suite Life",
            // listMenuContactYourAgent: "Contact Your Agent",
            listMenuContactYourAgent: "Contact",
            textContact: "Contact",
            accessibility: "Accessibility",
            extras: "Extras",
        },
        es: {
            listMenuYourCruises: "Tus Cruceros",
            listMenuWhyRoyal: "Por Qué Royal",
            listMenuWhatsIncluded: "Qué Incluye",
            listMenuTheSuiteLife: "Vida En Suite",
            // listMenuContactYourAgent: "Contacta Con Tu Agente",
            listMenuContactYourAgent: "Contacta",
            textContact: "Contacta",
            accessibility: "Accesibilidad",
            extras: "Extras",
        },
    },
    yourCruise: {
        en: {
            Families: "Families",
            Couples: "Couples",
            Solo: "Solo",
            MultiGen: "Multi-Gen",
            FriendsGroups: "Friends/Groups",
            navbarYourCruises: "Your Cruises",
            headingYourNextHolidayAwaits: "YOUR NEXT HOLIDAY AWAITS",
            textHi: "Hi",
            textThanksForInterest: "Thank you for your interest in a Royal Caribbean Holiday with",
            textYouHave: "You have",
            textExtraordinaryHoliday: "extraordinary holiday",
            textExtraordinaryHolidays: "extraordinary holidays",
            textItinerary: "itinerary",
            textItineraries: "itineraries",
            textToChooseFrom:
                "to choose from, which include everything you need to know and can look forward to!",
            textPleaseBrowse:
                "Please browse these at your leisure and contact us if you'd like to book – we can't wait to help you secure your dream holiday.",
            textWhatsIncluded: "What's Included",
            textWhyRoyalFor: "WHY ROYAL FOR",
            textCall: "Call",
            textEmail: "Email",
            headingBook: "BOOK",
            headingNow: "NOW",
            welcomeText: "Welcome to your suitcase",
            amazing: "Amazing",
            textHoliday: "Holiday",
            textHolidays: "Holidays",
            whatToExpect: "What to expect from a Royal Caribbean cruise",
            howCanWeMake: "How can we make your {title} holiday the best it can be",
            alwaysHappyToHelp: "We're always happy to help.",
            responseSentTitle: "Your response has been sent!",
            responseSentText:
                "Your travel agent is now reviewing your response. Like the cruises you’re interested in to keep things moving.",
            responseSentButtonText: "OK",
            likeWhatYouSee: "Like what you see?",
            likeWhatYouSeeSubtitle: "Let your travel agent know by liking some of these cruises!",
            likeWhatYouSeeButton: "Send your response",
            thanksForSharing: "Thanks for sharing!",
            thanksForSharingSubtitle:
                "You can resend your responses whenever you update your likes!",
            thanksForSharingButton: "Response Sent!",
            popupTitle: "LET THEM KNOW WHAT YOU LIKE",
            popupDescription:
                'See an itinerary you like? Give it a "like" to let your contact know your preference.',
            popupButtonText: "I understand, let's go!",
        },
        nordics: {
            Families: "Families",
            Couples: "Couples",
            Solo: "Solo",
            MultiGen: "Multi-Gen",
            FriendsGroups: "Friends/Groups",
            navbarYourCruises: "Your Cruises",
            headingYourNextHolidayAwaits: "YOUR NEXT HOLIDAY AWAITS",
            textHi: "Hi",
            textThanksForInterest: "Thank you for your interest in a Royal Caribbean Holiday with",
            textYouHave: "You have",
            textExtraordinaryHoliday: "extraordinary holiday",
            textExtraordinaryHolidays: "extraordinary holidays",
            textItinerary: "itinerary",
            textItineraries: "itineraries",
            textToChooseFrom:
                "to choose from, which include everything you need to know and can look forward to!",
            textPleaseBrowse:
                "Please browse these at your leisure and contact us if you'd like to book – we can't wait to help you secure your dream holiday.",
            textWhatsIncluded: "What's Included",
            textWhyRoyalFor: "WHY ROYAL FOR",
            textCall: "Call",
            textEmail: "Email",
            headingBook: "BOOK",
            headingNow: "NOW",
            welcomeText: "Welcome to your suitcase",
            amazing: "Amazing",
            textHoliday: "Holiday",
            textHolidays: "Holidays",
            whatToExpect: "What to expect from a Royal Caribbean cruise",
            howCanWeMake: "How can we make your {title} holiday the best it can be",
            alwaysHappyToHelp: "We're always happy to help.",
            responseSentTitle: "Your response has been sent!",
            responseSentText:
                "Your travel agent is now reviewing your response. Like the cruises you’re interested in to keep things moving.",
            responseSentButtonText: "OK",
            likeWhatYouSee: "Like what you see?",
            likeWhatYouSeeSubtitle: "Let your travel agent know by liking some of these cruises!",
            likeWhatYouSeeButton: "Send your response",
            thanksForSharing: "Thanks for sharing!",
            thanksForSharingSubtitle:
                "You can resend your responses whenever you update your likes!",
            thanksForSharingButton: "Response Sent!",
            popupTitle: "LET THEM KNOW WHAT YOU LIKE",
            popupDescription:
                "When you see an itinerary that you like, give it a like! This will let your contact know what you like!",
            popupButtonText: "I understand, let's go!",
        },
        es: {
            Families: "Familias",
            Couples: "Parejas",
            Solo: "Solo",
            MultiGen: "Diferentes edades",
            FriendsGroups: "Amigos/ Grupos",
            navbarYourCruises: "Tus Cruceros",
            headingYourNextHolidayAwaits: "TUS PRÓXIMAS VACACIONES",
            textHi: "Hola",
            textThanksForInterest:
                "Gracias por tu interés en unas vacaciones de Royal Caribbean con",
            textYouHave: "Tienes",
            textExtraordinaryHoliday: "extraordinario",
            textExtraordinaryHolidays: "extraordinarios",
            textItinerary: "itinerario",
            textItineraries: "itinerarios",
            textToChooseFrom:
                "para tus vacaciones a elegir. Incluyen todo lo que necesitas saber y lo que puedes esperar.",
            textPleaseBrowse:
                "Mira con calma la información y contacta con nosotros si te decides hacer una reserva. Nos hace mucha ilusión ayudarte a materializar las vacaciones de tus sueños.",
            textWhatsIncluded: "¿Qué está incluido",
            textWhyRoyalFor: "¿PORQUÉ ROYAL PARA",
            textCall: "Llamar",
            textEmail: "Correo electrónico",
            headingBook: "RESERVAR",
            headingNow: "AHORA",
            welcomeText: "Bienvenido a tu maleta de vacaciones",
            amazing: "Increíbles",
            textHoliday: "Vacaciones",
            textHolidays: "Vacaciones",
            whatToExpect: "Qué esperar de un crucero de Royal Caribbean",
            howCanWeMake:
                "¿Cómo podemos hacer que tus vacaciones para {title} sean las mejores posibles?",
            alwaysHappyToHelp: "Siempre estamos encantados de ayudarte.",
            responseSentTitle: "¡Tu respuesta ha sido enviada!",
            responseSentText:
                "Tu agente de viajes está revisando tu respuesta. Marca con “Me gusta” los cruceros que te interesan para que el proceso continúe.",
            responseSentButtonText: "Aceptar",
            likeWhatYouSee: "¿Te interesa alguna de las opciones?",
            likeWhatYouSeeSubtitle:
                "Deja que tu agente de viajes lo sepa dándole me gusta a alguna de las propuestas",
            likeWhatYouSeeButton: "Manda Tu Respuesta",
            thanksForSharing: "¡Gracias por compartir!",
            thanksForSharingSubtitle:
                "Puedes volver a enviar tus respuestas cuando actualices tus gustos.",
            thanksForSharingButton: "¡Respuesta enviada!",
            popupTitle: "DÉJALES SABER LO QUE TE GUSTA",
            popupDescription:
                "¿Te gusta algún itinerario? Dale a «Me gusta» para que tus contactos sepan cuáles son tus preferencias.",
            popupButtonText: "¡Entendido, vamos!",
        },
    },
    whyRoyal: {
        en: {
            // UI
            headingWhyRoyal: "WHY ROYAL",
            textPutYourWalletAway: "Put Your Wallet Away",
            textServicesAmenities: "SERVICES & AMENITIES JUST FOR YOU",
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",

            // Royal Families
            whyRoyalFamiliesTitle1: "Why Royal for",
            whyRoyalFamiliesTitle2: "Families",
            whyRoyalFamiliesDescription: `Imagine a place where luxury, adventure, and relaxation converge. Royal Caribbean delivers unforgettable family holidays with activities for all ages, dining to suit even the fussiest of eaters, Broadway shows, private islands, and endless sun-soaking. Say goodbye to sacrificing ease for exploration and turn your family holiday into an adventure for everyone.`,

            whyRoyalFamilies_MealtimeTitle: "Mealtime Made Awesome",
            whyRoyalFamilies_MealtimeText:
                "My Time Family Dining’ makes sure the kids are fed and watered before they are whisked away for fun and games – leaving you to dine at your leisure. Shall we pass the dessert list?",

            whyRoyalFamilies_FamilyTitle: "Family Time, Guaranteed",
            whyRoyalFamilies_FamilyText:
                "If you can manage to momentarily drag your kids away from the fun for a bit of quality family bonding, there are plenty of photo-album-making moments to be had. Whether that be cooling off in the pool, cosying up for a top-deck movie night, overindulging in ice cream flavours, or heading for a competitive kids vs. parents game in Playmakers℠ Sports Bar & Arcade.",

            whyRoyalFamilies_ReadyTitle: "Ready, Steady,  Fun.",
            whyRoyalFamilies_ReadyText:
                "Whether they’re wide-eyed tots or teens, they’ll be entertained from the moment they step on board. Laser tag, dodgems, water slides, escape rooms, and surf simulators are just some of the activities designed to keep kids of all ages occupied, whilst you sip the day away in the afternoon sunshine.",

            whyRoyalFamilies_SeatTitle: "The Best Seats in the House",
            whyRoyalFamilies_SeatText:
                "Treat the whole family to tickets of a lifetime with world-class entertainment every night, plus matinees for younger children. With all this included in your holiday, it’s sure to be a showstopper – better hope your kids don’t ask for an encore.",

            whyRoyalFamilies_ExplainBoxBigTitle: "TOTS, TEENS & INBETWEENS",
            whyRoyalFamilies_ExplainBoxBigText:
                "Two reasons why our award-winning complimentary Adventure Ocean Kids Club will put a smile on your face. Firstly, you know your kids are going to have the time of their lives making friends and memories. But more importantly, you’ll finally be able to enjoy some well-deserved time off from parent duties so you can get up to whatever you want – probably just a bit of shut-eye in the sunshine.",

            whyRoyalFamilies_ExplainGridAdventureOceanTitle: "adventure ocean",
            whyRoyalFamilies_ExplainGridAdventureOceanSubtitle: "Royal Babies & Tots™ Nursery",

            whyRoyalFamilies_ExplainGridAdventureOceanText:
                "Babies from 6–36 months learn as they play through interactive toys and games, together with their parents and our trained professionals. <br><br> *Charges apply for this service",

            whyRoyalFamilies_ExplainGridAquanautsTitle: "Aquanauts",
            whyRoyalFamilies_ExplainGridAquanautsSubtitle: "3-5 Years Old",
            whyRoyalFamilies_ExplainGridAquanautsText:
                "Calling all imaginative youngsters – we’ve got activities to keep your brains at bay. With everything from a playroom, music room, art studio, theatre, to a science lab, if you leave them long enough you might just have a child prodigy by the end of your holiday.",

            whyRoyalFamilies_ExplainGridExplorersTitle: "Explorers",
            whyRoyalFamilies_ExplainGridExplorersSubtitle: "6-8 Years Old",
            whyRoyalFamilies_ExplainGridExplorersText:
                "Budding explorers will find our fun-filled learning full of adventure. Imagine soaring through space, hunting for fossils, dancing the day away, and experimenting with as many flavours of ice cream as they can stuff in. And with the little explorers in here, you’ll be free to explore the many sights on board (or bars).",

            whyRoyalFamilies_ExplainGridVoyagersTitle: "Voyagers",
            whyRoyalFamilies_ExplainGridVoyagersSubtitle: "9-11 Years Old",
            whyRoyalFamilies_ExplainGridVoyagersText:
                "Let your mini-adventurer go forth and seek excitement with backstage access and plenty of sporty activities. They’ll return with wide eyes, tales to tell, and they might even find some hidden treasure!",

            whyRoyalFamilies_ExplainGridTeensTitle: "Teens",
            whyRoyalFamilies_ExplainGridTeensSubtitle: "12-17 Years Old",
            whyRoyalFamilies_ExplainGridTeensText:
                "It’s a bit of a mystery what goes on at our legendary pool parties, karaoke, and discos. Just a lot of selfies from what we can tell. These are our teen-only hangout areas - no parents allowed.",

            whyRoyalFamilies_ExplainGridLateNightKidsTitle: "Late Night Kids Party Zone",
            whyRoyalFamilies_ExplainGridLateNightKidsText:
                "We know it’s bedtime, but on holiday older-young-guns can buy tickets to keep the party going. Perfect for young night owls and older wise owls to let loose and regain some of that long-lost teen spirit.",

            whyRoyalFamilies_ExplainGridMixBigBoxTitle: "THE ULTIMATE <br /> FAMILIES DAY AT SEA",
            whyRoyalFamilies_ExplainGridMixBigBoxText:
                "Enjoy these incredible onboard activities at no extra charge.",

            whyRoyalFamilies_ExplainGridMix1030Title: "10:30",
            whyRoyalFamilies_ExplainGridMix1030Text:
                "Learn how to surf by catching a wave on the ground-breaking Flowrider.",

            whyRoyalFamilies_ExplainGridMix0900Title: "09:00",
            whyRoyalFamilies_ExplainGridMix0900Text:
                "Enjoy breakfast at The Windjammer, perfect for fuelling your day.",

            whyRoyalFamilies_ExplainGridMix1130Title: "11:30",
            whyRoyalFamilies_ExplainGridMix1130Text:
                "Hit the waterpark and face off head-to-head on our exhilarating slides.",

            whyRoyalFamilies_ExplainGridMix1300Title: "13:00",
            whyRoyalFamilies_ExplainGridMix1300Text:
                "Head to El Loco Fresh to grab some tasty tacos and quesadillas for lunch.",

            whyRoyalFamilies_ExplainGridMix1600Title: "16:00",
            whyRoyalFamilies_ExplainGridMix1600Text:
                "Grab the whole family a delicious ice cream by the pool.",

            whyRoyalFamilies_ExplainGridMix1400Title: "14:00",
            whyRoyalFamilies_ExplainGridMix1400Text: "Seek thrills with a ride on the zip line.",

            whyRoyalFamilies_ExplainGridMix1700Title: "17:00",
            whyRoyalFamilies_ExplainGridMix1700Text:
                "Whether you’ve mastered the art of show tunes or shower tunes, you can sing your favourite hits with thousands of popular songs to choose from at Spotlight Karaoke.",

            whyRoyalFamilies_ExplainGridMix1930Title: "19:30",
            whyRoyalFamilies_ExplainGridMix1930Text:
                "Take your family dinner to the next level — and there’s no better place onboard to do that than the Main Dining Room.",

            whyRoyalFamilies_ExplainGridMix2200Title: "22:00",
            whyRoyalFamilies_ExplainGridMix2200Text:
                "Take in the mind-blowing AquaTheater show. Give a standing ovation.",

            whyRoyalFamilies_ExplainGridMix2100Title: "21:00",
            whyRoyalFamilies_ExplainGridMix2100Text:
                "Strap on a pair of skates and show off your best ice skating moves.",

            whyRoyalFamilies_ExplainGridMix2300Title: "23:00",
            whyRoyalFamilies_ExplainGridMix2300Text:
                "Hit Sorrento’s for a late night slice with the gang.",

            // Royal Couples
            whyRoyalFamiliesTitle1: "Why Royal for",
            whyRoyalFamiliesTitle2: "Couples",
            whyRoyalCouplesDescription: `What could be more romantic than exploring stylish, adventure-packed ships with your soulmate? Royal Caribbean offers mesmerising destinations, adult-only areas, incredible dining, and world-class entertainment. Check in once and enjoy a holiday filled with culture, relaxation, and jaw-dropping experiences. Romantic getaways have never been more thrilling.`,

            whyRoyalCouples_CompetitiveTitle: "Competitive, Us?",
            whyRoyalCouples_CompetitiveText:
                "There’s nothing wrong with some healthy competition. From racing each other up the rock climbing wall to sliding down the epic water slides, who will be crowned the ultimate ruler of the waves?",

            whyRoyalCouples_PoolsideTitle: "Poolside <br /> Paradise",
            whyRoyalCouples_PoolsideText:
                "Shake up your sea day with ice-cold drinks and sun-drenched hangs. Like the suspended infinity pool that bumps beach club beats, a swim-up bar that doubles as a dance party, and an elevated retreat that's in another stratosphere of chic.",

            whyRoyalCouples_HavenTitle: "A Haven of <br /> Ultimate <br /> Relaxation",
            whyRoyalCouples_HavenText:
                "Treat yourself and someone special to a romantic stay they’ll never forget. As well as the sumptuous comfort of the suite itself, you can enjoy your own dedicated lounge with a full bar and delicious hors d'oeuvres, all just a few steps away from the Sun Deck. Unforgettable memories await.",

            whyRoyalCouples_IntimateTitle: "Intimate Dining <br /> for Two",
            whyRoyalCouples_IntimateText:
                "Whether it’s a romantic dinner with exceptional table service, or a long lazy brunch before a day of adventures, you'll be spoilt for choice with all the delicious dining options onboard any time of the day.",

            whyRoyalCouples_SailTogetherTitle: "Those Who Sail <br /> Together",
            whyRoyalCouples_SailTogetherText:
                "Rekindle the romance with an unforgettable getaway to one of the world’s top destinations – The Caribbean! Unwind together in a paradise of white sand beaches, starlit skies, and balmy nights. Celebrate your anniversary or honeymoon under swaying palm trees while you soak up some sun-soaked serenity.",

            whyRoyalCouples_PerfectDayTitle: "",
            whyRoyalCouples_PerfectDayText:
                "Or for those couples that like to dial up the fun we have the ultimate beachfront party in paradise just for adults — Hideaway Beach only on Royal Caribbean® at Perfect Day at CocoCay. Swim right up to the popping Hideaway Bar, fuelled by non-stop DJ-spun beats.",

            whyRoyalCouples_UltimateCouplesTitle: "THE ULTIMATE <br /> COUPLES DAY AT SEA",
            whyRoyalCouples_UltimateCouplesText:
                "Whether travelling with family, friends or as a couple, our interior staterooms have everything a guest could need, including 24-hour room service and a nightly turn-down service.",

            whyRoyalCouples_1030Title: "10:30",
            whyRoyalCouples_1030Text:
                "Race your partner 12 metres above the deck on the signature Rock Climbing Wall.",

            whyRoyalCouples_0900Title: "09:00",
            whyRoyalCouples_0900Text:
                "Take a stroll through Central Park and grab a breakfast sandwich at Park Cafe.",

            whyRoyalCouples_1100Title: "11:00",
            whyRoyalCouples_1100Text:
                "It’s time to hit the pool deck, race down slides, relax in the whirlpool and soak up the sun.",

            whyRoyalCouples_1230Title: "12:30",
            whyRoyalCouples_1230Text:
                "Head to the Windjammer for a buffet-style lunch of fresh fish and Mediterranean inspired salad.",

            whyRoyalCouples_1500Title: "15:00",
            whyRoyalCouples_1500Text:
                "Raise the bar on the North Star as it elevates you high above the ship for unrivalled 360-degree views.",

            whyRoyalCouples_1400Title: "14:00",
            whyRoyalCouples_1400Text:
                "Feel the freedom of freefall without even leaving the deck on the RipCord by iFLY simulator.",

            whyRoyalCouples_1730Title: "17:30",
            whyRoyalCouples_1730Text:
                "Indulge in the ultimate date night in the Main Dining Room for a world-class dining experience that invites you to taste your way around the world.",

            whyRoyalCouples_1930Title: "19:30",
            whyRoyalCouples_1930Text:
                "Indulge in the ultimate date night in the Main Dining Room for a world-class dining experience that invites you to taste your way around the world.",

            whyRoyalCouples_2230Title: "22:30",
            whyRoyalCouples_2230Text:
                "Watch all-star performers at the Ice Show unleash maximum axels and supersized spins like nothing you’ve seen before.",

            whyRoyalCouples_2100Title: "21:00",
            whyRoyalCouples_2100Text:
                "Sing your heart out at a West End hit musical miles away from the mainland.",

            whyRoyalCouples_0000Title: "00:00",
            whyRoyalCouples_0000Text:
                "Dance the night away in the Music Hall, this premier place for live music lovers deserves a spot on your after-dark setlist.",

            // Royal Friends
            whyRoyalFriendsTitle: "Royal for Friends <br/> and Groups",

            whyRoyalFamiliesTitle1: "Why Royal for",
            whyRoyalFamiliesTitle2: "Friends and Groups",
            whyRoyalFriendsDescription: `Get ready for an unforgettable holiday experience with Royal Caribbean. Gather your adventure-loving friends and embark on a journey like no other. Indulge in world-class cuisine, amazing parties, and exhilarating activities, all while exploring a stunning array of bucket-list destinations. From sun-soaked days to breathtaking views, every moment is designed to create lifelong memories.`,

            whyRoyalFriends_GroupActivitiesTitle: "Group Activities",
            whyRoyalFriends_GroupActivitiesText:
                "Royal Caribbean offers an unparalleled variety of group activities, including dance classes, sports tournaments, and even the chance to show off – or crash out – on FlowRider. These activities are a great opportunity for you and your friends to let loose and make long-lasting memories.",

            whyRoyalFriends_TasteParadiseTitle: "A Taste of <br /> Paradise",
            whyRoyalFriends_TasteParadiseText:
                "However you wish to unwind, we always raise the bar. Whether you're craving a tiki-inspired drink in a Polynesian-themed lounge, poolside piña coladas with live calypso music, or a custom cocktail crafted by the Bionic Bar’s robotic bartenders, we’ve got you covered!",

            whyRoyalFriends_DiningOptionsTitle: "Dining Options",
            whyRoyalFriends_DiningOptionsText:
                "Wondering what you’ll eat on board? With hundreds of options to choose from – the superb, sizzling steak at Chops Grille, to tasty Tex-Mex tacos at El Loco Fresh – you’re guaranteed to find something the whole group will love!",

            whyRoyalFriends_BestSeatTitle: "The Best Seats <br /> in the House",
            whyRoyalFriends_BestSeatText:
                "With world-famous acts every night of the week, Royal Caribbean redefines cruise entertainment. Delight in spectacular West End musicals and laugh out loud with comedians fresh from the circuit.",
        },
        nordics: {
            // UI
            headingWhyRoyal: "WHY ROYAL",
            textPutYourWalletAway: "Put Your Wallet Away",
            textServicesAmenities: "SERVICES & AMENITIES JUST FOR YOU",
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",

            // Royal Families
            whyRoyalFamiliesTitle1: "Why Royal for",
            whyRoyalFamiliesTitle2: "Families",
            whyRoyalFamiliesDescription: `Imagine a place where luxury, adventure, and relaxation converge. Royal Caribbean delivers unforgettable family holidays with activities for all ages, dining to suit even the fussiest of eaters, Broadway shows, private islands, and endless sun-soaking. Say goodbye to sacrificing ease for exploration and turn your family holiday into an adventure for everyone.`,

            whyRoyalFamilies_MealtimeTitle: "Mealtime Made Awesome",
            whyRoyalFamilies_MealtimeText:
                "My Time Family Dining’ makes sure the kids are fed and watered before they are whisked away for fun and games – leaving you to dine at your leisure. Shall we pass the dessert list?",

            whyRoyalFamilies_FamilyTitle: "Family Time, Guaranteed",
            whyRoyalFamilies_FamilyText:
                "If you can manage to momentarily drag your kids away from the fun for a bit of quality family bonding, there are plenty of photo-album-making moments to be had. Whether that be cooling off in the pool, cosying up for a top-deck movie night, overindulging in ice cream flavours, or heading for a competitive kids vs. parents game in Playmakers℠ Sports Bar & Arcade.",

            whyRoyalFamilies_ReadyTitle: "Ready, Steady, Fun.",
            whyRoyalFamilies_ReadyText:
                "Whether they’re wide-eyed tots or teens, they’ll be entertained from the moment they step on board. Laser tag, dodgems, water slides, escape rooms, and surf simulators are just some of the activities designed to keep kids of all ages occupied, whilst you sip the day away in the afternoon sunshine.",

            whyRoyalFamilies_SeatTitle: "The Best Seats in the House",
            whyRoyalFamilies_SeatText:
                "Treat the whole family to tickets of a lifetime with world-class entertainment every night, plus matinees for younger children. With all this included in your holiday, it’s sure to be a showstopper – better hope your kids don’t ask for an encore.",

            whyRoyalFamilies_ExplainBoxBigTitle: "TOTS, TEENS & INBETWEENS",
            whyRoyalFamilies_ExplainBoxBigText:
                "Two reasons why our award-winning complimentary Adventure Ocean Kids Club will put a smile on your face. Firstly, you know your kids are going to have the time of their lives making friends and memories. But more importantly, you’ll finally be able to enjoy some well-deserved time off from parent duties so you can get up to whatever you want – probably just a bit of shut-eye in the sunshine.",

            whyRoyalFamilies_ExplainGridAdventureOceanTitle: "adventure ocean",
            whyRoyalFamilies_ExplainGridAdventureOceanSubtitle:
                "Royal Babies & Tots™ <br /> Nursery",

            whyRoyalFamilies_ExplainGridAdventureOceanText:
                "Babies from 6–36 months learn as they play through interactive toys and games, together with their parents and our trained professionals. <br><br> *Charges apply for this service",

            whyRoyalFamilies_ExplainGridAquanautsTitle: "Aquanauts",
            whyRoyalFamilies_ExplainGridAquanautsSubtitle: "3-5 Years Old",
            whyRoyalFamilies_ExplainGridAquanautsText:
                "Calling all imaginative youngsters – we’ve got activities to keep your brains at bay. With everything from a playroom, music room, art studio, theatre, to a science lab, if you leave them long enough you might just have a child prodigy by the end of your holiday.",

            whyRoyalFamilies_ExplainGridExplorersTitle: "Explorers",
            whyRoyalFamilies_ExplainGridExplorersSubtitle: "6-8 Years Old",
            whyRoyalFamilies_ExplainGridExplorersText:
                "Budding explorers will find our fun-filled learning full of adventure. Imagine soaring through space, hunting for fossils, dancing the day away, and experimenting with as many flavours of ice cream as they can stuff in. And with the little explorers in here, you’ll be free to explore the many sights on board (or bars).",

            whyRoyalFamilies_ExplainGridVoyagersTitle: "Voyagers",
            whyRoyalFamilies_ExplainGridVoyagersSubtitle: "9-11 Years Old",
            whyRoyalFamilies_ExplainGridVoyagersText:
                "Let your mini-adventurer go forth and seek excitement with backstage access and plenty of sporty activities. They’ll return with wide eyes, tales to tell, and they might even find some hidden treasure!",

            whyRoyalFamilies_ExplainGridTeensTitle: "Teens",
            whyRoyalFamilies_ExplainGridTeensSubtitle: "12-17 Years Old",
            whyRoyalFamilies_ExplainGridTeensText:
                "It’s a bit of a mystery what goes on at our legendary pool parties, karaoke, and discos. Just a lot of selfies from what we can tell. These are our teen-only hangout areas - no parents allowed.",

            whyRoyalFamilies_ExplainGridLateNightKidsTitle: "Late Night Kids Party Zone",
            whyRoyalFamilies_ExplainGridLateNightKidsText:
                "We know it’s bedtime, but on holiday older-young-guns can buy tickets to keep the party going. Perfect for young night owls and older wise owls to let loose and regain some of that long-lost teen spirit.",

            whyRoyalFamilies_ExplainGridMixBigBoxTitle: "THE ULTIMATE <br /> FAMILIES DAY AT SEA",
            whyRoyalFamilies_ExplainGridMixBigBoxText:
                "Enjoy these incredible onboard activities at no extra charge.",

            whyRoyalFamilies_ExplainGridMix1030Title: "10:30",
            whyRoyalFamilies_ExplainGridMix1030Text:
                "Learn how to surf by catching a wave on the ground-breaking Flowrider.",

            whyRoyalFamilies_ExplainGridMix0900Title: "09:00",
            whyRoyalFamilies_ExplainGridMix0900Text:
                "Enjoy breakfast at The Windjammer, perfect for fuelling your day.",

            whyRoyalFamilies_ExplainGridMix1130Title: "11:30",
            whyRoyalFamilies_ExplainGridMix1130Text:
                "Hit the waterpark and face off head-to-head on our exhilarating slides.",

            whyRoyalFamilies_ExplainGridMix1300Title: "13:00",
            whyRoyalFamilies_ExplainGridMix1300Text:
                "Head to El Loco Fresh to grab some tasty tacos and quesadillas for lunch.",

            whyRoyalFamilies_ExplainGridMix1600Title: "16:00",
            whyRoyalFamilies_ExplainGridMix1600Text:
                "Grab the whole family a delicious ice cream by the pool.",

            whyRoyalFamilies_ExplainGridMix1400Title: "14:00",
            whyRoyalFamilies_ExplainGridMix1400Text: "Seek thrills with a ride on the zip line.",

            whyRoyalFamilies_ExplainGridMix1700Title: "17:00",
            whyRoyalFamilies_ExplainGridMix1700Text:
                "Whether you’ve mastered the art of show tunes or shower tunes, you can sing your favourite hits with thousands of popular songs to choose from at Spotlight Karaoke.",

            whyRoyalFamilies_ExplainGridMix1930Title: "19:30",
            whyRoyalFamilies_ExplainGridMix1930Text:
                "Take your family dinner to the next level — and there’s no better place onboard to do that than the Main Dining Room.",

            whyRoyalFamilies_ExplainGridMix2200Title: "22:00",
            whyRoyalFamilies_ExplainGridMix2200Text:
                "Take in the mind-blowing AquaTheater show. Give a standing ovation.",

            whyRoyalFamilies_ExplainGridMix2100Title: "21:00",
            whyRoyalFamilies_ExplainGridMix2100Text:
                "Strap on a pair of skates and show off your best ice skating moves.",

            whyRoyalFamilies_ExplainGridMix2300Title: "23:00",
            whyRoyalFamilies_ExplainGridMix2300Text:
                "Hit Sorrento’s for a late night slice with the gang.",

            // Royal Couples
            whyRoyalFamiliesTitle1: "Why Royal for",
            whyRoyalFamiliesTitle2: "Couples",
            whyRoyalCouplesDescription: `What could be more romantic than exploring stylish, adventure-packed ships with your soulmate? Royal Caribbean offers mesmerising destinations, adult-only areas, incredible dining, and world-class entertainment. Check in once and enjoy a holiday filled with culture, relaxation, and jaw-dropping experiences. Romantic getaways have never been more thrilling.`,

            whyRoyalCouples_CompetitiveTitle: "Competitive, Us?",
            whyRoyalCouples_CompetitiveText:
                "There’s nothing wrong with some healthy competition. From racing each other up the rock climbing wall to sliding down the epic water slides, who will be crowned the ultimate ruler of the waves?",

            whyRoyalCouples_PoolsideTitle: "Poolside <br /> Paradise",
            whyRoyalCouples_PoolsideText:
                "Shake up your sea day with ice-cold drinks and sun-drenched hangs. Like the suspended infinity pool that bumps beach club beats, a swim-up bar that doubles as a dance party, and an elevated retreat that's in another stratosphere of chic.",

            whyRoyalCouples_HavenTitle: "A Haven of <br /> Ultimate <br /> Relaxation",
            whyRoyalCouples_HavenText:
                "Treat yourself and someone special to a romantic stay they’ll never forget. As well as the sumptuous comfort of the suite itself, you can enjoy your own dedicated lounge with a full bar and delicious hors d'oeuvres, all just a few steps away from the Sun Deck. Unforgettable memories await.",

            whyRoyalCouples_IntimateTitle: "Intimate Dining <br /> for Two",
            whyRoyalCouples_IntimateText:
                "Whether it’s a romantic dinner with exceptional table service, or a long lazy brunch before a day of adventures, you'll be spoilt for choice with all the delicious dining options onboard any time of the day.",

            whyRoyalCouples_SailTogetherTitle: "Those Who Sail <br /> Together",
            whyRoyalCouples_SailTogetherText:
                "Rekindle the romance with an unforgettable getaway to one of the world’s top destinations – The Caribbean! Unwind together in a paradise of white sand beaches, starlit skies, and balmy nights. Celebrate your anniversary or honeymoon under swaying palm trees while you soak up some sun-soaked serenity.",

            whyRoyalCouples_PerfectDayTitle: "",
            whyRoyalCouples_PerfectDayText:
                "Or for those couples that like to dial up the fun we have the ultimate beachfront party in paradise just for adults — Hideaway Beach only on Royal Caribbean® at Perfect Day at CocoCay. Swim right up to the popping Hideaway Bar, fuelled by non-stop DJ-spun beats.",

            whyRoyalCouples_UltimateCouplesTitle: "THE ULTIMATE <br /> COUPLES DAY AT SEA",
            whyRoyalCouples_UltimateCouplesText:
                "Whether travelling with family, friends or as a couple, our interior staterooms have everything a guest could need, including 24-hour room service and a nightly turn-down service.",

            whyRoyalCouples_1030Title: "10:30",
            whyRoyalCouples_1030Text:
                "Race your partner 12 metres above the deck on the signature Rock Climbing Wall.",

            whyRoyalCouples_0900Title: "09:00",
            whyRoyalCouples_0900Text:
                "Take a stroll through Central Park and grab a breakfast sandwich at Park Cafe.",

            whyRoyalCouples_1100Title: "11:00",
            whyRoyalCouples_1100Text:
                "It’s time to hit the pool deck, race down slides, relax in the whirlpool and soak up the sun.",

            whyRoyalCouples_1230Title: "12:30",
            whyRoyalCouples_1230Text:
                "Head to the Windjammer for a buffet-style lunch of fresh fish and Mediterranean inspired salad.",

            whyRoyalCouples_1500Title: "15:00",
            whyRoyalCouples_1500Text:
                "Raise the bar on the North Star as it elevates you high above the ship for unrivalled 360-degree views.",

            whyRoyalCouples_1400Title: "14:00",
            whyRoyalCouples_1400Text:
                "Feel the freedom of freefall without even leaving the deck on the RipCord by iFLY simulator.",

            whyRoyalCouples_1730Title: "17:30",
            whyRoyalCouples_1730Text:
                "Indulge in the ultimate date night in the Main Dining Room for a world-class dining experience that invites you to taste your way around the world.",

            whyRoyalCouples_1930Title: "19:30",
            whyRoyalCouples_1930Text:
                "Indulge in the ultimate date night in the Main Dining Room for a world-class dining experience that invites you to taste your way around the world.",

            whyRoyalCouples_2230Title: "22:30",
            whyRoyalCouples_2230Text:
                "Watch all-star performers at the Ice Show unleash maximum axels and supersized spins like nothing you’ve seen before.",

            whyRoyalCouples_2100Title: "21:00",
            whyRoyalCouples_2100Text:
                "Sing your heart out at a West End hit musical miles away from the mainland.",

            whyRoyalCouples_0000Title: "00:00",
            whyRoyalCouples_0000Text:
                "Dance the night away in the Music Hall, this premier place for live music lovers deserves a spot on your after-dark setlist.",

            // Royal Friends

            whyRoyalFriends_GroupTitle1: "Why Royal for",
            whyRoyalFriends_GroupTitle2: "Friends and Groups",
            whyRoyalFriendsDescription: `Get ready for an unforgettable holiday experience with Royal Caribbean. Gather your adventure-loving friends and embark on a journey like no other. Indulge in world-class cuisine, amazing parties, and exhilarating activities, all while exploring a stunning array of bucket-list destinations. From sun-soaked days to breathtaking views, every moment is designed to create lifelong memories.`,

            whyRoyalFriends_GroupActivitiesTitle: "Group Activities",
            whyRoyalFriends_GroupActivitiesText:
                "Royal Caribbean offers an unparalleled variety of group activities, including dance classes, sports tournaments, and even the chance to show off – or crash out – on FlowRider. These activities are a great opportunity for you and your friends to let loose and make long-lasting memories.",

            whyRoyalFriends_TasteParadiseTitle: "A Taste of <br /> Paradise",
            whyRoyalFriends_TasteParadiseText:
                "However you wish to unwind, we always raise the bar. Whether you're craving a tiki-inspired drink in a Polynesian-themed lounge, poolside piña coladas with live calypso music, or a custom cocktail crafted by the Bionic Bar’s robotic bartenders, we’ve got you covered!",

            whyRoyalFriends_DiningOptionsTitle: "Dining Options",
            whyRoyalFriends_DiningOptionsText:
                "Wondering what you’ll eat on board? With hundreds of options to choose from – the superb, sizzling steak at Chops Grille, to tasty Tex-Mex tacos at El Loco Fresh – you’re guaranteed to find something the whole group will love!",

            whyRoyalFriends_BestSeatTitle: "The Best Seats <br /> in the House",
            whyRoyalFriends_BestSeatText:
                "With world-famous acts every night of the week, Royal Caribbean redefines cruise entertainment. Delight in spectacular West End musicals and laugh out loud with comedians fresh from the circuit.",
        },
        es: {
            // UI
            headingWhyRoyal: "PORQUÉ ROYAL",
            textPutYourWalletAway: "No necesitas la cartera",
            textServicesAmenities: "SERVICIOS & INSTALACIONES PARA TI",
            textBook: "RESERVAR",
            textNow: "AHORA",
            textCall: "Llamar",
            textEmail: "Correo electrónico",

            // Royal Families

            whyRoyalFamiliesTitle1: "Royal para",
            whyRoyalFamiliesTitle2: "Familias",
            whyRoyalFamiliesDescription:
                "Imagina un lugar donde se dan cita el lujo, la aventura y el relax. Royal Caribbean te ofrece vacaciones inolvidables para toda la familia, con actividades para todas las edades, manjares que encantarán a los comensales más exigentes, espectáculos de Broadway, islas privadas y baños de sol infinitos. No es necesario sacrificar el descanso para explorar. Puedes convertir estas vacaciones en familia en una aventura para todos.",

            whyRoyalFamilies_MealtimeTitle: "Las comidas serán Impresionantes",
            whyRoyalFamilies_MealtimeText:
                "My Time Family Dining garantiza que los niños comen bien antes de pasar a los juegos y la diversión, dejando así que sus padres disfruten de una cena más relajada.  ¿Vemos la carta de postres?",

            whyRoyalFamilies_FamilyTitle: "Tiempo en familia, Garantizado",
            whyRoyalFamilies_FamilyText:
                "Si consigues arrancar a tus hijos de la diversión para disfrutar de tiempo en familia de calidad, tendrás infinidad de momentos para inmortalizar en albums de fotos, jugando en la piscina, viendo una película en cubierta, probando helados de todos los sabores, o retando a vuestros hijos a competir contra vosotros jugando en Playmakers℠ Sports Bar & Arcade.",

            whyRoyalFamilies_ReadyTitle: "Preparados, listos, ¡A jugar!",
            whyRoyalFamilies_ReadyText:
                "Bienvenidos niños y adolescentes. Desde el momento que suban a bordo no tendrán tiempo de aburrirse. Laser Tag, autos de choque, toboganes acuáticos, escape rooms, simuladores de surf y mucho más. La cantidad de actividades diseñadas para divertir y entretener a todas las edades no tiene fin. Mientras, imagínate tomando el sol con una copa en la mano. Relax.",

            whyRoyalFamilies_SeatTitle: "Las mejores localidades del teatro",
            whyRoyalFamilies_SeatText:
                "Lleva a tu familia a los espectáculo más impresionantes. Todas las noches podréis alucinar con producciones de primera categoría. Y los más pequeños podrán asistir a matinés especiales para ellos. Todo incluido en tus vacaciones. Cada noche será sensacional. ¡Solo has de preocuparte por si tus hijos te piden más una vez en tierra!",

            whyRoyalFamilies_ExplainBoxBigTitle: "NIÑOS, ADOLESCENTES & TODAS LAS EDADES",
            whyRoyalFamilies_ExplainBoxBigText:
                "Hay dos razones por las cuales nuestro galardonado Adventure Ocean Kids Club, también incluido, te dibujará una sonrisa en el rostro. Primero, porque tus hijos lo van a pasar en grande, harán amigos y vivirán momentos que no olvidarán nunca. Pero lo mejor es que al fin podrás disfrutar de ese tiempo para ti que tanto te mereces. Puedes olvidar tus obligaciones parentales. Ser libre, hacer lo que te apetezca... probablemente cerrar los ojos y soñar tumbado al sol.",

            whyRoyalFamilies_ExplainGridAdventureOceanTitle: "adventure ocean",
            whyRoyalFamilies_ExplainGridAdventureOceanSubtitle: "Royal Babies & Tots™ Guardería",
            whyRoyalFamilies_ExplainGridAdventureOceanText:
                "Bebés de 6–36 meses  aprenden mientras juegan con juguetes y juegos interactivos, con sus padres y con nuestro personal cualificado. <br><br> *Este servicio tiene un cargo adicional",

            whyRoyalFamilies_ExplainGridAquanautsTitle: "Aquanautas",
            whyRoyalFamilies_ExplainGridAquanautsSubtitle: " De3 a 5 Años",
            whyRoyalFamilies_ExplainGridAquanautsText:
                "¡Llamando a los niños imaginativos! Tenemos actividades que desafiarán a sus cerebritos. Juegos, música, estudio de arte, teatro y laboratorio de ciencias. Si dejas a tus hijos con nosotros mucho tiempo, puede que te lleves a casa un niño prodigio al final de las vacaciones.",

            whyRoyalFamilies_ExplainGridExplorersTitle: "Exploradores",
            whyRoyalFamilies_ExplainGridExplorersSubtitle: "De 6 a 8 Años",
            whyRoyalFamilies_ExplainGridExplorersText:
                "Los pequeños exploradores aprenderán a través de la aventura y la diversión. Viajarán por el espacio, buscarán fósiles, bailarán sin límite y podrán experimentar con todos los sabores de helado que puedan comer. Y mientras tus pequeños exploradores disfrutan, tú serás libre para explorar todas las atracciones del barco (o sus bares).",

            whyRoyalFamilies_ExplainGridVoyagersTitle: "Viajeros",
            whyRoyalFamilies_ExplainGridVoyagersSubtitle: "De 9 a 11 Años",
            whyRoyalFamilies_ExplainGridVoyagersText:
                "Deja que tu mini-explorador salga a buscar aventuras con nosotros. Tendrá acceso al backstage y a un montón de actividades deportivas. Volverá emocionado con muchas historias que contar. Incluso puede que haya encontrado algún tesoro oculto!",

            whyRoyalFamilies_ExplainGridTeensTitle: "Adolescentes",
            whyRoyalFamilies_ExplainGridTeensSubtitle: "De 12 a 17 Años",
            whyRoyalFamilies_ExplainGridTeensText:
                "Lo que ocurre en nuestras legendarias fiestas en la piscina, en el karaoke y en las discotecas es un misterio. Se hacen muchos selfies por lo que parece. Y es que estamos en nuestra zona exclusiva para adolescentes. No se permite la entrada de padres.",

            whyRoyalFamilies_ExplainGridLateNightKidsTitle: "Zona de fiesta nocturna para niños",
            whyRoyalFamilies_ExplainGridLateNightKidsText:
                "Sabemos que es hora de irse a la cama peo en vacaciones los jóvenes tienen permiso para seguir con la diversión. Una idea perfecta para jóvenes aves nocturnas y para que los menos jóvenes salgan a disfrutar del espíritu juvenil de sus tiempos mozos.",

            whyRoyalFamilies_ExplainGridMixBigBoxTitle:
                "LOS INSUPERABLES <br /> DÍAS EN EL MAR CON LA FAMILIA",
            whyRoyalFamilies_ExplainGridMixBigBoxText:
                "Disfruta estas increíbles activiades a bordo sin cargo adicional.",

            whyRoyalFamilies_ExplainGridMix1030Title: "10:30",
            whyRoyalFamilies_ExplainGridMix1030Text:
                "Aprende a surfear dominando las olas en nuestro revolucionario Flowrider.",

            whyRoyalFamilies_ExplainGridMix0900Title: "09:00",
            whyRoyalFamilies_ExplainGridMix0900Text:
                "Disfruta del desayuno en The Windjammer, perfecto para empezar el día con energía.",

            whyRoyalFamilies_ExplainGridMix1130Title: "11:30",
            whyRoyalFamilies_ExplainGridMix1130Text:
                "Atrévete con el parque acuático. Te vas a enfrentar a nuestros toboganes más escalofriantes.",

            whyRoyalFamilies_ExplainGridMix1300Title: "13:00",
            whyRoyalFamilies_ExplainGridMix1300Text:
                "Es el momento de acercarse a El Loco Fresh para probar sus sabrosos tacos y quesadillas.",

            whyRoyalFamilies_ExplainGridMix1600Title: "16:00",
            whyRoyalFamilies_ExplainGridMix1600Text:
                "Hora de llevar a toda la familia a tomarse un delicioso helado por la piscina.",

            whyRoyalFamilies_ExplainGridMix1400Title: "14:00",
            whyRoyalFamilies_ExplainGridMix1400Text: "Subida de adrenalina: prueba la tirolina.",

            whyRoyalFamilies_ExplainGridMix1700Title: "17:00",
            whyRoyalFamilies_ExplainGridMix1700Text:
                "Quizá cantes como los ángeles. O puede que sólo cantes en la ducha. No importa, te damos la bienvenida al Spotlight Karaoke para que cantes tus canciones favoritas. Tenemos miles de canciones para elegir.",

            whyRoyalFamilies_ExplainGridMix1930Title: "19:30",
            whyRoyalFamilies_ExplainGridMix1930Text:
                "Lleva a tu familia a cenar por todo lo alto. Para eso tenemos a bordo ese lugar especial, the Main Dining Room.",

            whyRoyalFamilies_ExplainGridMix2200Title: "22:00",
            whyRoyalFamilies_ExplainGridMix2200Text:
                "No te pierdas el alucinante espectáculo del AquaTheater. Al final te pondrás en pie para una clamorosa ovación.",

            whyRoyalFamilies_ExplainGridMix2100Title: "21:00",
            whyRoyalFamilies_ExplainGridMix2100Text:
                "Ponte los patines para demostrar tu arte sobre la pista de hielo.",

            whyRoyalFamilies_ExplainGridMix2300Title: "23:00",
            whyRoyalFamilies_ExplainGridMix2300Text:
                "Entra a Sorrento’s con los tuyos para saborear una buena porción de pizza antes de irte a dormir.",

            // Royal Couples

            whyRoyalCouplesTitle1: "Royal para",
            whyRoyalCouplesTitle2: "Parejas",
            whyRoyalCouplesDescription:
                "¿Hay algo más romántico que explorar un elegante barco rebosante de aventuras con tu alma gemela? Royal Caribbean te ofrece destinos de ensueño, zonas exclusivas para adultos, experiencias gastronómicas y espectáculos de primera categoría. Ven a disfrutar de unas vacaciones llenas de cultura, relax, y vivencias asombrosas. Nunca una escapada romántica fue tan emocionante. ",

            whyRoyalCouples_CompetitiveTitle: "Competitivos, Nosotros?",
            whyRoyalCouples_CompetitiveText:
                "Nada que objetar a la competitividad si es competencia sana. Compite subiendo la pared de escalada, compite a ver quien se desliza más rápido por nuestros legendarios toboganes. O en el simulador de surf. ¿Quién será coronado en la cresta de la ola?",

            whyRoyalCouples_PoolsideTitle: "Piscinas <br /> Paraíso",
            whyRoyalCouples_PoolsideText:
                "Días en el mar relajantes, absorviendo el sol en la tumbona con una bebida super fría. Sumérgete en nuestra emblemática piscina infinita al son de ritmos playeros, nada hasta la barra de bar, baila en la pista y disfruta del remanso de paz más elevado a un nivel de chic estratosférico.",

            whyRoyalCouples_HavenTitle: "Un puerto de <br /> Ultimate <br /> Relajación",
            whyRoyalCouples_HavenText:
                "Regálate una estancia romántica. Y trae a alguien especial. Nunca lo olvidará. Disfrutad del suntuoso confort de la suite, de un espacio exclusivo con un bar repleto de deliciosas exquisiteces, y de estar a un paso de la Sun Deck. Se forjarán recuerdos inolvidables.",

            whyRoyalCouples_IntimateTitle: "Cena romántica <br /> para dos",
            whyRoyalCouples_IntimateText:
                "Cena romántica con servicio excepcional o brunch relajado previo día de aventuras. En cualquier caso, te mimamos con multitud de opciones para degustar platos exquisitos a bordo. Y a cualquier hora del día.",

            whyRoyalCouples_SailTogetherTitle: "Los que navvegan<br /> juntos",
            whyRoyalCouples_SailTogetherText:
                "Reaviva la llama romántica con una escapada inolvidable a uno de los destinos más aclamados del planeta: el Caribe. Un paraíso de playas con arenas blancas, cielos estrellados y noches balsámicas donde disfrutar juntos. Celebra tu aniversario o tu luna de miel bajo las palmeras mientras te sumerges en la serenidad regalo del sol.",

            whyRoyalCouples_PerfectDayTitle: "",
            whyRoyalCouples_PerfectDayText:
                "Para parejas ávidas de divesión ofrecemos las fiestas más rompedoras a la orilla del mar, en pleno paraíso, solo para adultos. Es en Hideaway Beach, solo con Royal Caribbean® en Perfect Day at CocoCay. Puedes llegar nadando al vibrante Hideaway Bar y envolverte en la música que pinchan nuestros incansables Djs.",

            whyRoyalCouples_UltimateCouplesTitle: "LO ÚLTIMO EN <br /> DÍAS EN EL MAR EN PAREJA",

            whyRoyalCouples_UltimateCouplesText:
                "No importa si viajas con familia, amigos o en pareja, nuestros camarotes interiores tienen todo lo que el pasajero puede necesitar, incluyendo servicio de habitaciones las 24 horas y servicio de descubierta cada noche.",

            whyRoyalCouples_1030Title: "10:30",
            whyRoyalCouples_1030Text:
                "Reta a tu pareja. A ver quién sube antes los 12 metros de pared de escalada en nuestra distintiva Rock Climbing Wall.",

            whyRoyalCouples_0900Title: "09:00",
            whyRoyalCouples_0900Text:
                "Da un paseo por el Central Park y saborea un sandwich en Park Cafe.",

            whyRoyalCouples_1100Title: "11:00",
            whyRoyalCouples_1100Text:
                "Hora de acampar por la piscina, tirarte por los toboganes, relajarte en los jacuzzis y tumbarte al sol.",

            whyRoyalCouples_1230Title: "12:30",
            whyRoyalCouples_1230Text:
                "Visita el Windjammer para una comida estilo buffet. Prueba el pescado fresco y las ensaladas Mediterráneas.",

            whyRoyalCouples_1500Title: "15:00",
            whyRoyalCouples_1500Text:
                "Esto es subir el nivel: elévate en el North Star por encima del barco y obtendrás una vista de 360 grados sin parangón.",

            whyRoyalCouples_1400Title: "14:00",
            whyRoyalCouples_1400Text:
                "Siente la libertad de la caída libre sin abandonar la cubierta: prueba el simulador RipCord by iFLY.",

            whyRoyalCouples_1730Title: "17:30",
            whyRoyalCouples_1730Text:
                "Es vuestra última cita en el barco. Disfrutad de una cena inolvidable en el Main Dining Room, una experiencia gastronómica de primera que te invita a degustar sabores de todo el planeta.",

            whyRoyalCouples_1930Title: "19:30",
            whyRoyalCouples_1930Text:
                "Es vuestra última cita en el barco. Disfrutad de una cena inolvidable en el Main Dining Room, una experiencia gastronómica de primera que te invita a degustar sabores de todo el planeta.",

            whyRoyalCouples_2230Title: "22:30",
            whyRoyalCouples_2230Text:
                "El espectáculo en la pista de patinaje sobre hielo te ofrece figuras de primera categoría. El Ice Show te dejará boquiabierto con piruetas impresionantes y axels increíbles. No habrás visto nada igual.",

            whyRoyalCouples_2100Title: "21:00",
            whyRoyalCouples_2100Text:
                "Corea las cancciones de ese exitoso musical del West End lejos del teatro en tierra firme.",

            whyRoyalCouples_0000Title: "00:00",
            whyRoyalCouples_0000Text:
                "Baila toda la noche en el Music Hall. Un rincón especial con música en vivo que merece un hueco en tu lista de lista de citas nocturnas.",

            // Royal Friends

            whyRoyalFriends_GroupTitle1: "Royal para",
            whyRoyalFriends_GroupTitle2: "Amigos y Grupos",
            whyRoyalFriendsDescription: `Prepárate para unas vacaciones inolvidables con Royal Caribbean. Reúne a tus amigos aventureros y embarcad en un viaje sin igual. Os daréis el lujo de degustar alta cocina, de vibrar en fiestas increíbles, de participar en actividades super emocionantes, y de explorar los sorprendentes destinos turísticos que siempre quisisteis visitar. Días de sol, días de vistas impactantes: cada instante está diseñado para crear recuerdos indelebles.`,

            whyRoyalFriends_GroupActivitiesTitle: "Actividades en Grupo",
            whyRoyalFriends_GroupActivitiesText:
                "Royal Caribbean ofrece una gran variedad de actividades en grupo que incluyen clases de baile, torneos deportivos, y también la posibilidad de lucirte, o de caer derrotado, en el FlowRider. Estas actividades conseguirán que el grupo de amigos se sienta libre y disfrute de la diversión generando así recuerdos inolvidables.",

            whyRoyalFriends_TasteParadiseTitle: "Una Dosis de<br /> el Paraíso",
            whyRoyalFriends_TasteParadiseText:
                "Hay muchas formas de disfrutar del relax y aquí siempre lo hacemos con nivel. La variedad en las maneras de mimarte incluye caprichos como un cóctel al estilo tiki en un espacio temático de Polinesia, una piña colada en la piscina al son de música calypso, o un cóctel personalizado confeccionado en nuestro Bionic Bar por un barman robótico. ¿Alguien da más?",

            whyRoyalFriends_DiningOptionsTitle: "Opciones gastronómicas",
            whyRoyalFriends_DiningOptionsText:
                "¿Pensando en lo que vas a comer a bordo? Hay cientos de opciones a elegir, como un magnífico filetón en Chops Grille o los sabrosísimos tacos Tex-Mex del El Loco Fresh. Está garantizado: siempre podréis encontrar algo que le guste a todo el grupo.",

            whyRoyalFriends_BestSeatTitle: "Las mejores butacas<br /> del Teatro",
            whyRoyalFriends_BestSeatText:
                "Royal Caribbean redefine los espectáculos de un crucero con obras de primera categoría todas las noches de la semana. Alucina y deléitate con extraordinarios musicales del West End y monologuistas escapados de sus giras para arrancarte la carcajada más sonora.",
        },
    },
    accessibility: {
        en: {
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
            headerDescription:
                "There's a wonderful world of adventure awaiting you and there's no one that can bring it to life like Royal Caribbean International. We've always believed that discovering and exploring the world around us is something that everyone should be able to enjoy, and over the years we've been an industry leader in providing the finest cruise holiday experience for all of our guests.",
            contactTitle: "HOW TO CONTACT US",
            contactDescription: (
                <>
                    To notify us of your needs please email us at{" "}
                    <a
                        href="mailto:royalspecialservicesuk@rccl.com"
                        className="underline text-rebrandRcBlue"
                        rel="noreferrer"
                    >
                        royalspecialservicesuk@rccl.com
                    </a>{" "}
                    or{" "}
                    <a
                        href="mailto:special_needs@rccl.com"
                        className="underline text-rebrandRcBlue"
                        rel="noreferrer"
                    >
                        special_needs@rccl.com
                    </a>
                    .
                    <br />
                    We will make reasonable efforts to provide requested equipment or services but
                    we do not guarantee they are provided. Services and features vary by ship.
                    <br />
                    <br />
                    <a
                        className="underline font-darwinProBold"
                        href="https://creative.rccl.com/Sales/Royal/Accessible_Seas/20074179_Accessible_Seas_Brochure_2020.pdf"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Click here
                    </a>{" "}
                    for the Accessible Seas Brochure
                </>
            ),
            firstText: (
                <>
                    Royal Caribbean believes the best holidays come without limitations. We are
                    committed to providing the most accessible cruise holiday experience for our
                    guests. That’s why we outfit our ships with a wide variety of features and
                    programmes designed to give access to all. Rest assured, wherever our ships can
                    go, your customers can too. <br />
                    <br />
                    Every Royal Caribbean cruise is accessible, and offers features and services for
                    guests across a wide range of disabilities. Here are just some of the services
                    we provide onboard.{" "}
                </>
            ),
            secondTitle: "Accessible Rooms on Royal",
            secondText: (
                <>
                    We’re industry leaders in providing the finest cruise holiday experience for all
                    our guests - and offer a range of accessible staterooms to meet your customers'
                    needs. From Interiors to Suites we have the right option for them. <br />
                    <br />
                    Our accessible staterooms feature a variety of benefits to assist our guests
                    with mobility disabilities. Accessible staterooms are larger, allowing
                    wheelchair users to navigate in any accessible stateroom. The larger room also
                    allows for their mobility devices to be stored in the room overnight (not the
                    hallway or other public spaces.) <br />
                    <br />
                    *Please note that inventory is limited for accessible staterooms and a Special
                    Needs form must be filled out and returned showing that there is need for the
                    accessible features of the stateroom.
                </>
            ),
            thirdTitle1: "Mobility",
            thirdText1: (
                <>
                    With a variety of features onboard to allow our guests access to their entire
                    cruise holiday, some of the highlights include: <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>Lifts for pools and whirlpools </li>
                        <li>All theatres </li>
                        <li>Carousel </li>
                        <li>Wide tire beach chairs at Perfect Day at CocoCay and Labadee </li>
                        <li>Access to all public areas and restrooms</li>
                    </ul>
                </>
            ),
            thirdTitle2: "Visual",
            thirdText2: (
                <>
                    For our guests who are blind or have low vision we offer:
                    <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>
                            Braille and tactile public room signage, elevator buttons, and audio
                            call signals
                        </li>
                        <li>Large print menus and daily activity planners</li>
                        <li>
                            Qualified readers as select crew members have been trained as qualified
                            readers for written material. Waiters will also read dining room menus
                            upon request.
                        </li>
                    </ul>
                </>
            ),
            fourthTitle: "Hearing",
            fourthText: (
                <>
                    For our guests with a hearing disability we offer:
                    <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>Closed Caption TV (on a limited basis) </li>
                        <li>Sound Enhancing Devices in the Theatres </li>
                        <li>Assistive Listening Devices including: </li>
                        <li>Strobe light door knocker </li>
                        <li>Alarm clock with vibrator </li>
                        <li>Telephone ring strobe light </li>
                        <li>Telephone handset amplifier </li>
                        <li>Visual Tactile Alert System kits in staterooms</li>
                    </ul>
                </>
            ),
            fifthTitle: "Autism/Developmental Disability",
            fifthText: (
                <>
                    Autism-Friendly Products and Services Available On All Ships: <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>Expedited/Supported check-in, boarding, and departure</li>
                        <li>Special dietary accommodations including gluten-free and dairy-free</li>
                        <li>
                            Adventure Ocean flexible grouping by ability for children 3 to 12 years
                            old
                        </li>
                        <li>Adventure Ocean toilet-trained policy exception</li>
                        <li>
                            Pagers/phones for parents of children while signed into the care of
                            Adventure Ocean programmes (subject to availability)
                        </li>
                        <li>Teen programmes with teens-only hangouts and activities*</li>
                        <li>The Autism Channel</li>
                        <ul className="ml-8 space-y-2 list-disc">
                            <li>
                                We offer complimentary on-demand access to The Autism Channel on
                                most of our ships. The Autism Channel provides educational and
                                entertainment programs about people with autism spectrum disorders.
                            </li>
                            <li>
                                The Autism Channel is available on all Icon, Quantum, Oasis,
                                Freedom, Voyager, and Radiance class ships. To access The Autism
                                Channel content, select The Autism Channel folder under OnDemand
                                Movies from the iTV (interactive TV) menu.
                            </li>
                        </ul>
                    </ul>
                    <br />
                    <span className="italic">
                        *Adults are not permitted in Teen or Adventure Ocean spaces.
                    </span>
                </>
            ),
            sixthTitle: "Accessible Dining",
            sixthText: (
                <>
                    We offer a variety of options to cover almost all dietary requirements, from
                    vegetarian options, to low/no sugar choices, as well as additional
                    considerations based on other medical or disability-related needs. <br />
                    <br />
                    We can accommodate most special dietary requirements in our Main Dining Room.
                    Speciality Dining venues are able to accommodate guests as long as they speak to
                    the waiter to discuss the menu and modifications needed. It is recommended to
                    meet with the Dining Team as soon as the guests board so that the restaurant may
                    start prepping the dining venues for guests with food allergies.
                </>
            ),
            seventhTitle: "Accessible Shore Excursions",
            seventhText: (
                <>
                    Explore in comfort with Accessible Shore Excursions. <br />
                    <br />
                    Immerse yourself in our destinations with Accessible Shore Excursions, unique
                    cultural excursions that accommodate scooters, wheelchairs, walkers and more.
                    These tours were designed with you in mind.
                    <br />
                    <br />
                    <a
                        className="underline font-darwinProBold"
                        href="https://www.royalcaribbean.com/content/royal/gbr/en/experience/accessible-cruising/accessible-shore-excursions?&country=GBR"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Click here
                    </a>{" "}
                    for more accessible shorex information.
                </>
            ),
        },
        nordics: {
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
            headerDescription:
                "There's a wonderful world of adventure awaiting you and there's no one that can bring it to life like Royal Caribbean International. We've always believed that discovering and exploring the world around us is something that everyone should be able to enjoy, and over the years we've been an industry leader in providing the finest cruise holiday experience for all of our guests.",
            contactTitle: "HOW TO CONTACT US",
            contactDescription: (
                <>
                    To notify us of your needs please email us at{" "}
                    <a
                        href="mailto:royalspecialservicesuk@rccl.com"
                        className="underline text-rebrandRcBlue"
                        rel="noreferrer"
                    >
                        royalspecialservicesuk@rccl.com
                    </a>{" "}
                    or{" "}
                    <a
                        href="mailto:special_needs@rccl.com"
                        className="underline text-rebrandRcBlue"
                        rel="noreferrer"
                    >
                        special_needs@rccl.com
                    </a>
                    .
                    <br />
                    We will make reasonable efforts to provide requested equipment or services but
                    we do not guarantee they are provided. Services and features vary by ship.
                    <br />
                    <br />
                    <a
                        className="underline font-darwinProBold"
                        href="https://creative.rccl.com/Sales/Royal/Accessible_Seas/20074179_Accessible_Seas_Brochure_2020.pdf"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Click here
                    </a>{" "}
                    for the Accessible Seas Brochure
                </>
            ),
            firstText: (
                <>
                    Royal Caribbean believes the best holidays come without limitations. We are
                    committed to providing the most accessible cruise holiday experience for our
                    guests. That’s why we outfit our ships with a wide variety of features and
                    programmes designed to give access to all. Rest assured, wherever our ships can
                    go, your customers can too. <br />
                    <br />
                    Every Royal Caribbean cruise is accessible, and offers features and services for
                    guests across a wide range of disabilities. Here are just some of the services
                    we provide onboard.{" "}
                </>
            ),
            secondTitle: "Accessible Rooms on Royal",
            secondText: (
                <>
                    We’re industry leaders in providing the finest cruise holiday experience for all
                    our guests - and offer a range of accessible staterooms to meet your customers'
                    needs. From Interiors to Suites we have the right option for them. <br />
                    <br />
                    Our accessible staterooms feature a variety of benefits to assist our guests
                    with mobility disabilities. Accessible staterooms are larger, allowing
                    wheelchair users to navigate in any accessible stateroom. The larger room also
                    allows for their mobility devices to be stored in the room overnight (not the
                    hallway or other public spaces.) <br />
                    <br />
                    *Please note that inventory is limited for accessible staterooms and a Special
                    Needs form must be filled out and returned showing that there is need for the
                    accessible features of the stateroom.
                </>
            ),
            thirdTitle1: "Mobility",
            thirdText1: (
                <>
                    With a variety of features onboard to allow our guests access to their entire
                    cruise holiday, some of the highlights include: <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>Lifts for pools and whirlpools </li>
                        <li>All theatres </li>
                        <li>Carousel </li>
                        <li>Wide tire beach chairs at Perfect Day at CocoCay and Labadee </li>
                        <li>Access to all public areas and restrooms</li>
                    </ul>
                </>
            ),
            thirdTitle2: "Visual",
            thirdText2: (
                <>
                    For our guests who are blind or have low vision we offer:
                    <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>
                            Braille and tactile public room signage, elevator buttons, and audio
                            call signals
                        </li>
                        <li>Large print menus and daily activity planners</li>
                        <li>
                            Qualified readers as select crew members have been trained as qualified
                            readers for written material. Waiters will also read dining room menus
                            upon request.
                        </li>
                    </ul>
                </>
            ),
            fourthTitle: "Hearing",
            fourthText: (
                <>
                    For our guests with a hearing disability we offer:
                    <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>Closed Caption TV (on a limited basis) </li>
                        <li>Sound Enhancing Devices in the Theatres </li>
                        <li>Assistive Listening Devices including: </li>
                        <li>Strobe light door knocker </li>
                        <li>Alarm clock with vibrator </li>
                        <li>Telephone ring strobe light </li>
                        <li>Telephone handset amplifier </li>
                        <li>Visual Tactile Alert System kits in staterooms</li>
                    </ul>
                </>
            ),
            fifthTitle: "Autism/Developmental Disability",
            fifthText: (
                <>
                    Autism-Friendly Products and Services Available On All Ships: <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>Expedited/Supported check-in, boarding, and departure</li>
                        <li>Special dietary accommodations including gluten-free and dairy-free</li>
                        <li>
                            Adventure Ocean flexible grouping by ability for children 3 to 12 years
                            old
                        </li>
                        <li>Adventure Ocean toilet-trained policy exception</li>
                        <li>
                            Pagers/phones for parents of children while signed into the care of
                            Adventure Ocean programmes (subject to availability)
                        </li>
                        <li>Teen programmes with teens-only hangouts and activities*</li>
                        <li>The Autism Channel</li>
                        <ul className="ml-8 space-y-2 list-disc">
                            <li>
                                We offer complimentary on-demand access to The Autism Channel on
                                most of our ships. The Autism Channel provides educational and
                                entertainment programs about people with autism spectrum disorders.
                            </li>
                            <li>
                                The Autism Channel is available on all Icon, Quantum, Oasis,
                                Freedom, Voyager, and Radiance class ships. To access The Autism
                                Channel content, select The Autism Channel folder under OnDemand
                                Movies from the iTV (interactive TV) menu.
                            </li>
                        </ul>
                    </ul>
                    <br />
                    <span className="italic">
                        *Adults are not permitted in Teen or Adventure Ocean spaces.
                    </span>
                </>
            ),
            sixthTitle: "Accessible Dining",
            sixthText: (
                <>
                    We offer a variety of options to cover almost all dietary requirements, from
                    vegetarian options, to low/no sugar choices, as well as additional
                    considerations based on other medical or disability-related needs. <br />
                    <br />
                    We can accommodate most special dietary requirements in our Main Dining Room.
                    Speciality Dining venues are able to accommodate guests as long as they speak to
                    the waiter to discuss the menu and modifications needed. It is recommended to
                    meet with the Dining Team as soon as the guests board so that the restaurant may
                    start prepping the dining venues for guests with food allergies.
                </>
            ),
            seventhTitle: "Accessible Shore Excursions",
            seventhText: (
                <>
                    Explore in comfort with Accessible Shore Excursions. <br />
                    <br />
                    Immerse yourself in our destinations with Accessible Shore Excursions, unique
                    cultural excursions that accommodate scooters, wheelchairs, walkers and more.
                    These tours were designed with you in mind.
                    <br />
                    <br />
                    <a
                        className="underline font-darwinProBold"
                        href="https://www.royalcaribbean.com/content/royal/gbr/en/experience/accessible-cruising/accessible-shore-excursions?&country=GBR"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Click here
                    </a>{" "}
                    for more accessible shorex information.
                </>
            ),
        },
        es: {
            textBook: "RESERVA",
            textNow: "AHORA",
            textCall: "Llamada",
            textEmail: "Correo electrónico",
            headerDescription:
                "Hay un mundo fantástico lleno de aventuras esperándote y nadie mejor que Royal Caribbean International® para llevarte a explorarlo. Creemos que descubrir el mundo que nos rodea debería estar al alcance de todos y por eso nos hemos esforzado siempre en convertirnos en líderes a la hora de proporcionar la mejor experiencia vacacional a nuestros clientes.",
            contactTitle: "CONTACTA CON NOSOTROS",
            contactDescription: (
                <>
                    Para comunicarnos tus necesidades envía un correo electrónico a
                    royalspecialservicesuk@rccl.com o rellena una solicitud por medio de nuestro
                    Accommodation Request Form en{" "}
                    <a
                        href="RoyalCaribbean.com/SpecialNeedsForm"
                        className="underline text-rebrandRcBlue"
                        target="_blank"
                    >
                        RoyalCaribbean.com/SpecialNeedsForm
                    </a>
                    .
                    <br /> Haremos lo que esté en nuestras manos para proporcionar el equipamiento y
                    los servicios necesarios que se nos solicite, aunque no podemos garantizar que
                    se proporcionen todos ellos. Los servicios y las instalaciones varían según el
                    barco.
                </>
            ),
            firstText: (
                <>
                    Royal Caribbean® cree que las mejores vacaciones no han de presentar barreras y
                    se compromete a hacer lo posible para que la experiencia sea accesible para
                    todos. Con esta finalidad, hemos acondicionado nuestros barcos con una serie de
                    servicios de apoyo y programas especiales diseñados para proporcionar
                    accesibilidad. Donde van nuestros barcos, pueden ir vuestros clientes. <br />
                    <br />
                    Todos los barcos de Royal Caribbean® presentan medidas de accesibilidad para
                    pasajeros con discapacidad. A continuación enumeramos algunos de estos servicios
                    disponibles a bordo.
                </>
            ),
            secondTitle: "Las habitaciones accesibles de Royal",
            secondText: (
                <>
                    Somos líderes en conseguir los cruceros más impresionantes y las vacaciones más
                    extraordinarias para todos nuestros clientes. Para ello, ofrecemos una serie de
                    camarotes accesibles que se adaptan a las necesidades de nuestros pasajeros.
                    Desde los camarotes interiores a las Suites, tenemos la solución adecuada para
                    alojarles. <br />
                    <br />
                    Nuestros camarotes accesibles presentan una serie de servicios para ayudar a
                    nuestros huéspedes con problemas de movilidad. Los camarotes accesibles son de
                    mayores dimensiones y permiten que las sillas de ruedas puedan maniobrar con
                    facilidad. El espacio extra permite también que las sillas y otros accesorios se
                    puedan guardar dentro del camarote por las noches (evitando así dejarlos en los
                    pasillos o en espacios públicos) <br />
                    <br />* La oferta de camarotes accesibles es limitada. Para demostrar que existe
                    la necesidad de un camarote accesible, será obligatorio rellenar una solicitud
                    de Necesidades Especiales.
                </>
            ),
            thirdTitle1: "Movilidad",
            thirdText1: (
                <>
                    Una serie de servicios permite a nuestros pasajeros acceder a las instalaciones
                    a bordo del crucero. Algunos de estos servicios incluyen: <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>Elevadores o ascensores para piscinas y jacuzzis</li>
                        <li>Todos los teatros</li>
                        <li>Carrusel</li>
                        <li>Perfect Day at CocoCay and Labadee</li>
                        <li>Todas las zonas y baños públicos</li>
                    </ul>
                </>
            ),
            thirdTitle2: "Discapacidad Visual",
            thirdText2: (
                <>
                    Para los pasajeros ciegos o con visión reducida ofrecemos:
                    <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>
                            Señalización de las zonas públicas y botones de los ascensores táctiles
                            en Braille y señales auditivas
                        </li>
                        <li>Menús y planes de actividades diarios en letra grande</li>
                        <li>
                            Lectores cualificados: algunos miembros de la tripulación han recibido
                            formación como lectores cualificados. Los camareros también pueden leer
                            los menús si se les solicita.
                        </li>
                    </ul>
                </>
            ),
            fourthTitle: "Problemas auditivos",
            fourthText: (
                <>
                    Para nuestros pasajeros con problemas de audición ofrecemos:
                    <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>Televisión con subtítulos (cantidad limitada)</li>
                        <li>Amplificadores de sonido en los teatros</li>
                        <li>Dispositivos de ayuda para personas con pérdida auditiva:</li>
                        <li>Timbre de la puerta con luz estroboscópica</li>
                        <li>Despertador con vibración</li>
                        <li>Luz estroboscópica cuando suena el teléfono</li>
                        <li>Amplificador auditivo en el teléfono</li>
                        <li>Camarotes con sistema de alerta táctil y visual</li>
                    </ul>
                </>
            ),
            fifthTitle: "Autismo/Discapacidades del Desarrollo",
            fifthText: (
                <>
                    En todos los barcos hay disponibilidad de productos y servicios para personas
                    con autismo: <br />
                    <br />
                    <ul className="ml-6 space-y-1 list-disc">
                        <li>Apoyo y rapidez en los procesos de check-in, embarque y salida</li>
                        <li>Dietas especiales que incluyen productos sin gluten y sin lactosa</li>
                        <li>
                            Grupos flexibles según habilidades para niños de entre 3 y 12 años en
                            Adventure Ocean
                        </li>
                        <li>
                            Excepciones en las condiciones para niños que aún no van solos al baño
                            en Adventure Ocean
                        </li>
                        <li>
                            Buscapersonas/ teléfonos para padres de los niños al cuidado de los
                            programas de Adventure Ocean (sujeto a disponibilidad)
                        </li>
                        <li>
                            Programas exclusivos para adolescentes con sus propios espacios y
                            actividades*{" "}
                        </li>
                        <li>El Canal de Autismo</li>
                        <ul className="ml-8 space-y-2 list-disc">
                            <li>The Autism Channel </li>
                            <li>
                                En la mayoría de nuestros barcos ofrecemos acceso gratuito por
                                encargo al canal de televisión The Autism Channel®. Este canal emite
                                programas educativos y de entretenimiento sobre personas del
                                espectro autista.
                            </li>
                            <li>
                                The Autism Channel está disponible en todos los barcos de las clases
                                Icon, Quantum, Oasis, Freedom, Voyager and Radiance. Para acceder a
                                los contenidos de The Autism Channel, selecciona la carpeta de The
                                Autism Channel en OnDemand Movies de iTV ( TV interactiva).
                            </li>
                        </ul>
                    </ul>
                    <br />
                    <span className="italic">
                        * No se admiten adultos en las instalaciones de Teen o Adventure Ocean.
                    </span>
                </>
            ),
            sixthTitle: "Restaurantes Accesibles",
            sixthText: (
                <>
                    Ofrecemos una gran variedad de opciones para cubrir casi todos las dietas, desde
                    vegetariana, pasando por dietas sin azúcar o bajas en azúcar, hasta necesidades
                    derivadas de discapacidades o prescripciones médicas. <br />
                    <br />
                    Podemos adecuar los menús a la mayoría de necesidades en nuestro restaurante
                    Main Dining Room. Los restaurantes de especialidad podrán adaptar sus menús
                    siempre que los pasajeros hablen con el camarero sobre las modificaciones que
                    necesitan. Recomendamos hablar con nuestro equipo, Dining Team, en cuanto sea
                    posible tras subir al barco. De este modo, los servicios de restauración podrán
                    preparar los menús para pasajeros con alergias alimentarias.
                </>
            ),
            seventhTitle: "Excursiones accesibles",
            seventhText: (
                <>
                    Explora cómodamente con Accessible Shore Excursions. <br />
                    <br />
                    Disfruta de nuestros destinos con Accessible Shore Excursions, excursiones
                    culturales únicas que se adaptan a sillas de ruedas, andadores y scooters. Estos
                    tours se han diseñado teniendo en cuenta tus necesidades.
                </>
            ),
        },
    },
    extras: {
        en: {
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
            firstTitle: "ELEVATE YOUR <br /> HOLIDAY",
            firstText: (
                <>
                    Money can’t buy happiness, but it can buy unbeatable luxury onboard our ships.
                    Discover extras designed to elevate your holiday to the next level all of which
                    can be <span className="font-darwinProBold">pre-booked</span> to make sure you
                    don't miss out.
                </>
            ),
            secondTitle: "FOR EVERY <br /> EXPLORER",
            secondText: (
                <>
                    These aren’t just tours; they’re zip line conquering, cave discovering,
                    underwater adventures. Explore island after island, culture after culture, and
                    city after city. With thousands of options, there’s something for families,
                    foodies, action lovers, and culture seekers. Explore the possibilities for{" "}
                    <span className="font-darwinProBold">shore excursions</span> and book before you
                    board.
                </>
            ),
            thirdTitle: "INDULGE YOURSELF",
            thirdText: (
                <>
                    It's your holiday - so take the time to look after number on. Let your worries
                    wash away with invigorating massages, age-defying facials and flawless manicures
                    at our peaceful <span className="font-darwinProBold">onboard spas</span>. Heaven
                    awaits.
                </>
            ),
            fourthTitle: "SAVOUR THE WORLD",
            fourthText: (
                <>
                    <span className="font-darwinProBold">Speciality dining</span> serves up a host
                    of restaurants for every craving and occasion. Indulge in the authentic taste of
                    Italy, feast on exotic Asian flavours, or savour freshly-caught fish and New
                    England-style seafood. You can experience several unique speciality restaurants
                    and enjoy great savings when you purchase one of our Speciality Dining Packages.
                    Enjoy multiple restaurants for a discounted price, the more you dine,the more
                    you save.
                </>
            ),
            fifthTitle: "GET A TASTE OF PARADISE",
            fifthText: (
                <>
                    Craving a tiki-inspired drink in a Polynesian themed lounge, poolside piña
                    coladas by the pool with live Calypso music, or how about a cocktail crafted by
                    robots? With Royal Caribbean we like to raise the bar. Enjoy unlimited soft
                    drinks, add on mocktails, premium coffees and teas and freshly squeezed juices,
                    or go all out with unlimited alcoholic drinks with the{" "}
                    <span className="font-darwinProBold">Deluxe Beverage package</span>*.
                    <br />
                    <br />
                    *Non alcoholic drinks packages are also available to purchase.
                </>
            ),
        },
        nordics: {
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
            firstTitle: "ELEVATE YOUR <br /> HOLIDAY",
            firstText: (
                <>
                    Money can’t buy happiness, but it can buy unbeatable luxury onboard our ships.
                    Discover extras designed to elevate your holiday to the next level all of which
                    can be <span className="font-darwinProBold">pre-booked</span> to make sure you
                    don't miss out.
                </>
            ),
            secondTitle: "FOR EVERY <br /> EXPLORER",
            secondText: (
                <>
                    These aren’t just tours; they’re zip line conquering, cave discovering,
                    underwater adventures. Explore island after island, culture after culture, and
                    city after city. With thousands of options, there’s something for families,
                    foodies, action lovers, and culture seekers. Explore the possibilities for{" "}
                    <span className="font-darwinProBold">shore excursions</span> and book before you
                    board.
                </>
            ),
            thirdTitle: "INDULGE YOURSELF",
            thirdText: (
                <>
                    It's your holiday - so take the time to look after number on. Let your worries
                    wash away with invigorating massages, age-defying facials and flawless manicures
                    at our peaceful <span className="font-darwinProBold">onboard spas</span>. Heaven
                    awaits.
                </>
            ),
            fourthTitle: "SAVOUR THE WORLD",
            fourthText: (
                <>
                    <span className="font-darwinProBold">Speciality dining</span> serves up a host
                    of restaurants for every craving and occasion. Indulge in the authentic taste of
                    Italy, feast on exotic Asian flavours, or savour freshly-caught fish and New
                    England-style seafood. You can experience several unique speciality restaurants
                    and enjoy great savings when you purchase one of our Speciality Dining Packages.
                    Enjoy multiple restaurants for a discounted price, the more you dine,the more
                    you save.
                </>
            ),
            fifthTitle: "GET A TASTE OF PARADISE",
            fifthText: (
                <>
                    Craving a tiki-inspired drink in a Polynesian themed lounge, poolside piña
                    coladas by the pool with live Calypso music, or how about a cocktail crafted by
                    robots? With Royal Caribbean we like to raise the bar. Enjoy unlimited soft
                    drinks, add on mocktails, premium coffees and teas and freshly squeezed juices,
                    or go all out with unlimited alcoholic drinks with the{" "}
                    <span className="font-darwinProBold">Deluxe Beverage package</span>*.
                    <br />
                    <br />
                    *Non alcoholic drinks packages are also available to purchase.
                </>
            ),
        },
        es: {
            textBook: "RESERVA",
            textNow: "AHORA",
            textCall: "Llamada",
            textEmail: "Correo electrónico",
            firstTitle: "ELEVA TUS VACACIONES",
            firstText:
                "El dinero no puede comprar la felicidad, pero puede comprar un lujo inigualable a bordo de nuestros barcos. Descubre extras diseñados para elevar tus vacaciones al siguiente nivel, todos los cuales se pueden reservar por adelantado para asegurarte de no perderte nada.",
            secondTitle: "PARA EXPLORADORES",
            secondText:
                "Lo nuestro no son tours, son aventuras: volar en la tirolina, descubrir cuevas y vivir aventuras submarinas. Explora islas, conoce otras culturas, admira ciudades emblemáticas. Hay para todos, para familias, gourmets y gente de acción. Estudia las ofertasde excursiones y reserva antes de subir a bordo.",
            thirdTitle: "DATE UN CAPRICHO",
            thirdText:
                "Es tu descanso, así que tómate el tiempo para cuidarte. Deja que tus preocupaciones se desvanezcan con masajes vigorizantes, faciales antiedad y manicuras impecables en nuestros tranquilos spas a bordo. El paraíso te espera.",
            fourthTitle: "SABOREA EL MUNDO",
            fourthText:
                "Cocina de especialidad en muchos restaurantes donde encontrarás platos adecuados para cada paladar y cada ocasión. Déjate seducir por los sabores de Italia, sorpréndete con el exotismo de Oriente o date el lujo de pescado fresco y marisco al estilo de New England. Prueba los diferentes restaurantes de especialidad con grandes descuentos comprando uno de nuestros paquetes Specialtity Dining Packages. Múltiples opciones con descuento.",
            fifthTitle: "UNSORBO DELPARAÍSO",
            fifthText: (
                <>
                    Prueba una bebida típica de la Polinesia, o una piña colada ¡o un cóctel hecho
                    por robots! Royal Caribbean sube el listón en sus bares, con bebidas no
                    alcohólicas incluidas, deliciosos móckteles, cafés y tés premium y zumos recién
                    exprimidos. También puedes comprar el paquete de bebidas alcohólicas ilimitadas
                    Deluxe Beverage package.
                </>
            ),
        },
    },
    micrositeHeader: {
        en: {
            whatsincludedTitle: "Put Your Wallet Away",
            whatsincludedSubtitle:
                "Why booking a Royal Caribbean Holiday is <br /> incredible value with so much included.",

            whyRoyalFamiliesTitle1: "Why Royal for",
            whyRoyalFamiliesTitle2: "Families",

            whyRoyalCouplesTitle1: "Why Royal for",
            whyRoyalCouplesTitle2: "Couples",

            whyRoyalFriends_GroupTitle1: "Why Royal for",
            whyRoyalFriends_GroupTitle2: "Friends and Groups",
            whyRoyalFriendsTitle: "Royal for Friends <br /> and Groups",
            whyRoyalCouplesTitle: "Royal for <br /> Couples",
            whyRoyalFamiliesTitle: "Royal for <br /> Families",
            suiteLifeTitle: "The Suite Life",
            suiteLifeSubtitle:
                "Why booking a Royal Caribbean Holiday is incredible<br /> value with so much included.",
            extrasTitle: "Additional Extras",
            extrasSubtitle:
                "Why booking a Royal Caribbean Holiday is incredible<br /> value with so much included.",
            accessibilityTitle: "Accessible Cruising",
        },
        nordics: {
            whatsincludedTitle: "Put Your Wallet Away",
            whatsincludedSubtitle:
                "Why booking a Royal Caribbean Holiday is <br /> incredible value with so much included.",
            whyRoyalFamiliesTitle1: "Why Royal for",
            whyRoyalFamiliesTitle2: "Families",

            whyRoyalCouplesTitle1: "Why Royal for",
            whyRoyalCouplesTitle2: "Couples",

            whyRoyalFriends_GroupTitle1: "Why Royal for",
            whyRoyalFriends_GroupTitle2: "Friends and Groups",
            suiteLifeTitle: "The Suite Life",
            extrasTitle: "Additional Extras",
            suiteLifeSubtitle:
                "Why booking a Royal Caribbean Holiday is incredible<br /> value with so much included.",
            extrasSubtitle:
                "Why booking a Royal Caribbean Holiday is incredible<br /> value with so much included.",
            accessibilityTitle: "Accessible Cruising",
        },
        es: {
            whatsincludedTitle: "No Necesitas la Cartera",
            whatsincludedSubtitle:
                '¡La tarifa de un crucero con Royal Caribbean no sólo incluye alojamiento digno de un hotel de 5 estrellas!  <br class="hidden lg:block">También incluye todas las comidas y bebidas a bordo y actividades increíbles como toboganes auáticos, tiovivos,  <br class="hidden lg:block">autos de choque, laser tag, paredes de escalada y mucho más.',
            whyRoyalFriendsTitle: "Royal para Amigos<br /> y Grupos",
            whyRoyalCouplesTitle: "Royal para <br /> Parejas",
            whyRoyalFamiliesTitle: "Royal para <br /> Familias",

            whyRoyalFamiliesTitle1: "Por Qué Royal Para",
            whyRoyalFamiliesTitle2: "Familias",

            whyRoyalCouplesTitle1: "Por Qué Royal Para",
            whyRoyalCouplesTitle2: "Parejas",

            whyRoyalFriends_GroupTitle1: "Por Qué Royal Para",
            whyRoyalFriends_GroupTitle2: "Amigos y Grupos",
            suiteLifeTitle: "La Vida En Suite",
            extrasTitle: "Extras  Adicionales",
            suiteLifeSubtitle:
                "Reservar unas vacaciones de Royal Caribbean es increíble<br /> por todo lo que está incluido.",
            extrasSubtitle:
                "Reservar unas vacaciones de Royal Caribbean es increíble<br /> por todo lo que está incluido.",
            accessibilityTitle: "Cruceros Accesibles",
        },
    },
    whatIncluded: {
        en: {
            diningTitle: "DINING",
            diningText:
                "Ever had French pastries on tap in the Mediterranean, exquisite seafood out at sea or more ice cream than you can shake a flake at? When it’s time to dine with Royal Caribbean the complimentary choices are endless. From steaks to shakes, there’s a menu for everyone, day or night.",
            sportTitle: "Sports, Fitness <br> & Wellness ",
            sportText:
                "With so much incredible food on offer, you might feel compelled to burn off some calories. It goes without saying we have a fully equipped gym, but if that’s a bit too run-of-the-mill, how does a climbing wall, basketball court or a 2,000ft running track sound? If that’s too much then how about a nice leisurely game of pool in our sports bar. It’s still a sport.",
            entertainmentTitle: "Entertainment <br> & Onboard <br> Activities",
            entertainmentText:
                "Where else can you twist and turn down 10 storeys and go for a spin in a dodgem without spending a penny. How about catching a wave in the morning and skydiving in the afternoon. From aqua shows to West End shows and everything in between, epic family entertainment is always free with Royal Caribbean.",

            familyTitle: "Family Venues & <br> Offering",
            familyText:
                "With free waterparks, mini golf, surfing, a Boardwalk, an Adventure Ocean kids club and even a dedicated space for teenagers included, we’ve got you covered. So whether you’re looking after your kids, want to hang out with your kids, or desperate to escape your kids, it won’t cost you a thing.",
            stateroomTitle: "Your Guide To Staterooms",
            stateroomText:
                "When you’re staying on an awe-inspiring ship, you’ll want accommodation to match. Whatever your budget, there’s the perfect room for everyone on board. Whether you feel like living the high life or simply indulging in a few little extras, you’ll have the space to stretch out and congratulate yourself on booking a suite like no other.",
            interiorStateroomTitle: "Interior Staterooms",
            interiorStateroomText:
                "Whether travelling with family, friends or as a couple, our interior staterooms have everything a guest could need, including 24-hour room service and a nightly turn-down service.",
            oceanViewBalconyTitle: "Ocean-View  Balcony  Rooms",
            oceanViewBalconyText:
                "Take in the breathtaking views and the fresh sea breeze with a balcony room. With luxurious bedding, in-suite dining, and uninterrupted sunsets, this romantic room is ideal for couples wanting a special stay.",
            oceanViewRoomsTitle: "Ocean-View  Rooms",
            oceanViewRoomsText:
                "Let there be light! With our ocean-view rooms, guests get a window to see the sea and shores at a more affordable price.",
            boardwalkBalconyRoomsTitle: "Boardwalk Balcony Rooms",
            boardwalkBalconyRoomsText:
                "Feel part of the hustle and bustle of the neighbourhood with a balcony overlooking the Boardwalk. If people-watching, sea air and lots of light is your thing, this is where you might like to call home.",
            centralParkBalconyTitle: "Central Park Balcony Rooms",
            centralParkBalconyText:
                "Take in the neighbourhood’s ambience with a balcony overlooking the green oasis of Central Park. These rooms are perfect for guests wanting sea air and lots of light, for a slightly smaller price than ocean-view balcony rooms.",
            virtualBalconyTitle: "Virtual Balcony Staterooms",
            virtualBalconyText:
                "With an 80-inch HD screen that spans nearly floor to ceiling, guests can enjoy real-time views of the ocean and destinations from the comfort of their interior staterooms.",
            titleWhatsIncluded: "WHAT'S INCLUDED",
            titleAddedExtras: "Added Extras",
            textNotIncluded: "The following services are not included in the cruise price:",
            listAddedExtra1: (
                <>
                    Dining in Speciality Restaurants such as Chops Grille, 150
                    <pre className="font-darwinProRegular text-colorPrimary">
                        Central Park, and Izumi
                    </pre>
                </>
            ),
            listAddedExtra2: "Dining in Johnny Rockets (Where applicable)",
            listAddedExtra3: "Spa and Salon services",
            listAddedExtra4: "Gambling (Including Bingo)",
            listAddedExtra5: "Art Auction",
            listAddedExtra6: "Any purchases made in the gift shops onboard",
            listAddedExtra7: "Shore excursions",
            listAddedExtra8: "Photographs",
            listAddedExtra9: "Video Arcade",
            listAddedExtra10: "Medical Services",
            listAddedExtra11: "Internet Access",
            listAddedExtra12: "Transfers (Unless guest has purchased our air/sea package)",
            listAddedExtra13: "Laundry and Dry Cleaning Services",
            listAddedExtra14: "Ship to Shore Telephone calls",
            listAddedExtra15: "Gratuities",
            listAddedExtra16: "Alcoholic Beverages",
            listAddedExtra17: "Non-Alcoholic Beverages (excluding water, lemonade and iced tea)",
            textFeaturesVary: "*Features and activities vary by ship.",
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
        },
        nordics: {
            diningTitle: "DINING",
            diningText:
                "Ever had French pastries on tap in the Mediterranean, exquisite seafood out at sea or more ice cream than you can shake a flake at? When it’s time to dine with Royal Caribbean the complimentary choices are endless. From steaks to shakes, there’s a menu for everyone, day or night.",
            sportTitle: "Sports, Fitness <br> & Wellness ",
            sportText:
                "With so much incredible food on offer, you might feel compelled to burn off some calories. It goes without saying we have a fully equipped gym, but if that’s a bit too run-of-the-mill, how does a climbing wall, basketball court or a 2,000ft running track sound? If that’s too much then how about a nice leisurely game of pool in our sports bar. It’s still a sport.",
            entertainmentTitle: "Entertainment <br> & Onboard <br> Activities",
            entertainmentText:
                "Where else can you twist and turn down 10 storeys and go for a spin in a dodgem without spending a penny. How about catching a wave in the morning and skydiving in the afternoon. From aqua shows to West End shows and everything in between, epic family entertainment is always free with Royal Caribbean.",

            familyTitle: "Family Venues & <br> Offering",
            familyText:
                "With free waterparks, mini golf, surfing, a Boardwalk, an Adventure Ocean kids club and even a dedicated space for teenagers included, we’ve got you covered. So whether you’re looking after your kids, want to hang out with your kids, or desperate to escape your kids, it won’t cost you a thing.",
            stateroomTitle: "Your Guide To Staterooms",
            stateroomText:
                "When you’re staying on an awe-inspiring ship, you’ll want accommodation to match. Whatever your budget, there’s the perfect room for everyone on board. Whether you feel like living the high life or simply indulging in a few little extras, you’ll have the space to stretch out and congratulate yourself on booking a suite like no other.",
            interiorStateroomTitle: "Interior Staterooms",
            interiorStateroomText:
                "Whether travelling with family, friends or as a couple, our interior staterooms have everything a guest could need, including 24-hour room service and a nightly turn-down service.",
            oceanViewBalconyTitle: "Ocean-View  Balcony  Rooms",
            oceanViewBalconyText:
                "Take in the breathtaking views and the fresh sea breeze with a balcony room. With luxurious bedding, in-suite dining, and uninterrupted sunsets, this romantic room is ideal for couples wanting a special stay.",
            oceanViewRoomsTitle: "Ocean-View  Rooms",
            oceanViewRoomsText:
                "Let there be light! With our ocean-view rooms, guests get a window to see the sea and shores at a more affordable price.",
            boardwalkBalconyRoomsTitle: "Boardwalk Balcony Rooms",
            boardwalkBalconyRoomsText:
                "Feel part of the hustle and bustle of the neighbourhood with a balcony overlooking the Boardwalk. If people-watching, sea air and lots of light is your thing, this is where you might like to call home.",
            centralParkBalconyTitle: "Central Park Balcony Rooms",
            centralParkBalconyText:
                "Take in the neighbourhood’s ambience with a balcony overlooking the green oasis of Central Park. These rooms are perfect for guests wanting sea air and lots of light, for a slightly smaller price than ocean-view balcony rooms.",
            virtualBalconyTitle: "Virtual Balcony Staterooms",
            virtualBalconyText:
                "With an 80-inch HD screen that spans nearly floor to ceiling, guests can enjoy real-time views of the ocean and destinations from the comfort of their interior staterooms.",
            titleWhatsIncluded: "WHAT'S INCLUDED",
            titleAddedExtras: "Added Extras",
            textNotIncluded: "The following services are not included in the cruise price:",
            listAddedExtra1: (
                <>
                    Dining in Speciality Restaurants such as Chops Grille, 150
                    <pre className="font-darwinProRegular text-colorPrimary">
                        Central Park, and Izumi
                    </pre>
                </>
            ),
            listAddedExtra2: "Dining in Johnny Rockets (Where applicable)",
            listAddedExtra3: "Spa and Salon services",
            listAddedExtra4: "Gambling (Including Bingo)",
            listAddedExtra5: "Art Auction",
            listAddedExtra6: "Any purchases made in the gift shops onboard",
            listAddedExtra7: "Shore excursions",
            listAddedExtra8: "Photographs",
            listAddedExtra9: "Video Arcade",
            listAddedExtra10: "Medical Services",
            listAddedExtra11: "Internet Access",
            listAddedExtra12: "Transfers (Unless guest has purchased our air/sea package)",
            listAddedExtra13: "Laundry and Dry Cleaning Services",
            listAddedExtra14: "Ship to Shore Telephone calls",
            listAddedExtra15: "Gratuities",
            listAddedExtra16: "Alcoholic Beverages",
            listAddedExtra17: "Non-Alcoholic Beverages (excluding water, lemonade and iced tea)",
            textFeaturesVary: "*Features and activities vary by ship.",
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
        },
        es: {
            diningTitle: "COMER",
            diningText:
                "¿Alguna vez has tenido pasteles franceses  al alcance de la mano navegando por el Mediterráneo, o un marisco exquisito en alta mar, o helados hasta que te canses de comer? Las comidas con Royal Caribbean ofrecen infinitas opciones incluidas. Hay carne, batidos, y menús para todos los gustos día y noche.",
            sportTitle: "Deportes, Fitness <br> & Bienestar",
            sportText:
                "Con tanta comida irresistible es posible que te veas inclinado a quemar algunas calorías. Ni que decir tiene que nuestro gimnasio está a tu disposición, totalmente equipado, pero si el gimasio lo tienes muy  visto, puede que prefieras probar la pared de escalada, o la pista de baloncesto, o el circuito de running de más de 600 metros. Y si tanto deporte te abruma, se acepta una partida de billar en nuestro bar deportivo. Deporte es.",
            entertainmentTitle: "Diversión <br> & Actividades <br> A bordo",
            entertainmentText:
                "¿Dónde más podrías serpentear y deslizarte por un tobogán de 10 pisos o subir a los autos de choque sin pagar nada? ¿Te apetece coger unas olas por la mañana y probar la caída libre por la tarde?  Por no hablar de los espectáculos: aqua shows, musicales del West End y de todo un poco. La diversión con mayúsculas para toda la familia está asegurada y es gratis con Royal Caribbean.",

            familyTitle: "Espacios para la familia & <br> Oferta",
            familyText:
                "Con tres parques acuáticos, mini golf, surf, el paseo Boardwalk, el club infantil Adventure Ocean, y un espacio exclusivo para adolescentes, todo incluido, lo tenemos dominado. Puedes cuidar a tus hijos, salir con ellos, o escapar de ellos. Haz lo que quieras. No pagarás por ello.",
            stateroomTitle: "Guía de Camarotes",
            stateroomText:
                "De crucero en un barco de impresión, querrás alojamiento a juego. No importa tu presupuesto, hay una habitación perfecta para cada persona a bordo. Vive la vida a todo lujo o simplemente disfruta de algunos extras. Tendrás espacio para expandirte y te alegrarás de haber reservado una suite única. ",
            interiorStateroomTitle: "Camarotes Interiores",
            interiorStateroomText:
                "No importa si viajas con familia, amigos o en pareja, nuestros camarotes interiores tienen todo lo que el pasajero puede necesitar, incluyendo servicio de habitaciones las 24 horas y servicio de descubierta cada noche.",
            oceanViewBalconyTitle: "Habitacione con Balcón Vista al Océano",
            oceanViewBalconyText:
                "Aspira las incomparables vistas y la brisa marina desde el balcón de tu habitación. Con camas a todo lujo, cena en la suite, y atardeceres de película, esta romántica habitación es ideal para parejas que buscan una estancia especial.",
            oceanViewRoomsTitle: "Habitaciones Con vistas al océano",
            oceanViewRoomsText:
                "¡Que se haga la luz! En nuestras habitaciones con vistas al océano los pasajeros disponen de una ventana para ver el mar y la línea de costa a un precio más económico",
            boardwalkBalconyRoomsTitle: "HABITACIONES con Balcó a BOARDWALK",
            boardwalkBalconyRoomsText:
                "Puedes sentirte parte del bullicio del barrio solo asomándote al balcón que da al paseo Boardwalk. Si te gusta ver el ambiente, respirar la brisa marina y ver la luz entrar a raudales, aquí te encontrarás en casa.",
            centralParkBalconyTitle: "CENTRAL PARK HABITACIONES CON BALCÓN",
            centralParkBalconyText:
                "Asómate a ver el ambiente desde tu balcón. Verás el oasis verde de Central Park. Estas habitaciones son ideales para pasajeros amantes de la brisa marina que quieran mucha luz. Y el precio es más bajo que el de las habitaciones con balcón al océano.",
            virtualBalconyTitle: "CAMAROTES CON BALCÓN VIRTUAL",
            virtualBalconyText:
                "Con una pantalla de 80 pulgadas en alta definición que ocupa casi toda la pared, los pasajeros pueden disfrutar de vistas al océano y la costa a tiempo real desde la comodidad de sus camarotes interiores.",
            titleWhatsIncluded: "QUE SE INCLUYE",
            titleAddedExtras: "Extras añadidos",
            textNotIncluded:
                "Los siguientes servicios no están incluidos en el precio del crucero:",
            listAddedExtra1: (
                <>
                    Cenar en restaurantes de especialidades como Chops Grille,
                    <pre className="font-darwinProRegular text-colorPrimary">
                        150 Central Park e Izumi
                    </pre>{" "}
                    Es
                </>
            ),
            listAddedExtra2: "Cenar en Johnny Rockets (Cuando sea aplicable)",
            listAddedExtra3: "Spa y servicios de Salón de belleza",
            listAddedExtra4: "Juegos de azar (Incluyendo el Bingo)",
            listAddedExtra5: "Subasta de arte",
            listAddedExtra6: "Compras realizadas en las tiendas de a bordo",
            listAddedExtra7: "Excursiones en tierra",
            listAddedExtra8: "Fotos",
            listAddedExtra9: "Videojuegos",
            listAddedExtra10: "Servicios médicos",
            listAddedExtra11: "Acceso a Internet",
            listAddedExtra12:
                "Tralados (A menos que el cliente haya contratado un paquete por aire o por mar con nosotros)",
            listAddedExtra13: "Lavandería y limpieza en seco",
            listAddedExtra14: "Llamadas de teléfono del barco a tierra",
            listAddedExtra15: "Propinas",
            listAddedExtra16: "Bebidas alcohólicas",
            listAddedExtra17: "Bebidas no alcohólicas (excluye agua, limonada y té frío)",
            textFeaturesVary: "*Las atracciones y actividades pueden variar según el barco.",
            textBook: "RESERVA",
            textNow: "AHORA",
            textCall: "Llamada",
            textEmail: "Correo electrónico",
        },
    },
    suiteLife: {
        en: {
            suiteLifeTitle: "The Suite Life",
            suiteLifeText:
                "Come onboard one of our spectacular ships and experience a luxurious lifestyle like no other. Enjoy deluxe accommodation, superior service, and special amenities for Suite guests – all crafted with your comfort in mind. Make it even more opulent by visiting our dedicated Suite Neighbourhoods on board Icon of the Seas! Unwind in style with ocean views from your own private plunge pool; tantalise every taste bud at unique five star dining venues that promise unforgettable gastronomic delights",
            skyClassTitle: "Sky Class",
            skyClassText:
                "As Sky Class guests, you have access to a Concierge who crafts your personal adventures, from restaurant reservations to recommendations for shopping or dining at ports of call. Plus access to the Suite Lounge the most elevated spot for indulging in your favourite eats and libations.",
            seaClassTitle: "Sea Class",
            seaClassText:
                "The Sea Class suites are perfect for recharging between adventures! These spacious suites offer plenty of living space, sumptuous design, and flawless attention to detail. You’ll notice the difference those little extra touches can make. You will be first onboard with priority boarding and can indulge at our exclusive restaurant for suite guests, Coastal Kitchen..",
            starClassTitle: "Star Class",
            starClassText:
                "Exclusively to Star Class, the Royal Genie is the ultimate way to make your holiday a unique, personalised VIP experience.  Imagine having your own personal butler who takes care of all your needs; from pre-trip requests to ensuring the best seats in the house, be that in a restaurant or a show. Your Genie will craft exclusive one of a kind experience, tailor-made to you.",
            upscaleTitle: "Upscale on a new Scale",
            upscaleText:
                "Just steps away from your room, discover the Suite Neighbourhood, a retreat with indulgences exclusively for suite guests. Soak up rays on the two-story sun deck or take a tranquil dip in the private pool and hot tub. Savour upscale cuisine at two restaurants for suite guests only, the casual elegance of Coastal Kitchen or al fresco Mediterranean bliss at The Grove. And at the Suite Lounge, enjoy bites and cocktails over jaw-dropping views right into the heart of the revolutionary AquaDome. It’s time you discover just how suite life can be.",
            touchMagicTitle: "Add a Touch <br /> of Magic",
            touchMagicText:
                "Exclusively to Star Class, the Royal Genie is the ultimate way to make your vacation a unique, personalised VIP experience. Imagine having your own personal butler who takes care of all your needs; from pre-trip requests to ensuring the best seats in the house, be that in a restaurant or a show. Your Genie will craft exclusive one of a kind experience, tailor-made to you.",
            headingTheSuiteLife: "THE SUITE LIFE",
            textEveryDetail: "EVERY DETAIL ACCOUNTED FOR",
            textAmenitiesForYou: "SERVICES & AMENITIES JUST FOR YOU",
            textInternetComplementary:
                "* Royal Suite Class is available on Icon Class ships as well as selected Oasis and Quantum Class ships. The complimentary Internet package is not available for Sky Junior Suites sailing on Allure, Anthem, Harmony, Icon, Oasis, Odyssey, Ovation, Quantum, Spectrum, Star, Symphony, Utopia and Wonder of the Seas®",
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
        },
        nordics: {
            suiteLifeTitle: "The Suite Life",
            suiteLifeText:
                "Come onboard one of our spectacular ships and experience a luxurious lifestyle like no other. Enjoy deluxe accommodation, superior service, and special amenities for Suite guests – all crafted with your comfort in mind. Make it even more opulent by visiting our dedicated Suite Neighbourhoods on board Icon of the Seas! Unwind in style with ocean views from your own private plunge pool; tantalise every taste bud at unique five star dining venues that promise unforgettable gastronomic delights",
            skyClassTitle: "Sky Class",
            skyClassText:
                "As Sky Class guests, you have access to a Concierge who crafts your personal adventures, from restaurant reservations to recommendations for shopping or dining at ports of call. Plus access to the Suite Lounge the most elevated spot for indulging in your favourite eats and libations.",
            seaClassTitle: "Sea Class",
            seaClassText:
                "The Sea Class suites are perfect for recharging between adventures! These spacious suites offer plenty of living space, sumptuous design, and flawless attention to detail. You’ll notice the difference those little extra touches can make. You will be first onboard with priority boarding and can indulge at our exclusive restaurant for suite guests, Coastal Kitchen..",
            starClassTitle: "Star Class",
            starClassText:
                "Exclusively to Star Class, the Royal Genie is the ultimate way to make your holiday a unique, personalised VIP experience.  Imagine having your own personal butler who takes care of all your needs; from pre-trip requests to ensuring the best seats in the house, be that in a restaurant or a show. Your Genie will craft exclusive one of a kind experience, tailor-made to you.",
            upscaleTitle: "Upscale on a new Scale",
            upscaleText:
                "Just steps away from your room, discover the Suite Neighbourhood, a retreat with indulgences exclusively for suite guests. Soak up rays on the two-story sun deck or take a tranquil dip in the private pool and hot tub. Savour upscale cuisine at two restaurants for suite guests only, the casual elegance of Coastal Kitchen or al fresco Mediterranean bliss at The Grove. And at the Suite Lounge, enjoy bites and cocktails over jaw-dropping views right into the heart of the revolutionary AquaDome. It’s time you discover just how suite life can be.",
            touchMagicTitle: "Add a Touch <br /> of Magic",
            touchMagicText:
                "Exclusively to Star Class, the Royal Genie is the ultimate way to make your vacation a unique, personalised VIP experience. Imagine having your own personal butler who takes care of all your needs; from pre-trip requests to ensuring the best seats in the house, be that in a restaurant or a show. Your Genie will craft exclusive one of a kind experience, tailor-made to you.",
            headingTheSuiteLife: "THE SUITE LIFE",
            textEveryDetail: "EVERY DETAIL ACCOUNTED FOR",
            textAmenitiesForYou: "SERVICES & AMENITIES JUST FOR YOU",
            textInternetComplementary:
                "* Royal Suite Class is available on Icon Class ships as well as selected Oasis and Quantum Class ships. The complimentary Internet package is not available for Sky Junior Suites sailing on Allure, Anthem, Harmony, Icon, Oasis, Odyssey, Ovation, Quantum, Spectrum, Star, Symphony, Utopia and Wonder of the Seas®",
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
        },
        es: {
            suiteLifeTitle: "La Vida En Suite",
            suiteLifeText:
                "Sube a bordo de uno de nuestros impresionantes barcos para conocer un estilo de vida a todo lujo. Disfruta de alojamiento deluxe, un servicio extraordinario y detalles especiales para los clientes de las suites, todo ello diseñado para agasajar a nuestros pasajeros. Magnifica la experiencia visitando nuestras zonas exclusivas para los pasajeros de las suites, las Suite Neighbourhoods a bordo del Icon of the Seas! Relájate con estilo contemplando el océano desde tu propia piscina privada y dale gusto a tu paladar en restaurantes de cinco estrellas únicos que te prometen delicias gastronómicas inolvidables.",

            skyClassTitle: "Sky Class",
            skyClassText:
                "Como huésped de la Sky Class tienes acceso a un Concierge, el conserje que diseñará y personalizará tus aventuras, hará las reservas en los restaurantes que tú selecciones y te recomendará dónde comer o hacer tus compras en tierra durante las escalas. Y tendrás acceso a la Suite Lounge, el espacio más elevado para disfrutar de tus manjares favoritos y tus bebidas preferidas.",
            seaClassTitle: "Sea Class",
            seaClassText:
                "Las suites de la Sea Class son lo mejor para recargar baterías después de cada aventura. Estas amplias suites ofrecen mucho espacio, están diseñadas con estilo y elegancia, y pensadas hasta el más mínimo detalle. Verás cómo esos pequeños toques extra son capaces de marcar la diferencia. Serás de los primeros en llegar a bordo gracias al embarque prioritario y podrás darte el gusto de cenar en el Coastal Kitchen, nuestro restaurante exclusivo para huéspedes de las suites.",
            starClassTitle: "Star Class",
            starClassText:
                "Exclusivo de Star Class, el Royal Genie es la mejor manera de convertir tus vacaciones en una experiencia VIP única y personalizada. Imagina tener tu propio mayordomo personal que se ocupa de todas tus necesidades; desde solicitudes previas al viaje hasta asegurar los mejores asientos en el restaurante o espectáculo. Tu Genie creará una experiencia exclusiva y única, hecha a medida para ti.",
            upscaleTitle: "Eleva el lujo a otra dimensión",
            upscaleText:
                "Descubre the Suite Neighbourhood a un paso de tu habitación. Un espacio exclusivo para los pasajeros de las suites con lujos a medida. Disfuta del sol en la cubierta de dos plantas o sumérgete en la piscina o el jacuzzi privados. Saborea una cocina de primer orden en dos restaurantes reservados para los clientes de las suites. Puedes elegir entre la elegancia informal del Coastal Kitchen or cenar al fresco respirando la gloria del Mediterráneo en The Grove.  En el bar de la Suite Lounge podrás degustar los mejores cócteles admirando vistas de ensueño en el centro del corazón del revolucionario AquaDome. Es el momento de descubrir lo dulce que puede llegar a ser la vida en la suite.",
            touchMagicTitle: "Añade un Toque <br /> de Magia",
            touchMagicText:
                "El genio Royal Genie, exclusivo para la Star Class, es la forma definitiva de convertir tus vacaciones en una experiencia VIP única y personalizada. Imagina tener tu propio mayordomo personal para ocuparse de todo lo que necesites antes incluso de embarcar. Te encontrará las mejores localidades en los espectáculos y la mejor mesa en el restaurante de tu elección. Tu genio creará una experiencia única y exclusiva, hecha a medida para ti.",
            headingTheSuiteLife: "LA VIDA EN SUITE",
            textEveryDetail: "CADA DETALLE CUENTA",
            textAmenitiesForYou: "SERVICIOS & DETALLES EXCLUSIVOS PARA TI",
            textInternetComplementary:
                "* El paquete de Internet de cortesía no está disponible para las Sky Junior Suites a bordo del Allure, Anthem, Harmony, Oasis, Odyssey, Ovation, Quantum, Symphony and Wonder of the Seas®. Esta prestación sí se incluye para las Sky Junior Suites a bordo del Icon, Spectrum and Utopia of the Seas®.",
            textBook: "RESERVAR",
            textNow: "AHORA",
            textCall: "Llamada",
            textEmail: "Correo electrónico",
        },
    },
    contact: {
        en: {
            textContactDescription:
                "Everyone deserves a holiday, but why not make it a one-of-a-kind, unforgettable adventure? To find out how we can help you book your next holiday, please contact:",
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
        },
        nordics: {
            textContactDescription:
                "Everyone deserves a holiday, but why not make it a one-of-a-kind, unforgettable adventure? To find out how we can help you book your next holiday, please contact:",
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
        },
        es: {
            textContactDescription:
                "Todo el mundo se merece unas vacaciones así que, ¿por qué no hacer de tus vacaciones una aventura única e inolvidable? Para ver cómo podemos ayudarte a reservar tus próximas vacaciones, puedes contactar:",
            textBook: "RESERVAR",
            textNow: "AHORA",
            textCall: "Llamar",
            textEmail: "Correo electrónico",
        },
    },
    itinerary: {
        en: {
            textNightCruise: "NIGHT CRUISE",
            buttonAboutTheShip: "About The Ship",
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
        },
        nordics: {
            textNightCruise: "NIGHT CRUISE",
            buttonAboutTheShip: "About The Ship",
            textBook: "BOOK",
            textNow: "NOW",
            textCall: "Call",
            textEmail: "Email",
        },
        es: {
            textNightCruise: "NOCHES DE CRUCERO",
            buttonAboutTheShip: "Acerca Del Barco",
            textBook: "RESERVAR",
            textNow: "AHORA",
            textCall: "Llamar",
            textEmail: "Correo electrónico",
        },
    },
    itineraryNavbar: {
        en: {
            Itinerary: "Itinerary",
            LeaveFrom: "Leave From",
            Destination: "Destination",
            Ship: "Ship",
            Days: "Days",
            Day: "Day",
            Seaday: "Seaday",
            CruiseEnd: "Cruise End",
        },
        nordics: {
            Itinerary: "Itinerary",
            LeaveFrom: "Leave From",
            Destination: "Destination",
            Ship: "Ship",
            Days: "Days",
            Day: "Day",
            Seaday: "Seaday",
            CruiseEnd: "Cruise End",
        },
        es: {
            Itinerary: "Itinerario",
            LeaveFrom: "Salida desde",
            Destination: "Puerto",
            Ship: "Barco",
            Days: "Días",
            Day: "Día",
            Seaday: "Día en el mar",
            CruiseEnd: "Fin del crucero",
        },
    },
    itineraryShip: {
        en: {
            headingYourShip: "YOUR SHIP",
            buttonDay: "Day",
            shipBulletThrills: "THRILLS",
            shipBulletEntertainment: "ENTERTAINMENT",
            shipBulletChills: "CHILLS",
            shipBulletRestaurant: "RESTAURANTS",
            shipBulletBars: "BARS",
            shipBulletStaterooms: "STATEROOMS",
            statisticLaunched: "LAUNCHED",
            statisticPassengers: "PASSENGERS",
            statisticDecks: "DECKS",
            statisticFeetLong: "FEET LONG",
            textStaterooms: "STATEROOMS",
        },
        nordics: {
            headingYourShip: "YOUR SHIP",
            buttonDay: "Day",
            shipBulletThrills: "THRILLS",
            shipBulletEntertainment: "ENTERTAINMENT",
            shipBulletChills: "CHILLS",
            shipBulletRestaurant: "RESTAURANTS",
            shipBulletBars: "BARS",
            shipBulletStaterooms: "STATEROOMS",
            statisticLaunched: "LAUNCHED",
            statisticPassengers: "PASSENGERS",
            statisticDecks: "DECKS",
            statisticFeetLong: "FEET LONG",
            textStaterooms: "STATEROOMS",
        },
        es: {
            headingYourShip: "TU BARCO",
            buttonDay: "Día",
            shipBulletThrills: "AVENTURAS",
            shipBulletEntertainment: "ESPECTÁCULOS",
            shipBulletChills: "RELAX",
            shipBulletRestaurant: "RESTAURANTES",
            shipBulletBars: "BARES",
            shipBulletStaterooms: "CAMAROTES",
            statisticLaunched: "INAUGURACIÓN ",
            statisticPassengers: "PASAJEROS",
            statisticDecks: "CUBIERTAS",
            statisticFeetLong: "LONGITUD",
            textStaterooms: "CAMAROTES",
        },
    },
    itineraryDay: {
        en: {
            textDays: "Days",
            textDay: "Day",
            textFromCentre: "FROM CENTRE",
            textInsiderTip: "INSIDER TIP",
        },
        nordics: {
            textDays: "Days",
            textDay: "Day",
            textFromCentre: "FROM CENTRE",
            textInsiderTip: "INSIDER TIP",
        },
        es: {
            textDays: "Días",
            textDay: "Día",
            textFromCentre: "DESDE EL CENTRO",
            textInsiderTip: "INFORMACIÓN PRIVILEGIADA",
        },
    },
    itinerarySeaDay: {
        en: {
            textDays: "Days",
            textDay: "Day",
            textInsiderTip: "INSIDER TIP",
            textComplimentaryRestaurant: (
                <>
                    COMPLIMENTARY <br />
                    RESTAURANTS
                </>
            ),
            textSpecialityRestaurant: (
                <>
                    SPECIALITY <br /> RESTAURANTS
                </>
            ),
        },
        nordics: {
            textDays: "Days",
            textDay: "Day",
            textInsiderTip: "INSIDER TIP",
            textComplimentaryRestaurant: (
                <>
                    COMPLIMENTARY <br />
                    RESTAURANTS
                </>
            ),
            textSpecialityRestaurant: (
                <>
                    SPECIALITY <br /> RESTAURANTS
                </>
            ),
        },
        es: {
            textDays: "Días",
            textDay: "Día",
            textInsiderTip: "INFORMACIÓN PRIVILEGIADA",
            textComplimentaryRestaurant: (
                <>
                    RESTAURANTES
                    <br />
                    GRATUITOS
                </>
            ),
            textSpecialityRestaurant: (
                <>
                    RESTAURANTES <br />
                    DE ESPECIALIDAD
                </>
            ),
        },
    },
    itineraryThingsToDo: {
        en: {
            textThingsToDo: "THINGS TO DO",
        },
        nordics: {
            textThingsToDo: "THINGS TO DO",
        },
        es: {
            textThingsToDo: "QUÉ HACER",
        },
    },
    itineraryBox: {
        en: {
            textDelete: "Delete",
            textReplace: "Replace",
            focusHoliday: "FOCUS HOLIDAY",
        },
        nordics: {
            textDelete: "Delete",
            textReplace: "Replace",
            focusHoliday: "FOCUS HOLIDAY",
        },
        es: {
            textDelete: "Borrar",
            textReplace: "Reemplazar",
            focusHoliday: "VACACIONES DESTACADAS",
        },
    },
    suitcaseCard: {
        en: {
            textLeaving: "Leaving",
            textDeparting: "Departing",
            textOnboard: "Onboard",
            textNight: "Night",
            textNights: "Nights",
        },
        nordics: {
            textLeaving: "Leaving",
            textDeparting: "Departing",
            textOnboard: "Onboard",
            textNight: "Night",
            textNights: "Nights",
        },
        es: {
            textLeaving: "Partida",
            textDeparting: "Partiendo",
            textOnboard: "De a bordo",
            textNight: "Noche",
            textNights: "Noches",
        },
    },
    getStartedLanding: {
        en: {
            textBuildANewHoliday: "BUILD A NEW HOLIDAY EXPERIENCE",
            textExperience: "EXPERIENCE",
            headingInspireMe: "NEED SOME INSPIRATION?",
            textInspireMe: (
                <>
                    Start from scratch to create the perfect selection of holiday{" "}
                    <br className="hidden ipad:block" />
                    itineraries for your customer.
                </>
            ),
            headingShip: "KNOW YOUR SHIP AND SAIL DATE?",
            textShip: (
                <>
                    Already know which Ship they want to cruise on? Take this simplified flow to get
                    you to those perfect holiday itineraries even faster.
                </>
            ),
            buttonClickHere1: "Inspire me",
            buttonClickHere2: "Take me there",
        },
        nordics: {
            textBuildANewHoliday: "BUILD A NEW HOLIDAY",
            textExperience: "EXPERIENCE",
            headingInspireMe: "INSPIRE ME",
            textInspireMe: (
                <>
                    Start from scratch to create the perfect selection of holiday{" "}
                    <br className="hidden ipad:block" />
                    itineraries for your customer.
                </>
            ),
            headingShip: "KNOW YOUR SHIP AND SAIL DATE?",
            textShip: (
                <>
                    Already know which Ship they want to cruise on? Take this simplified flow to get
                    you to those perfect holiday itineraries even faster.
                </>
            ),
            buttonClickHere1: "Inspire me",
            buttonClickHere2: "Take me there",
        },
        es: {
            textBuildANewHoliday: "PERSONALIZA",
            textExperience: "LAS VACACIONES",
            headingInspireMe: "¿NECESITAS IDEAS PARA LAS VACACIONES?",
            textInspireMe: (
                <>
                    Empieza desde el principio para personalizar el{" "}
                    <br className="hidden ipad:block" />
                    itinerario perfecto para tus clientes.
                </>
            ),
            headingShip: "¿YA TIENES FECHA Y BARCO EN MENTE?",
            textShip: (
                <>
                    ¿Ya saben en qué crucero quieren embarcar? Esta es la opción más rápida para
                    personalizar el crucero de tus clientes.
                </>
            ),
            buttonClickHere1: "Haz clic aquí",
            buttonClickHere2: "Haz clic aquí",
        },
    },
    getStarted: {
        en: {
            // buttonText: "Get Started",
            buttonText: "Create a new suitcase",
        },
        nordics: {
            buttonText: "Get Started",
        },
        es: {
            buttonText: "Empezar",
        },
    },
    agentEngagement: {
        en: {
            pageTitle: "Agent Engagement",
            tabClubLearn: "Learn",
            tabRoyalGenie: "My Royal Genie",
            tabUpperDeck: "Upper Deck",
            clubLearnTitle: "Club Learn",
            clubLearnSubtitle: "2026 focus modules",
            royalGuruTitle: "Royal Guru",
            myRoyalGuruTotals: "My Royal Guru Totals",
            certifiedAgents: "Certified Agents",
            storesWithRoyalGuru: "Stores with Royal Guru",
            ofTotalStores: "of total stores",
            storesWithoutRoyalGuru: "Stores without Royal Guru",
            totalModulesCompleted: "Total Modules Completed",
            allClubLearnModules: "All Club Learn modules",
            clubLearnModulesCompleted: "Club Learn Modules Completed",
            topStoreGurus: "Top Store Guru's",
            guruBasedRanking: "Royal Guru-Based Ranking",
            agentsSignedUp: "Agents\nSigned up",
            modulesCompleted: "Modules\nCompleted",
            gurus: "Royal Guru's",
            completed: "completed",
            target: "Target",
            yearToDateTotal: "Year to Date total",
            myRoyalGenie: "My Royal Genie",
            totalAgentsSignedUp: "Total Agents Signed Up",
            totalProposalsGenerated: "Total Proposals Generated",
            agentsSignedUpByMonth: "Agents Signed Up by Month",
            proposalsGeneratedByMonth: "Proposals Generated by Month",
            storeBreakdown: "Store Breakdown",
            genieUsageRanking: "Genie Usage Ranking",
            proposalsGenerated: "Proposals\nGenerated",
            conversions: "Conversions",
            productMix: "Product Mix",
            ofItinerariesSelectedInGenieProposals: "Of Itineraries Selected In Genie Proposals",
            topItinerariesSelectedInGenieProposals: "Top 10 Itineraries Selected in Genie Proposals",
            yoy: "YoY",
            vsLastMonth: "vs. last month",
            upperDeckTitle: "Upper Deck",
            totalBookingsRedeemed: "Total Bookings Redeemed",
            totalBookingsRedeemedByMonth: "Total Bookings Redeemed by Month",
            totalAgentsSignedUpPerMonth: "Total Agents Signed up Per Month",
            yearPartnerSignups: "Year Partner Signups",
            in2026: "In 2026",
        },
        nordics: {
            pageTitle: "Agent Engagement",
            tabClubLearn: "Club Learn",
            tabRoyalGenie: "Royal Genie",
            tabUpperDeck: "Upper Deck",
            clubLearnTitle: "Club Learn",
            clubLearnSubtitle: "2026 focus modules",
            royalGuruTitle: "Royal Guru",
            myRoyalGuruTotals: "My Royal Guru Totals",
            certifiedAgents: "Certified Agents",
            storesWithRoyalGuru: "Stores with Royal Guru",
            ofTotalStores: "of total stores",
            storesWithoutRoyalGuru: "Stores without Royal Guru",
            totalModulesCompleted: "Total Modules Completed",
            allClubLearnModules: "All Club Learn modules",
            clubLearnModulesCompleted: "Club Learn Modules Completed",
            topStoreGurus: "Top Store Guru's",
            guruBasedRanking: "Royal Guru-Based Ranking",
            agentsSignedUp: "Agents\nSigned up",
            modulesCompleted: "Modules\nCompleted",
            gurus: "Royal Guru's",
            completed: "completed",
            target: "Target",
            yearToDateTotal: "Year to Date total",
            myRoyalGenie: "My Royal Genie",
            totalAgentsSignedUp: "Total Agents Signed Up",
            totalProposalsGenerated: "Total Proposals Generated",
            agentsSignedUpByMonth: "Agents Signed Up by Month",
            proposalsGeneratedByMonth: "Proposals Generated by Month",
            storeBreakdown: "Store Breakdown",
            genieUsageRanking: "Genie Usage Ranking",
            proposalsGenerated: "Proposals\nGenerated",
            conversions: "Conversions",
            productMix: "Product Mix",
            ofItinerariesSelectedInGenieProposals: "Of Itineraries Selected In Genie Proposals",
            topItinerariesSelectedInGenieProposals: "Top 10 Itineraries Selected in Genie Proposals",
            yoy: "YoY",
            vsLastMonth: "vs. last month",
            upperDeckTitle: "Upper Deck",
            totalBookingsRedeemed: "Total Bookings Redeemed",
            totalBookingsRedeemedByMonth: "Total Bookings Redeemed by Month",
            totalAgentsSignedUpPerMonth: "Total Agents Signed up Per Month",
            yearPartnerSignups: "Year Partner Signups",
            in2026: "In 2026",
        },
        es: {
            pageTitle: "Agent Engagement es",
            tabClubLearn: "Club Learn es",
            tabRoyalGenie: "Royal Genie es",
            tabUpperDeck: "Upper Deck es",
            clubLearnTitle: "Club Learn es",
            clubLearnSubtitle: "2026 focus modules es",
            royalGuruTitle: "Royal Guru es",
            myRoyalGuruTotals: "My Royal Guru Totals es",
            certifiedAgents: "Certified Agents es",
            storesWithRoyalGuru: "Stores with Royal Guru es",
            ofTotalStores: "of total stores es",
            storesWithoutRoyalGuru: "Stores without Royal Guru es",
            totalModulesCompleted: "Total Modules Completed es",
            allClubLearnModules: "All Club Learn modules es",
            clubLearnModulesCompleted: "Club Learn Modules Completed es",
            topStoreGurus: "Top Store Guru's es",
            guruBasedRanking: "Royal Guru-Based Ranking es",
            agentsSignedUp: "Agents\nSigned up es",
            modulesCompleted: "Modules\nCompleted es",
            gurus: "Royal Guru's es",
            completed: "completed es",
            target: "Target es",
            yearToDateTotal: "Year to Date total es",
            myRoyalGenie: "My Royal Genie es",
            totalAgentsSignedUp: "Total Agents Signed Up es",
            totalProposalsGenerated: "Total Proposals Generated es",
            agentsSignedUpByMonth: "Agents Signed Up by Month es",
            proposalsGeneratedByMonth: "Proposals Generated by Month es",
            storeBreakdown: "Store Breakdown es",
            genieUsageRanking: "Genie Usage Ranking es",
            proposalsGenerated: "Proposals\nGenerated es",
            conversions: "Conversions es",
            productMix: "Product Mix es",
            ofItinerariesSelectedInGenieProposals: "Of Itineraries Selected In Genie Proposals es",
            topItinerariesSelectedInGenieProposals: "Top 10 Itineraries Selected in Genie Proposals es",
            yoy: "YoY es",
            vsLastMonth: "vs. last month es",
            upperDeckTitle: "Upper Deck es",
            totalBookingsRedeemed: "Total Bookings Redeemed es",
            totalBookingsRedeemedByMonth: "Total Bookings Redeemed by Month es",
            totalAgentsSignedUpPerMonth: "Total Agents Signed up Per Month es",
            yearPartnerSignups: "Year Partner Signups es",
            in2026: "In 2026 es",
        },
    },
    storeVisitSummary: {
        en: {
            pageTitle: "Your Store Visit Summary",
            sectionStoreDetails: "Store Details",
            storeName: "Store Name",
            location: "Location",
            date: "Date",
            sectionAttendees: "Attendees",
            storeAgent: "Store Agent",
            sectionMeetingSummary: "Meeting Summary",
            meetingSummary: "Meeting Summary",
            sectionNextSteps: "Next Steps",
            nextSteps: "Next Steps",
            focusAreas: "Focus Areas",
            copyButton: "COPY LINK TO SUMMARY",
            linkCopied: "Link copied!",
            notFound: "Visit summary not found.",
            genieTarget: "Increase Genie Usage to a target of {target}",
            bookingsTarget: "Drive more passengers to a target of {target}",
            upperDeckTarget: "Increase upper deck to a target of {target}",
        },
        es: {
            pageTitle: "Resumen de la visita",
            sectionStoreDetails: "Detalles de la Tienda",
            storeName: "Nombre de la Tienda",
            location: "Ubicación",
            date: "Fecha",
            sectionAttendees: "Asistentes",
            storeAgent: "Gerente de tienda",
            sectionMeetingSummary: "Resumen de la Reunión",
            meetingSummary: "Resumen de la Reunión",
            sectionNextSteps: "Próximos Pasos",
            nextSteps: "Próximos Pasos",
            focusAreas: "Áreas de Enfoque",
            copyButton: "COPIAR ENLACE AL RESUMEN",
            linkCopied: "¡Enlace copiado!",
            notFound: "Resumen de visita no encontrado.",
            genieTarget: "Aumentar el uso de Genie a un objetivo de {target}",
            bookingsTarget: "Incrementar los pasajeros a un objetivo de {target}",
            upperDeckTarget: "Aumentar la cubierta superior a un objetivo de {target}",
        },
    },
    // NOTE: Spanish (es) copy below is placeholder pending the final translation pack
    // supplied by Royal Caribbean via the 2Viz language pack template. Structure mirrors
    // storeVisitSummary to keep the Store Visit and KAM Visit packs aligned.
    kamVisitSummary: {
        en: {
            pageTitle: "Your Visit Summary",
            sectionAccountDetails: "Account Details",
            name: "Name",
            address: "Address",
            date: "Date",
            sectionVisitDetails: "Visit Details",
            visitName: "Visit Name",
            visitType: "Visit Type",
            sectionAttendees: "Attendees",
            storeManager: "Store Manager",
            sectionPriorities: "Priorities",
            tradePartnerPriorities: "Trade Partner Priorities",
            whatsGoingWell: "What's going well?",
            whatsGettingInTheWay: "What's Getting in the Way",
            sectionNextSteps: "Next Steps",
            nextPriorities: "Next Priorities",
            committingTo: "What are you Committing to?",
            royalsActions: "Royal's Actions",
            anyOtherBusiness: "Any Other Business",
            sendViaEmail: "Send via Email",
            copyButton: "COPY LINK TO SUMMARY",
            linkCopied: "Link copied!",
            notFound: "Visit summary not found.",
            emptyValue: "—",
        },
        es: {
            pageTitle: "Resumen de tu visita",
            sectionAccountDetails: "Detalles de la cuenta",
            name: "Nombre",
            address: "Dirección",
            date: "Fecha",
            sectionVisitDetails: "Detalles de la visita",
            visitName: "Nombre de la visita",
            visitType: "Tipo de visita",
            sectionAttendees: "Asistentes",
            storeManager: "Gerente de tienda",
            sectionPriorities: "Prioridades",
            tradePartnerPriorities: "Prioridades del socio comercial",
            whatsGoingWell: "¿Qué va bien?",
            whatsGettingInTheWay: "¿Qué lo está obstaculizando?",
            sectionNextSteps: "Próximos pasos",
            nextPriorities: "Próximas prioridades",
            committingTo: "¿A qué te comprometes?",
            royalsActions: "Acciones de Royal",
            anyOtherBusiness: "Otros asuntos",
            sendViaEmail: "Enviar por correo",
            copyButton: "COPIAR ENLACE AL RESUMEN",
            linkCopied: "¡Enlace copiado!",
            notFound: "Resumen de visita no encontrado.",
            emptyValue: "—",
        },
    },
    accessDenied: {
        en: {
            title: "Access Denied",
            text: "You do not have access to {platform}.",
            goToPlatform: "Go to {platform}",
            goHome: "Go Home",
        },
        es: {
            title: "Acceso Denegado",
            text: "No tienes acceso a {platform}.",
            goToPlatform: "Ir a {platform}",
            goHome: "Ir al Inicio",
        },
    },
};

export default translationResources;
